export const sm1_10_linux = ['addons/metamod/sourcemod.vdf',
'addons/sourcemod/bin/sourcemod.2.bms.so',
'addons/sourcemod/bin/sourcemod.2.csgo.so',
'addons/sourcemod/bin/sourcemod.2.css.so',
'addons/sourcemod/bin/sourcemod.2.dods.so',
'addons/sourcemod/bin/sourcemod.2.doi.so',
'addons/sourcemod/bin/sourcemod.2.ep1.so',
'addons/sourcemod/bin/sourcemod.2.ep2.so',
'addons/sourcemod/bin/sourcemod.2.hl2dm.so',
'addons/sourcemod/bin/sourcemod.2.insurgency.so',
'addons/sourcemod/bin/sourcemod.2.l4d.so',
'addons/sourcemod/bin/sourcemod.2.l4d2.so',
'addons/sourcemod/bin/sourcemod.2.nd.so',
'addons/sourcemod/bin/sourcemod.2.sdk2013.so',
'addons/sourcemod/bin/sourcemod.2.tf2.so',
'addons/sourcemod/bin/sourcemod.logic.so',
'addons/sourcemod/bin/sourcemod_mm.x64.so',
'addons/sourcemod/bin/sourcemod_mm_i486.so',
'addons/sourcemod/bin/sourcepawn.jit.x86.so',
'addons/sourcemod/bin/x64/sourcemod.2.csgo.so',
'addons/sourcemod/bin/x64/sourcemod.logic.so',
'addons/sourcemod/bin/x64/sourcepawn.jit.x86.so',
'addons/sourcemod/configs/adminmenu_cfgs.txt',
'addons/sourcemod/configs/adminmenu_custom.txt',
'addons/sourcemod/configs/adminmenu_grouping.txt',
'addons/sourcemod/configs/adminmenu_sorting.txt',
'addons/sourcemod/configs/admins.cfg',
'addons/sourcemod/configs/admins_simple.ini',
'addons/sourcemod/configs/admin_groups.cfg',
'addons/sourcemod/configs/admin_levels.cfg',
'addons/sourcemod/configs/admin_overrides.cfg',
'addons/sourcemod/configs/banreasons.txt',
'addons/sourcemod/configs/core.cfg',
'addons/sourcemod/configs/databases.cfg',
'addons/sourcemod/configs/geoip/GeoIP.dat',
'addons/sourcemod/configs/languages.cfg',
'addons/sourcemod/configs/maplists.cfg',
'addons/sourcemod/configs/sql-init-scripts/mysql/clientprefs-mysql.sql',
'addons/sourcemod/configs/sql-init-scripts/mysql/create_admins.sql',
'addons/sourcemod/configs/sql-init-scripts/mysql/update_admins_r1409.sql',
'addons/sourcemod/configs/sql-init-scripts/sqlite/admins-sqlite.sq3',
'addons/sourcemod/configs/sql-init-scripts/sqlite/clientprefs-sqlite.sq3',
'addons/sourcemod/configs/sql-init-scripts/sqlite/clientprefs-sqlite.sql',
'addons/sourcemod/configs/sql-init-scripts/sqlite/create_admins.sql',
'addons/sourcemod/configs/sql-init-scripts/sqlite/update_admins-r1409.sql',
'addons/sourcemod/extensions/bintools.ext.so',
'addons/sourcemod/extensions/clientprefs.ext.so',
'addons/sourcemod/extensions/dbi.mysql.ext.so',
'addons/sourcemod/extensions/dbi.sqlite.ext.so',
'addons/sourcemod/extensions/game.cstrike.ext.2.csgo.so',
'addons/sourcemod/extensions/game.cstrike.ext.2.css.so',
'addons/sourcemod/extensions/game.tf2.ext.2.tf2.so',
'addons/sourcemod/extensions/geoip.ext.so',
'addons/sourcemod/extensions/regex.ext.so',
'addons/sourcemod/extensions/sdkhooks.ext.2.bms.so',
'addons/sourcemod/extensions/sdkhooks.ext.2.csgo.so',
'addons/sourcemod/extensions/sdkhooks.ext.2.css.so',
'addons/sourcemod/extensions/sdkhooks.ext.2.dods.so',
'addons/sourcemod/extensions/sdkhooks.ext.2.doi.so',
'addons/sourcemod/extensions/sdkhooks.ext.2.ep1.so',
'addons/sourcemod/extensions/sdkhooks.ext.2.ep2.so',
'addons/sourcemod/extensions/sdkhooks.ext.2.hl2dm.so',
'addons/sourcemod/extensions/sdkhooks.ext.2.insurgency.so',
'addons/sourcemod/extensions/sdkhooks.ext.2.l4d.so',
'addons/sourcemod/extensions/sdkhooks.ext.2.l4d2.so',
'addons/sourcemod/extensions/sdkhooks.ext.2.nd.so',
'addons/sourcemod/extensions/sdkhooks.ext.2.sdk2013.so',
'addons/sourcemod/extensions/sdkhooks.ext.2.tf2.so',
'addons/sourcemod/extensions/sdktools.ext.2.bms.so',
'addons/sourcemod/extensions/sdktools.ext.2.csgo.so',
'addons/sourcemod/extensions/sdktools.ext.2.css.so',
'addons/sourcemod/extensions/sdktools.ext.2.dods.so',
'addons/sourcemod/extensions/sdktools.ext.2.doi.so',
'addons/sourcemod/extensions/sdktools.ext.2.ep1.so',
'addons/sourcemod/extensions/sdktools.ext.2.ep2.so',
'addons/sourcemod/extensions/sdktools.ext.2.hl2dm.so',
'addons/sourcemod/extensions/sdktools.ext.2.insurgency.so',
'addons/sourcemod/extensions/sdktools.ext.2.l4d.so',
'addons/sourcemod/extensions/sdktools.ext.2.l4d2.so',
'addons/sourcemod/extensions/sdktools.ext.2.nd.so',
'addons/sourcemod/extensions/sdktools.ext.2.sdk2013.so',
'addons/sourcemod/extensions/sdktools.ext.2.tf2.so',
'addons/sourcemod/extensions/topmenus.ext.so',
'addons/sourcemod/extensions/updater.ext.so',
'addons/sourcemod/extensions/webternet.ext.so',
'addons/sourcemod/extensions/x64/bintools.ext.so',
'addons/sourcemod/extensions/x64/clientprefs.ext.so',
'addons/sourcemod/extensions/x64/dbi.mysql.ext.so',
'addons/sourcemod/extensions/x64/dbi.sqlite.ext.so',
'addons/sourcemod/extensions/x64/game.cstrike.ext.2.csgo.so',
'addons/sourcemod/extensions/x64/geoip.ext.so',
'addons/sourcemod/extensions/x64/regex.ext.so',
'addons/sourcemod/extensions/x64/sdkhooks.ext.2.csgo.so',
'addons/sourcemod/extensions/x64/sdktools.ext.2.csgo.so',
'addons/sourcemod/extensions/x64/topmenus.ext.so',
'addons/sourcemod/extensions/x64/updater.ext.so',
'addons/sourcemod/extensions/x64/webternet.ext.so',
'addons/sourcemod/gamedata/core.games/blacklist.plugins.txt',
'addons/sourcemod/gamedata/core.games/common.games.txt',
'addons/sourcemod/gamedata/core.games/engine.bgt.txt',
'addons/sourcemod/gamedata/core.games/engine.blade.txt',
'addons/sourcemod/gamedata/core.games/engine.bms.txt',
'addons/sourcemod/gamedata/core.games/engine.contagion.txt',
'addons/sourcemod/gamedata/core.games/engine.csgo.txt',
'addons/sourcemod/gamedata/core.games/engine.css.txt',
'addons/sourcemod/gamedata/core.games/engine.darkm.txt',
'addons/sourcemod/gamedata/core.games/engine.ep1.txt',
'addons/sourcemod/gamedata/core.games/engine.ep2.txt',
'addons/sourcemod/gamedata/core.games/engine.ep2valve.txt',
'addons/sourcemod/gamedata/core.games/engine.eye.txt',
'addons/sourcemod/gamedata/core.games/engine.insurgency.txt',
'addons/sourcemod/gamedata/core.games/engine.l4d.txt',
'addons/sourcemod/gamedata/core.games/engine.l4d2.txt',
'addons/sourcemod/gamedata/core.games/engine.sdk2013.txt',
'addons/sourcemod/gamedata/core.games/engine.swarm.txt',
'addons/sourcemod/gamedata/core.games/game.dinodday.txt',
'addons/sourcemod/gamedata/core.games/master.games.txt',
'addons/sourcemod/gamedata/funcommands.games.txt',
'addons/sourcemod/gamedata/sdkhooks.games/common.games.txt',
'addons/sourcemod/gamedata/sdkhooks.games/engine.blade.txt',
'addons/sourcemod/gamedata/sdkhooks.games/engine.contagion.txt',
'addons/sourcemod/gamedata/sdkhooks.games/engine.csgo.txt',
'addons/sourcemod/gamedata/sdkhooks.games/engine.darkm.txt',
'addons/sourcemod/gamedata/sdkhooks.games/engine.ep2v.txt',
'addons/sourcemod/gamedata/sdkhooks.games/engine.insurgency.txt',
'addons/sourcemod/gamedata/sdkhooks.games/engine.l4d.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.ag2.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.alienswarm.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.aoc.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.bms.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.cspromod.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.cstrike.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.dinodday.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.doi.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.empires.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.ff.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.fof.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.gesource.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.hidden.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.hl2ctf.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.insurgency.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.kz.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.l4d2.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.modularcombat.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.neotokyo.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.nmrih.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.nucleardawn.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.pvkii.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.reactivedrop.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.sgtls.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.sourceforts.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.synergy.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.zm.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.zpanic.txt',
'addons/sourcemod/gamedata/sdkhooks.games/master.games.txt',
'addons/sourcemod/gamedata/sdktools.games/common.games.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.bgt.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.blade.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.contagion.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.csgo.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.css.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.darkm.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.ep1.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.ep2.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.ep2valve.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.eye.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.insurgency.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.l4d.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.l4d2.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.sdk2013.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.swarm.txt',
'addons/sourcemod/gamedata/sdktools.games/game.ag2.txt',
'addons/sourcemod/gamedata/sdktools.games/game.alienswarm.txt',
'addons/sourcemod/gamedata/sdktools.games/game.aoc.txt',
'addons/sourcemod/gamedata/sdktools.games/game.bg2.txt',
'addons/sourcemod/gamedata/sdktools.games/game.bms.txt',
'addons/sourcemod/gamedata/sdktools.games/game.cspromod.txt',
'addons/sourcemod/gamedata/sdktools.games/game.cstrike.txt',
'addons/sourcemod/gamedata/sdktools.games/game.dinodday.txt',
'addons/sourcemod/gamedata/sdktools.games/game.dod.txt',
'addons/sourcemod/gamedata/sdktools.games/game.doi.txt',
'addons/sourcemod/gamedata/sdktools.games/game.dystopia.txt',
'addons/sourcemod/gamedata/sdktools.games/game.empires.txt',
'addons/sourcemod/gamedata/sdktools.games/game.esmod.txt',
'addons/sourcemod/gamedata/sdktools.games/game.fas.txt',
'addons/sourcemod/gamedata/sdktools.games/game.ff.txt',
'addons/sourcemod/gamedata/sdktools.games/game.fof.txt',
'addons/sourcemod/gamedata/sdktools.games/game.gesource.txt',
'addons/sourcemod/gamedata/sdktools.games/game.hidden.txt',
'addons/sourcemod/gamedata/sdktools.games/game.hl2ctf.txt',
'addons/sourcemod/gamedata/sdktools.games/game.hl2mp.txt',
'addons/sourcemod/gamedata/sdktools.games/game.insurgency.txt',
'addons/sourcemod/gamedata/sdktools.games/game.ios.txt',
'addons/sourcemod/gamedata/sdktools.games/game.kz.txt',
'addons/sourcemod/gamedata/sdktools.games/game.left4dead2.txt',
'addons/sourcemod/gamedata/sdktools.games/game.modularcombat.txt',
'addons/sourcemod/gamedata/sdktools.games/game.neotokyo.txt',
'addons/sourcemod/gamedata/sdktools.games/game.nmrih.txt',
'addons/sourcemod/gamedata/sdktools.games/game.nucleardawn.txt',
'addons/sourcemod/gamedata/sdktools.games/game.obsidian.txt',
'addons/sourcemod/gamedata/sdktools.games/game.pvkii.txt',
'addons/sourcemod/gamedata/sdktools.games/game.reactivedrop.txt',
'addons/sourcemod/gamedata/sdktools.games/game.rnlbeta.txt',
'addons/sourcemod/gamedata/sdktools.games/game.ship.txt',
'addons/sourcemod/gamedata/sdktools.games/game.sourceforts.txt',
'addons/sourcemod/gamedata/sdktools.games/game.synergy.txt',
'addons/sourcemod/gamedata/sdktools.games/game.tf.txt',
'addons/sourcemod/gamedata/sdktools.games/game.zm.txt',
'addons/sourcemod/gamedata/sdktools.games/game.zpanic.txt',
'addons/sourcemod/gamedata/sdktools.games/master.games.txt',
'addons/sourcemod/gamedata/sm-cstrike.games/game.csgo.txt',
'addons/sourcemod/gamedata/sm-cstrike.games/game.css.txt',
'addons/sourcemod/gamedata/sm-cstrike.games/master.games.txt',
'addons/sourcemod/gamedata/sm-tf2.games.txt',
'addons/sourcemod/GPLv2.txt',
'addons/sourcemod/GPLv3.txt',
'addons/sourcemod/LICENSE.txt',
'addons/sourcemod/plugins/admin-flatfile.smx',
'addons/sourcemod/plugins/adminhelp.smx',
'addons/sourcemod/plugins/adminmenu.smx',
'addons/sourcemod/plugins/antiflood.smx',
'addons/sourcemod/plugins/basebans.smx',
'addons/sourcemod/plugins/basechat.smx',
'addons/sourcemod/plugins/basecomm.smx',
'addons/sourcemod/plugins/basecommands.smx',
'addons/sourcemod/plugins/basetriggers.smx',
'addons/sourcemod/plugins/basevotes.smx',
'addons/sourcemod/plugins/clientprefs.smx',
'addons/sourcemod/plugins/disabled/admin-sql-prefetch.smx',
'addons/sourcemod/plugins/disabled/admin-sql-threaded.smx',
'addons/sourcemod/plugins/disabled/mapchooser.smx',
'addons/sourcemod/plugins/disabled/nominations.smx',
'addons/sourcemod/plugins/disabled/randomcycle.smx',
'addons/sourcemod/plugins/disabled/rockthevote.smx',
'addons/sourcemod/plugins/disabled/sql-admin-manager.smx',
'addons/sourcemod/plugins/funcommands.smx',
'addons/sourcemod/plugins/funvotes.smx',
'addons/sourcemod/plugins/nextmap.smx',
'addons/sourcemod/plugins/playercommands.smx',
'addons/sourcemod/plugins/reservedslots.smx',
'addons/sourcemod/plugins/sounds.smx',
'addons/sourcemod/scripting/admin-flatfile/admin-flatfile.sp',
'addons/sourcemod/scripting/admin-flatfile/admin-groups.sp',
'addons/sourcemod/scripting/admin-flatfile/admin-overrides.sp',
'addons/sourcemod/scripting/admin-flatfile/admin-simple.sp',
'addons/sourcemod/scripting/admin-flatfile/admin-users.sp',
'addons/sourcemod/scripting/admin-sql-prefetch.sp',
'addons/sourcemod/scripting/admin-sql-threaded.sp',
'addons/sourcemod/scripting/adminhelp.sp',
'addons/sourcemod/scripting/adminmenu.sp',
'addons/sourcemod/scripting/adminmenu/dynamicmenu.sp',
'addons/sourcemod/scripting/antiflood.sp',
'addons/sourcemod/scripting/basebans.sp',
'addons/sourcemod/scripting/basebans/ban.sp',
'addons/sourcemod/scripting/basechat.sp',
'addons/sourcemod/scripting/basecomm.sp',
'addons/sourcemod/scripting/basecommands.sp',
'addons/sourcemod/scripting/basecommands/cancelvote.sp',
'addons/sourcemod/scripting/basecommands/execcfg.sp',
'addons/sourcemod/scripting/basecommands/kick.sp',
'addons/sourcemod/scripting/basecommands/map.sp',
'addons/sourcemod/scripting/basecommands/reloadadmins.sp',
'addons/sourcemod/scripting/basecommands/who.sp',
'addons/sourcemod/scripting/basecomm/forwards.sp',
'addons/sourcemod/scripting/basecomm/gag.sp',
'addons/sourcemod/scripting/basecomm/natives.sp',
'addons/sourcemod/scripting/basetriggers.sp',
'addons/sourcemod/scripting/basevotes.sp',
'addons/sourcemod/scripting/basevotes/voteban.sp',
'addons/sourcemod/scripting/basevotes/votekick.sp',
'addons/sourcemod/scripting/basevotes/votemap.sp',
'addons/sourcemod/scripting/clientprefs.sp',
'addons/sourcemod/scripting/compile.sh',
'addons/sourcemod/scripting/funcommands.sp',
'addons/sourcemod/scripting/funcommands/beacon.sp',
'addons/sourcemod/scripting/funcommands/blind.sp',
'addons/sourcemod/scripting/funcommands/drug.sp',
'addons/sourcemod/scripting/funcommands/fire.sp',
'addons/sourcemod/scripting/funcommands/gravity.sp',
'addons/sourcemod/scripting/funcommands/ice.sp',
'addons/sourcemod/scripting/funcommands/noclip.sp',
'addons/sourcemod/scripting/funcommands/timebomb.sp',
'addons/sourcemod/scripting/funvotes.sp',
'addons/sourcemod/scripting/funvotes/votealltalk.sp',
'addons/sourcemod/scripting/funvotes/voteburn.sp',
'addons/sourcemod/scripting/funvotes/voteff.sp',
'addons/sourcemod/scripting/funvotes/votegravity.sp',
'addons/sourcemod/scripting/funvotes/voteslay.sp',
'addons/sourcemod/scripting/include/admin.inc',
'addons/sourcemod/scripting/include/adminmenu.inc',
'addons/sourcemod/scripting/include/adt.inc',
'addons/sourcemod/scripting/include/adt_array.inc',
'addons/sourcemod/scripting/include/adt_stack.inc',
'addons/sourcemod/scripting/include/adt_trie.inc',
'addons/sourcemod/scripting/include/banning.inc',
'addons/sourcemod/scripting/include/basecomm.inc',
'addons/sourcemod/scripting/include/bitbuffer.inc',
'addons/sourcemod/scripting/include/clientprefs.inc',
'addons/sourcemod/scripting/include/clients.inc',
'addons/sourcemod/scripting/include/commandfilters.inc',
'addons/sourcemod/scripting/include/commandline.inc',
'addons/sourcemod/scripting/include/console.inc',
'addons/sourcemod/scripting/include/convars.inc',
'addons/sourcemod/scripting/include/core.inc',
'addons/sourcemod/scripting/include/cstrike.inc',
'addons/sourcemod/scripting/include/datapack.inc',
'addons/sourcemod/scripting/include/dbi.inc',
'addons/sourcemod/scripting/include/entity.inc',
'addons/sourcemod/scripting/include/entity_prop_stocks.inc',
'addons/sourcemod/scripting/include/events.inc',
'addons/sourcemod/scripting/include/files.inc',
'addons/sourcemod/scripting/include/float.inc',
'addons/sourcemod/scripting/include/functions.inc',
'addons/sourcemod/scripting/include/geoip.inc',
'addons/sourcemod/scripting/include/halflife.inc',
'addons/sourcemod/scripting/include/handles.inc',
'addons/sourcemod/scripting/include/helpers.inc',
'addons/sourcemod/scripting/include/keyvalues.inc',
'addons/sourcemod/scripting/include/lang.inc',
'addons/sourcemod/scripting/include/logging.inc',
'addons/sourcemod/scripting/include/mapchooser.inc',
'addons/sourcemod/scripting/include/menus.inc',
'addons/sourcemod/scripting/include/nextmap.inc',
'addons/sourcemod/scripting/include/profiler.inc',
'addons/sourcemod/scripting/include/protobuf.inc',
'addons/sourcemod/scripting/include/regex.inc',
'addons/sourcemod/scripting/include/sdkhooks.inc',
'addons/sourcemod/scripting/include/sdktools.inc',
'addons/sourcemod/scripting/include/sdktools_client.inc',
'addons/sourcemod/scripting/include/sdktools_engine.inc',
'addons/sourcemod/scripting/include/sdktools_entinput.inc',
'addons/sourcemod/scripting/include/sdktools_entoutput.inc',
'addons/sourcemod/scripting/include/sdktools_functions.inc',
'addons/sourcemod/scripting/include/sdktools_gamerules.inc',
'addons/sourcemod/scripting/include/sdktools_hooks.inc',
'addons/sourcemod/scripting/include/sdktools_sound.inc',
'addons/sourcemod/scripting/include/sdktools_stocks.inc',
'addons/sourcemod/scripting/include/sdktools_stringtables.inc',
'addons/sourcemod/scripting/include/sdktools_tempents.inc',
'addons/sourcemod/scripting/include/sdktools_tempents_stocks.inc',
'addons/sourcemod/scripting/include/sdktools_trace.inc',
'addons/sourcemod/scripting/include/sdktools_variant_t.inc',
'addons/sourcemod/scripting/include/sdktools_voice.inc',
'addons/sourcemod/scripting/include/sorting.inc',
'addons/sourcemod/scripting/include/sourcemod.inc',
'addons/sourcemod/scripting/include/string.inc',
'addons/sourcemod/scripting/include/testing.inc',
'addons/sourcemod/scripting/include/textparse.inc',
'addons/sourcemod/scripting/include/tf2.inc',
'addons/sourcemod/scripting/include/tf2_stocks.inc',
'addons/sourcemod/scripting/include/timers.inc',
'addons/sourcemod/scripting/include/topmenus.inc',
'addons/sourcemod/scripting/include/usermessages.inc',
'addons/sourcemod/scripting/include/vector.inc',
'addons/sourcemod/scripting/include/version.inc',
'addons/sourcemod/scripting/include/version_auto.inc',
'addons/sourcemod/scripting/mapchooser.sp',
'addons/sourcemod/scripting/nextmap.sp',
'addons/sourcemod/scripting/nominations.sp',
'addons/sourcemod/scripting/playercommands.sp',
'addons/sourcemod/scripting/playercommands/rename.sp',
'addons/sourcemod/scripting/playercommands/slap.sp',
'addons/sourcemod/scripting/playercommands/slay.sp',
'addons/sourcemod/scripting/randomcycle.sp',
'addons/sourcemod/scripting/reservedslots.sp',
'addons/sourcemod/scripting/rockthevote.sp',
'addons/sourcemod/scripting/sounds.sp',
'addons/sourcemod/scripting/spcomp',
'addons/sourcemod/scripting/spcomp64',
'addons/sourcemod/scripting/sql-admin-manager.sp',
'addons/sourcemod/scripting/testsuite/benchmark.sp',
'addons/sourcemod/scripting/testsuite/bug4059.sp',
'addons/sourcemod/scripting/testsuite/callfunctest.sp',
'addons/sourcemod/scripting/testsuite/capstest.sp',
'addons/sourcemod/scripting/testsuite/clientprefstest.sp',
'addons/sourcemod/scripting/testsuite/cstrike-test.sp',
'addons/sourcemod/scripting/testsuite/entpropelements.sp',
'addons/sourcemod/scripting/testsuite/fakenative1.sp',
'addons/sourcemod/scripting/testsuite/fakenative2.sp',
'addons/sourcemod/scripting/testsuite/filetest.sp',
'addons/sourcemod/scripting/testsuite/fwdtest1.sp',
'addons/sourcemod/scripting/testsuite/fwdtest2.sp',
'addons/sourcemod/scripting/testsuite/gamerules-props.sp',
'addons/sourcemod/scripting/testsuite/goto_test.sp',
'addons/sourcemod/scripting/testsuite/keyvalues.sp',
'addons/sourcemod/scripting/testsuite/outputtest.sp',
'addons/sourcemod/scripting/testsuite/ptstest.sp',
'addons/sourcemod/scripting/testsuite/sorttest.sp',
'addons/sourcemod/scripting/testsuite/sqltest.sp',
'addons/sourcemod/scripting/testsuite/sqltest.sql',
'addons/sourcemod/scripting/testsuite/stacktest.sp',
'addons/sourcemod/scripting/testsuite/structtest.sp',
'addons/sourcemod/scripting/testsuite/tf2-test.sp',
'addons/sourcemod/scripting/testsuite/tries.sp',
'addons/sourcemod/translations/adminhelp.phrases.txt',
'addons/sourcemod/translations/adminmenu.phrases.txt',
'addons/sourcemod/translations/antiflood.phrases.txt',
'addons/sourcemod/translations/ar/adminhelp.phrases.txt',
'addons/sourcemod/translations/ar/adminmenu.phrases.txt',
'addons/sourcemod/translations/ar/antiflood.phrases.txt',
'addons/sourcemod/translations/ar/basebans.phrases.txt',
'addons/sourcemod/translations/ar/basecomm.phrases.txt',
'addons/sourcemod/translations/ar/basetriggers.phrases.txt',
'addons/sourcemod/translations/ar/basevotes.phrases.txt',
'addons/sourcemod/translations/ar/clientprefs.phrases.txt',
'addons/sourcemod/translations/ar/common.phrases.txt',
'addons/sourcemod/translations/ar/core.phrases.txt',
'addons/sourcemod/translations/ar/funcommands.phrases.txt',
'addons/sourcemod/translations/ar/funvotes.phrases.txt',
'addons/sourcemod/translations/ar/mapchooser.phrases.txt',
'addons/sourcemod/translations/ar/nextmap.phrases.txt',
'addons/sourcemod/translations/ar/nominations.phrases.txt',
'addons/sourcemod/translations/ar/playercommands.phrases.txt',
'addons/sourcemod/translations/ar/plugin.basecommands.txt',
'addons/sourcemod/translations/ar/reservedslots.phrases.txt',
'addons/sourcemod/translations/ar/rockthevote.phrases.txt',
'addons/sourcemod/translations/ar/sounds.phrases.txt',
'addons/sourcemod/translations/ar/sqladmins.phrases.txt',
'addons/sourcemod/translations/basebans.phrases.txt',
'addons/sourcemod/translations/basecomm.phrases.txt',
'addons/sourcemod/translations/basetriggers.phrases.txt',
'addons/sourcemod/translations/basevotes.phrases.txt',
'addons/sourcemod/translations/bg/adminhelp.phrases.txt',
'addons/sourcemod/translations/bg/adminmenu.phrases.txt',
'addons/sourcemod/translations/bg/antiflood.phrases.txt',
'addons/sourcemod/translations/bg/basebans.phrases.txt',
'addons/sourcemod/translations/bg/basecomm.phrases.txt',
'addons/sourcemod/translations/bg/basetriggers.phrases.txt',
'addons/sourcemod/translations/bg/basevotes.phrases.txt',
'addons/sourcemod/translations/bg/clientprefs.phrases.txt',
'addons/sourcemod/translations/bg/common.phrases.txt',
'addons/sourcemod/translations/bg/core.phrases.txt',
'addons/sourcemod/translations/bg/funcommands.phrases.txt',
'addons/sourcemod/translations/bg/funvotes.phrases.txt',
'addons/sourcemod/translations/bg/mapchooser.phrases.txt',
'addons/sourcemod/translations/bg/nextmap.phrases.txt',
'addons/sourcemod/translations/bg/nominations.phrases.txt',
'addons/sourcemod/translations/bg/playercommands.phrases.txt',
'addons/sourcemod/translations/bg/plugin.basecommands.txt',
'addons/sourcemod/translations/bg/reservedslots.phrases.txt',
'addons/sourcemod/translations/bg/rockthevote.phrases.txt',
'addons/sourcemod/translations/bg/sounds.phrases.txt',
'addons/sourcemod/translations/bg/sqladmins.phrases.txt',
'addons/sourcemod/translations/chi/adminhelp.phrases.txt',
'addons/sourcemod/translations/chi/adminmenu.phrases.txt',
'addons/sourcemod/translations/chi/antiflood.phrases.txt',
'addons/sourcemod/translations/chi/basebans.phrases.txt',
'addons/sourcemod/translations/chi/basecomm.phrases.txt',
'addons/sourcemod/translations/chi/basetriggers.phrases.txt',
'addons/sourcemod/translations/chi/basevotes.phrases.txt',
'addons/sourcemod/translations/chi/clientprefs.phrases.txt',
'addons/sourcemod/translations/chi/common.phrases.txt',
'addons/sourcemod/translations/chi/core.phrases.txt',
'addons/sourcemod/translations/chi/funcommands.phrases.txt',
'addons/sourcemod/translations/chi/funvotes.phrases.txt',
'addons/sourcemod/translations/chi/mapchooser.phrases.txt',
'addons/sourcemod/translations/chi/nextmap.phrases.txt',
'addons/sourcemod/translations/chi/nominations.phrases.txt',
'addons/sourcemod/translations/chi/playercommands.phrases.txt',
'addons/sourcemod/translations/chi/plugin.basecommands.txt',
'addons/sourcemod/translations/chi/reservedslots.phrases.txt',
'addons/sourcemod/translations/chi/rockthevote.phrases.txt',
'addons/sourcemod/translations/chi/slapslay.phrases.txt',
'addons/sourcemod/translations/chi/sounds.phrases.txt',
'addons/sourcemod/translations/chi/sqladmins.phrases.txt',
'addons/sourcemod/translations/clientprefs.phrases.txt',
'addons/sourcemod/translations/common.phrases.txt',
'addons/sourcemod/translations/core.phrases.txt',
'addons/sourcemod/translations/cze/adminhelp.phrases.txt',
'addons/sourcemod/translations/cze/adminmenu.phrases.txt',
'addons/sourcemod/translations/cze/antiflood.phrases.txt',
'addons/sourcemod/translations/cze/basebans.phrases.txt',
'addons/sourcemod/translations/cze/basecomm.phrases.txt',
'addons/sourcemod/translations/cze/basetriggers.phrases.txt',
'addons/sourcemod/translations/cze/basevotes.phrases.txt',
'addons/sourcemod/translations/cze/clientprefs.phrases.txt',
'addons/sourcemod/translations/cze/common.phrases.txt',
'addons/sourcemod/translations/cze/core.phrases.txt',
'addons/sourcemod/translations/cze/funcommands.phrases.txt',
'addons/sourcemod/translations/cze/funvotes.phrases.txt',
'addons/sourcemod/translations/cze/mapchooser.phrases.txt',
'addons/sourcemod/translations/cze/nextmap.phrases.txt',
'addons/sourcemod/translations/cze/nominations.phrases.txt',
'addons/sourcemod/translations/cze/playercommands.phrases.txt',
'addons/sourcemod/translations/cze/plugin.basecommands.txt',
'addons/sourcemod/translations/cze/reservedslots.phrases.txt',
'addons/sourcemod/translations/cze/rockthevote.phrases.txt',
'addons/sourcemod/translations/cze/sounds.phrases.txt',
'addons/sourcemod/translations/cze/sqladmins.phrases.txt',
'addons/sourcemod/translations/da/adminhelp.phrases.txt',
'addons/sourcemod/translations/da/adminmenu.phrases.txt',
'addons/sourcemod/translations/da/antiflood.phrases.txt',
'addons/sourcemod/translations/da/basebans.phrases.txt',
'addons/sourcemod/translations/da/basecomm.phrases.txt',
'addons/sourcemod/translations/da/basetriggers.phrases.txt',
'addons/sourcemod/translations/da/basevotes.phrases.txt',
'addons/sourcemod/translations/da/clientprefs.phrases.txt',
'addons/sourcemod/translations/da/common.phrases.txt',
'addons/sourcemod/translations/da/core.phrases.txt',
'addons/sourcemod/translations/da/funcommands.phrases.txt',
'addons/sourcemod/translations/da/funvotes.phrases.txt',
'addons/sourcemod/translations/da/mapchooser.phrases.txt',
'addons/sourcemod/translations/da/nextmap.phrases.txt',
'addons/sourcemod/translations/da/nominations.phrases.txt',
'addons/sourcemod/translations/da/playercommands.phrases.txt',
'addons/sourcemod/translations/da/plugin.basecommands.txt',
'addons/sourcemod/translations/da/reservedslots.phrases.txt',
'addons/sourcemod/translations/da/rockthevote.phrases.txt',
'addons/sourcemod/translations/da/slapslay.phrases.txt',
'addons/sourcemod/translations/da/sounds.phrases.txt',
'addons/sourcemod/translations/da/sqladmins.phrases.txt',
'addons/sourcemod/translations/de/adminhelp.phrases.txt',
'addons/sourcemod/translations/de/adminmenu.phrases.txt',
'addons/sourcemod/translations/de/antiflood.phrases.txt',
'addons/sourcemod/translations/de/basebans.phrases.txt',
'addons/sourcemod/translations/de/basecomm.phrases.txt',
'addons/sourcemod/translations/de/basetriggers.phrases.txt',
'addons/sourcemod/translations/de/basevotes.phrases.txt',
'addons/sourcemod/translations/de/clientprefs.phrases.txt',
'addons/sourcemod/translations/de/common.phrases.txt',
'addons/sourcemod/translations/de/core.phrases.txt',
'addons/sourcemod/translations/de/funcommands.phrases.txt',
'addons/sourcemod/translations/de/funvotes.phrases.txt',
'addons/sourcemod/translations/de/mapchooser.phrases.txt',
'addons/sourcemod/translations/de/nextmap.phrases.txt',
'addons/sourcemod/translations/de/nominations.phrases.txt',
'addons/sourcemod/translations/de/playercommands.phrases.txt',
'addons/sourcemod/translations/de/plugin.basecommands.txt',
'addons/sourcemod/translations/de/reservedslots.phrases.txt',
'addons/sourcemod/translations/de/rockthevote.phrases.txt',
'addons/sourcemod/translations/de/slapslay.phrases.txt',
'addons/sourcemod/translations/de/sounds.phrases.txt',
'addons/sourcemod/translations/de/sqladmins.phrases.txt',
'addons/sourcemod/translations/el/adminhelp.phrases.txt',
'addons/sourcemod/translations/el/adminmenu.phrases.txt',
'addons/sourcemod/translations/el/antiflood.phrases.txt',
'addons/sourcemod/translations/el/basebans.phrases.txt',
'addons/sourcemod/translations/el/basecomm.phrases.txt',
'addons/sourcemod/translations/el/basetriggers.phrases.txt',
'addons/sourcemod/translations/el/basevotes.phrases.txt',
'addons/sourcemod/translations/el/clientprefs.phrases.txt',
'addons/sourcemod/translations/el/common.phrases.txt',
'addons/sourcemod/translations/el/core.phrases.txt',
'addons/sourcemod/translations/el/funcommands.phrases.txt',
'addons/sourcemod/translations/el/funvotes.phrases.txt',
'addons/sourcemod/translations/el/mapchooser.phrases.txt',
'addons/sourcemod/translations/el/nextmap.phrases.txt',
'addons/sourcemod/translations/el/nominations.phrases.txt',
'addons/sourcemod/translations/el/playercommands.phrases.txt',
'addons/sourcemod/translations/el/plugin.basecommands.txt',
'addons/sourcemod/translations/el/reservedslots.phrases.txt',
'addons/sourcemod/translations/el/rockthevote.phrases.txt',
'addons/sourcemod/translations/el/sounds.phrases.txt',
'addons/sourcemod/translations/el/sqladmins.phrases.txt',
'addons/sourcemod/translations/es/adminhelp.phrases.txt',
'addons/sourcemod/translations/es/adminmenu.phrases.txt',
'addons/sourcemod/translations/es/antiflood.phrases.txt',
'addons/sourcemod/translations/es/basebans.phrases.txt',
'addons/sourcemod/translations/es/basecomm.phrases.txt',
'addons/sourcemod/translations/es/basetriggers.phrases.txt',
'addons/sourcemod/translations/es/basevotes.phrases.txt',
'addons/sourcemod/translations/es/clientprefs.phrases.txt',
'addons/sourcemod/translations/es/common.phrases.txt',
'addons/sourcemod/translations/es/core.phrases.txt',
'addons/sourcemod/translations/es/funcommands.phrases.txt',
'addons/sourcemod/translations/es/funvotes.phrases.txt',
'addons/sourcemod/translations/es/mapchooser.phrases.txt',
'addons/sourcemod/translations/es/nextmap.phrases.txt',
'addons/sourcemod/translations/es/nominations.phrases.txt',
'addons/sourcemod/translations/es/playercommands.phrases.txt',
'addons/sourcemod/translations/es/plugin.basecommands.txt',
'addons/sourcemod/translations/es/reservedslots.phrases.txt',
'addons/sourcemod/translations/es/rockthevote.phrases.txt',
'addons/sourcemod/translations/es/slapslay.phrases.txt',
'addons/sourcemod/translations/es/sounds.phrases.txt',
'addons/sourcemod/translations/es/sqladmins.phrases.txt',
'addons/sourcemod/translations/fi/adminhelp.phrases.txt',
'addons/sourcemod/translations/fi/adminmenu.phrases.txt',
'addons/sourcemod/translations/fi/antiflood.phrases.txt',
'addons/sourcemod/translations/fi/basebans.phrases.txt',
'addons/sourcemod/translations/fi/basecomm.phrases.txt',
'addons/sourcemod/translations/fi/basetriggers.phrases.txt',
'addons/sourcemod/translations/fi/basevotes.phrases.txt',
'addons/sourcemod/translations/fi/clientprefs.phrases.txt',
'addons/sourcemod/translations/fi/common.phrases.txt',
'addons/sourcemod/translations/fi/core.phrases.txt',
'addons/sourcemod/translations/fi/funcommands.phrases.txt',
'addons/sourcemod/translations/fi/funvotes.phrases.txt',
'addons/sourcemod/translations/fi/mapchooser.phrases.txt',
'addons/sourcemod/translations/fi/nextmap.phrases.txt',
'addons/sourcemod/translations/fi/nominations.phrases.txt',
'addons/sourcemod/translations/fi/playercommands.phrases.txt',
'addons/sourcemod/translations/fi/plugin.basecommands.txt',
'addons/sourcemod/translations/fi/reservedslots.phrases.txt',
'addons/sourcemod/translations/fi/rockthevote.phrases.txt',
'addons/sourcemod/translations/fi/sounds.phrases.txt',
'addons/sourcemod/translations/fi/sqladmins.phrases.txt',
'addons/sourcemod/translations/fr/adminhelp.phrases.txt',
'addons/sourcemod/translations/fr/adminmenu.phrases.txt',
'addons/sourcemod/translations/fr/antiflood.phrases.txt',
'addons/sourcemod/translations/fr/basebans.phrases.txt',
'addons/sourcemod/translations/fr/basecomm.phrases.txt',
'addons/sourcemod/translations/fr/basetriggers.phrases.txt',
'addons/sourcemod/translations/fr/basevotes.phrases.txt',
'addons/sourcemod/translations/fr/clientprefs.phrases.txt',
'addons/sourcemod/translations/fr/common.phrases.txt',
'addons/sourcemod/translations/fr/core.phrases.txt',
'addons/sourcemod/translations/fr/funcommands.phrases.txt',
'addons/sourcemod/translations/fr/funvotes.phrases.txt',
'addons/sourcemod/translations/fr/mapchooser.phrases.txt',
'addons/sourcemod/translations/fr/nextmap.phrases.txt',
'addons/sourcemod/translations/fr/nominations.phrases.txt',
'addons/sourcemod/translations/fr/playercommands.phrases.txt',
'addons/sourcemod/translations/fr/plugin.basecommands.txt',
'addons/sourcemod/translations/fr/reservedslots.phrases.txt',
'addons/sourcemod/translations/fr/rockthevote.phrases.txt',
'addons/sourcemod/translations/fr/slapslay.phrases.txt',
'addons/sourcemod/translations/fr/sounds.phrases.txt',
'addons/sourcemod/translations/fr/sqladmins.phrases.txt',
'addons/sourcemod/translations/funcommands.phrases.txt',
'addons/sourcemod/translations/funvotes.phrases.txt',
'addons/sourcemod/translations/he/adminhelp.phrases.txt',
'addons/sourcemod/translations/he/adminmenu.phrases.txt',
'addons/sourcemod/translations/he/antiflood.phrases.txt',
'addons/sourcemod/translations/he/basebans.phrases.txt',
'addons/sourcemod/translations/he/basecomm.phrases.txt',
'addons/sourcemod/translations/he/basetriggers.phrases.txt',
'addons/sourcemod/translations/he/basevotes.phrases.txt',
'addons/sourcemod/translations/he/clientprefs.phrases.txt',
'addons/sourcemod/translations/he/common.phrases.txt',
'addons/sourcemod/translations/he/core.phrases.txt',
'addons/sourcemod/translations/he/funcommands.phrases.txt',
'addons/sourcemod/translations/he/funvotes.phrases.txt',
'addons/sourcemod/translations/he/mapchooser.phrases.txt',
'addons/sourcemod/translations/he/nextmap.phrases.txt',
'addons/sourcemod/translations/he/nominations.phrases.txt',
'addons/sourcemod/translations/he/playercommands.phrases.txt',
'addons/sourcemod/translations/he/plugin.basecommands.txt',
'addons/sourcemod/translations/he/reservedslots.phrases.txt',
'addons/sourcemod/translations/he/rockthevote.phrases.txt',
'addons/sourcemod/translations/he/sounds.phrases.txt',
'addons/sourcemod/translations/he/sqladmins.phrases.txt',
'addons/sourcemod/translations/hu/adminhelp.phrases.txt',
'addons/sourcemod/translations/hu/adminmenu.phrases.txt',
'addons/sourcemod/translations/hu/antiflood.phrases.txt',
'addons/sourcemod/translations/hu/basebans.phrases.txt',
'addons/sourcemod/translations/hu/basecomm.phrases.txt',
'addons/sourcemod/translations/hu/basetriggers.phrases.txt',
'addons/sourcemod/translations/hu/basevotes.phrases.txt',
'addons/sourcemod/translations/hu/clientprefs.phrases.txt',
'addons/sourcemod/translations/hu/common.phrases.txt',
'addons/sourcemod/translations/hu/core.phrases.txt',
'addons/sourcemod/translations/hu/funcommands.phrases.txt',
'addons/sourcemod/translations/hu/funvotes.phrases.txt',
'addons/sourcemod/translations/hu/mapchooser.phrases.txt',
'addons/sourcemod/translations/hu/nextmap.phrases.txt',
'addons/sourcemod/translations/hu/nominations.phrases.txt',
'addons/sourcemod/translations/hu/playercommands.phrases.txt',
'addons/sourcemod/translations/hu/plugin.basecommands.txt',
'addons/sourcemod/translations/hu/reservedslots.phrases.txt',
'addons/sourcemod/translations/hu/rockthevote.phrases.txt',
'addons/sourcemod/translations/hu/slapslay.phrases.txt',
'addons/sourcemod/translations/hu/sounds.phrases.txt',
'addons/sourcemod/translations/hu/sqladmins.phrases.txt',
'addons/sourcemod/translations/it/adminhelp.phrases.txt',
'addons/sourcemod/translations/it/adminmenu.phrases.txt',
'addons/sourcemod/translations/it/antiflood.phrases.txt',
'addons/sourcemod/translations/it/basebans.phrases.txt',
'addons/sourcemod/translations/it/basecomm.phrases.txt',
'addons/sourcemod/translations/it/basetriggers.phrases.txt',
'addons/sourcemod/translations/it/basevotes.phrases.txt',
'addons/sourcemod/translations/it/clientprefs.phrases.txt',
'addons/sourcemod/translations/it/common.phrases.txt',
'addons/sourcemod/translations/it/core.phrases.txt',
'addons/sourcemod/translations/it/funcommands.phrases.txt',
'addons/sourcemod/translations/it/funvotes.phrases.txt',
'addons/sourcemod/translations/it/mapchooser.phrases.txt',
'addons/sourcemod/translations/it/nextmap.phrases.txt',
'addons/sourcemod/translations/it/nominations.phrases.txt',
'addons/sourcemod/translations/it/playercommands.phrases.txt',
'addons/sourcemod/translations/it/plugin.basecommands.txt',
'addons/sourcemod/translations/it/reservedslots.phrases.txt',
'addons/sourcemod/translations/it/rockthevote.phrases.txt',
'addons/sourcemod/translations/it/sounds.phrases.txt',
'addons/sourcemod/translations/it/sqladmins.phrases.txt',
'addons/sourcemod/translations/jp/adminhelp.phrases.txt',
'addons/sourcemod/translations/jp/adminmenu.phrases.txt',
'addons/sourcemod/translations/jp/antiflood.phrases.txt',
'addons/sourcemod/translations/jp/basebans.phrases.txt',
'addons/sourcemod/translations/jp/basecomm.phrases.txt',
'addons/sourcemod/translations/jp/basetriggers.phrases.txt',
'addons/sourcemod/translations/jp/basevotes.phrases.txt',
'addons/sourcemod/translations/jp/clientprefs.phrases.txt',
'addons/sourcemod/translations/jp/common.phrases.txt',
'addons/sourcemod/translations/jp/core.phrases.txt',
'addons/sourcemod/translations/jp/funcommands.phrases.txt',
'addons/sourcemod/translations/jp/funvotes.phrases.txt',
'addons/sourcemod/translations/jp/mapchooser.phrases.txt',
'addons/sourcemod/translations/jp/nextmap.phrases.txt',
'addons/sourcemod/translations/jp/nominations.phrases.txt',
'addons/sourcemod/translations/jp/playercommands.phrases.txt',
'addons/sourcemod/translations/jp/plugin.basecommands.txt',
'addons/sourcemod/translations/jp/reservedslots.phrases.txt',
'addons/sourcemod/translations/jp/rockthevote.phrases.txt',
'addons/sourcemod/translations/jp/slapslay.phrases.txt',
'addons/sourcemod/translations/jp/sounds.phrases.txt',
'addons/sourcemod/translations/jp/sqladmins.phrases.txt',
'addons/sourcemod/translations/ko/adminhelp.phrases.txt',
'addons/sourcemod/translations/ko/adminmenu.phrases.txt',
'addons/sourcemod/translations/ko/antiflood.phrases.txt',
'addons/sourcemod/translations/ko/basebans.phrases.txt',
'addons/sourcemod/translations/ko/basecomm.phrases.txt',
'addons/sourcemod/translations/ko/basetriggers.phrases.txt',
'addons/sourcemod/translations/ko/basevotes.phrases.txt',
'addons/sourcemod/translations/ko/clientprefs.phrases.txt',
'addons/sourcemod/translations/ko/common.phrases.txt',
'addons/sourcemod/translations/ko/core.phrases.txt',
'addons/sourcemod/translations/ko/funcommands.phrases.txt',
'addons/sourcemod/translations/ko/funvotes.phrases.txt',
'addons/sourcemod/translations/ko/mapchooser.phrases.txt',
'addons/sourcemod/translations/ko/nextmap.phrases.txt',
'addons/sourcemod/translations/ko/nominations.phrases.txt',
'addons/sourcemod/translations/ko/playercommands.phrases.txt',
'addons/sourcemod/translations/ko/plugin.basecommands.txt',
'addons/sourcemod/translations/ko/reservedslots.phrases.txt',
'addons/sourcemod/translations/ko/rockthevote.phrases.txt',
'addons/sourcemod/translations/ko/sounds.phrases.txt',
'addons/sourcemod/translations/ko/sqladmins.phrases.txt',
'addons/sourcemod/translations/lt/adminhelp.phrases.txt',
'addons/sourcemod/translations/lt/adminmenu.phrases.txt',
'addons/sourcemod/translations/lt/antiflood.phrases.txt',
'addons/sourcemod/translations/lt/basebans.phrases.txt',
'addons/sourcemod/translations/lt/basecomm.phrases.txt',
'addons/sourcemod/translations/lt/basetriggers.phrases.txt',
'addons/sourcemod/translations/lt/basevotes.phrases.txt',
'addons/sourcemod/translations/lt/clientprefs.phrases.txt',
'addons/sourcemod/translations/lt/common.phrases.txt',
'addons/sourcemod/translations/lt/core.phrases.txt',
'addons/sourcemod/translations/lt/funcommands.phrases.txt',
'addons/sourcemod/translations/lt/funvotes.phrases.txt',
'addons/sourcemod/translations/lt/mapchooser.phrases.txt',
'addons/sourcemod/translations/lt/nextmap.phrases.txt',
'addons/sourcemod/translations/lt/nominations.phrases.txt',
'addons/sourcemod/translations/lt/playercommands.phrases.txt',
'addons/sourcemod/translations/lt/plugin.basecommands.txt',
'addons/sourcemod/translations/lt/reservedslots.phrases.txt',
'addons/sourcemod/translations/lt/rockthevote.phrases.txt',
'addons/sourcemod/translations/lt/sounds.phrases.txt',
'addons/sourcemod/translations/lt/sqladmins.phrases.txt',
'addons/sourcemod/translations/lv/adminhelp.phrases.txt',
'addons/sourcemod/translations/lv/adminmenu.phrases.txt',
'addons/sourcemod/translations/lv/antiflood.phrases.txt',
'addons/sourcemod/translations/lv/basebans.phrases.txt',
'addons/sourcemod/translations/lv/basecomm.phrases.txt',
'addons/sourcemod/translations/lv/basetriggers.phrases.txt',
'addons/sourcemod/translations/lv/basevotes.phrases.txt',
'addons/sourcemod/translations/lv/clientprefs.phrases.txt',
'addons/sourcemod/translations/lv/common.phrases.txt',
'addons/sourcemod/translations/lv/core.phrases.txt',
'addons/sourcemod/translations/lv/funcommands.phrases.txt',
'addons/sourcemod/translations/lv/funvotes.phrases.txt',
'addons/sourcemod/translations/lv/mapchooser.phrases.txt',
'addons/sourcemod/translations/lv/nextmap.phrases.txt',
'addons/sourcemod/translations/lv/nominations.phrases.txt',
'addons/sourcemod/translations/lv/playercommands.phrases.txt',
'addons/sourcemod/translations/lv/plugin.basecommands.txt',
'addons/sourcemod/translations/lv/reservedslots.phrases.txt',
'addons/sourcemod/translations/lv/rockthevote.phrases.txt',
'addons/sourcemod/translations/lv/slapslay.phrases.txt',
'addons/sourcemod/translations/lv/sounds.phrases.txt',
'addons/sourcemod/translations/lv/sqladmins.phrases.txt',
'addons/sourcemod/translations/mapchooser.phrases.txt',
'addons/sourcemod/translations/nextmap.phrases.txt',
'addons/sourcemod/translations/nl/adminhelp.phrases.txt',
'addons/sourcemod/translations/nl/adminmenu.phrases.txt',
'addons/sourcemod/translations/nl/antiflood.phrases.txt',
'addons/sourcemod/translations/nl/basebans.phrases.txt',
'addons/sourcemod/translations/nl/basecomm.phrases.txt',
'addons/sourcemod/translations/nl/basetriggers.phrases.txt',
'addons/sourcemod/translations/nl/basevotes.phrases.txt',
'addons/sourcemod/translations/nl/clientprefs.phrases.txt',
'addons/sourcemod/translations/nl/common.phrases.txt',
'addons/sourcemod/translations/nl/core.phrases.txt',
'addons/sourcemod/translations/nl/funcommands.phrases.txt',
'addons/sourcemod/translations/nl/funvotes.phrases.txt',
'addons/sourcemod/translations/nl/mapchooser.phrases.txt',
'addons/sourcemod/translations/nl/nextmap.phrases.txt',
'addons/sourcemod/translations/nl/nominations.phrases.txt',
'addons/sourcemod/translations/nl/playercommands.phrases.txt',
'addons/sourcemod/translations/nl/plugin.basecommands.txt',
'addons/sourcemod/translations/nl/reservedslots.phrases.txt',
'addons/sourcemod/translations/nl/rockthevote.phrases.txt',
'addons/sourcemod/translations/nl/sounds.phrases.txt',
'addons/sourcemod/translations/nl/sqladmins.phrases.txt',
'addons/sourcemod/translations/nominations.phrases.txt',
'addons/sourcemod/translations/no/adminhelp.phrases.txt',
'addons/sourcemod/translations/no/adminmenu.phrases.txt',
'addons/sourcemod/translations/no/antiflood.phrases.txt',
'addons/sourcemod/translations/no/basebans.phrases.txt',
'addons/sourcemod/translations/no/basecomm.phrases.txt',
'addons/sourcemod/translations/no/basetriggers.phrases.txt',
'addons/sourcemod/translations/no/basevotes.phrases.txt',
'addons/sourcemod/translations/no/clientprefs.phrases.txt',
'addons/sourcemod/translations/no/common.phrases.txt',
'addons/sourcemod/translations/no/core.phrases.txt',
'addons/sourcemod/translations/no/funcommands.phrases.txt',
'addons/sourcemod/translations/no/funvotes.phrases.txt',
'addons/sourcemod/translations/no/mapchooser.phrases.txt',
'addons/sourcemod/translations/no/nextmap.phrases.txt',
'addons/sourcemod/translations/no/nominations.phrases.txt',
'addons/sourcemod/translations/no/playercommands.phrases.txt',
'addons/sourcemod/translations/no/plugin.basecommands.txt',
'addons/sourcemod/translations/no/reservedslots.phrases.txt',
'addons/sourcemod/translations/no/rockthevote.phrases.txt',
'addons/sourcemod/translations/no/slapslay.phrases.txt',
'addons/sourcemod/translations/no/sounds.phrases.txt',
'addons/sourcemod/translations/no/sqladmins.phrases.txt',
'addons/sourcemod/translations/playercommands.phrases.txt',
'addons/sourcemod/translations/plugin.basecommands.txt',
'addons/sourcemod/translations/pl/adminhelp.phrases.txt',
'addons/sourcemod/translations/pl/adminmenu.phrases.txt',
'addons/sourcemod/translations/pl/antiflood.phrases.txt',
'addons/sourcemod/translations/pl/basebans.phrases.txt',
'addons/sourcemod/translations/pl/basecomm.phrases.txt',
'addons/sourcemod/translations/pl/basetriggers.phrases.txt',
'addons/sourcemod/translations/pl/basevotes.phrases.txt',
'addons/sourcemod/translations/pl/clientprefs.phrases.txt',
'addons/sourcemod/translations/pl/common.phrases.txt',
'addons/sourcemod/translations/pl/core.phrases.txt',
'addons/sourcemod/translations/pl/funcommands.phrases.txt',
'addons/sourcemod/translations/pl/funvotes.phrases.txt',
'addons/sourcemod/translations/pl/mapchooser.phrases.txt',
'addons/sourcemod/translations/pl/nextmap.phrases.txt',
'addons/sourcemod/translations/pl/nominations.phrases.txt',
'addons/sourcemod/translations/pl/playercommands.phrases.txt',
'addons/sourcemod/translations/pl/plugin.basecommands.txt',
'addons/sourcemod/translations/pl/reservedslots.phrases.txt',
'addons/sourcemod/translations/pl/rockthevote.phrases.txt',
'addons/sourcemod/translations/pl/slapslay.phrases.txt',
'addons/sourcemod/translations/pl/sounds.phrases.txt',
'addons/sourcemod/translations/pl/sqladmins.phrases.txt',
'addons/sourcemod/translations/pt/adminhelp.phrases.txt',
'addons/sourcemod/translations/pt/adminmenu.phrases.txt',
'addons/sourcemod/translations/pt/antiflood.phrases.txt',
'addons/sourcemod/translations/pt/basebans.phrases.txt',
'addons/sourcemod/translations/pt/basecomm.phrases.txt',
'addons/sourcemod/translations/pt/basetriggers.phrases.txt',
'addons/sourcemod/translations/pt/basevotes.phrases.txt',
'addons/sourcemod/translations/pt/clientprefs.phrases.txt',
'addons/sourcemod/translations/pt/common.phrases.txt',
'addons/sourcemod/translations/pt/core.phrases.txt',
'addons/sourcemod/translations/pt/funcommands.phrases.txt',
'addons/sourcemod/translations/pt/funvotes.phrases.txt',
'addons/sourcemod/translations/pt/mapchooser.phrases.txt',
'addons/sourcemod/translations/pt/nextmap.phrases.txt',
'addons/sourcemod/translations/pt/nominations.phrases.txt',
'addons/sourcemod/translations/pt/playercommands.phrases.txt',
'addons/sourcemod/translations/pt/plugin.basecommands.txt',
'addons/sourcemod/translations/pt/reservedslots.phrases.txt',
'addons/sourcemod/translations/pt/rockthevote.phrases.txt',
'addons/sourcemod/translations/pt/slapslay.phrases.txt',
'addons/sourcemod/translations/pt/sounds.phrases.txt',
'addons/sourcemod/translations/pt/sqladmins.phrases.txt',
'addons/sourcemod/translations/pt_p/adminhelp.phrases.txt',
'addons/sourcemod/translations/pt_p/adminmenu.phrases.txt',
'addons/sourcemod/translations/pt_p/antiflood.phrases.txt',
'addons/sourcemod/translations/pt_p/basebans.phrases.txt',
'addons/sourcemod/translations/pt_p/basecomm.phrases.txt',
'addons/sourcemod/translations/pt_p/basetriggers.phrases.txt',
'addons/sourcemod/translations/pt_p/basevotes.phrases.txt',
'addons/sourcemod/translations/pt_p/clientprefs.phrases.txt',
'addons/sourcemod/translations/pt_p/common.phrases.txt',
'addons/sourcemod/translations/pt_p/core.phrases.txt',
'addons/sourcemod/translations/pt_p/funcommands.phrases.txt',
'addons/sourcemod/translations/pt_p/funvotes.phrases.txt',
'addons/sourcemod/translations/pt_p/mapchooser.phrases.txt',
'addons/sourcemod/translations/pt_p/nextmap.phrases.txt',
'addons/sourcemod/translations/pt_p/nominations.phrases.txt',
'addons/sourcemod/translations/pt_p/playercommands.phrases.txt',
'addons/sourcemod/translations/pt_p/plugin.basecommands.txt',
'addons/sourcemod/translations/pt_p/reservedslots.phrases.txt',
'addons/sourcemod/translations/pt_p/rockthevote.phrases.txt',
'addons/sourcemod/translations/pt_p/sounds.phrases.txt',
'addons/sourcemod/translations/pt_p/sqladmins.phrases.txt',
'addons/sourcemod/translations/reservedslots.phrases.txt',
'addons/sourcemod/translations/rockthevote.phrases.txt',
'addons/sourcemod/translations/ro/adminhelp.phrases.txt',
'addons/sourcemod/translations/ro/adminmenu.phrases.txt',
'addons/sourcemod/translations/ro/antiflood.phrases.txt',
'addons/sourcemod/translations/ro/basebans.phrases.txt',
'addons/sourcemod/translations/ro/basecomm.phrases.txt',
'addons/sourcemod/translations/ro/basetriggers.phrases.txt',
'addons/sourcemod/translations/ro/basevotes.phrases.txt',
'addons/sourcemod/translations/ro/clientprefs.phrases.txt',
'addons/sourcemod/translations/ro/common.phrases.txt',
'addons/sourcemod/translations/ro/core.phrases.txt',
'addons/sourcemod/translations/ro/funcommands.phrases.txt',
'addons/sourcemod/translations/ro/funvotes.phrases.txt',
'addons/sourcemod/translations/ro/mapchooser.phrases.txt',
'addons/sourcemod/translations/ro/nextmap.phrases.txt',
'addons/sourcemod/translations/ro/nominations.phrases.txt',
'addons/sourcemod/translations/ro/playercommands.phrases.txt',
'addons/sourcemod/translations/ro/plugin.basecommands.txt',
'addons/sourcemod/translations/ro/reservedslots.phrases.txt',
'addons/sourcemod/translations/ro/rockthevote.phrases.txt',
'addons/sourcemod/translations/ro/slapslay.phrases.txt',
'addons/sourcemod/translations/ro/sounds.phrases.txt',
'addons/sourcemod/translations/ro/sqladmins.phrases.txt',
'addons/sourcemod/translations/ru/adminhelp.phrases.txt',
'addons/sourcemod/translations/ru/adminmenu.phrases.txt',
'addons/sourcemod/translations/ru/antiflood.phrases.txt',
'addons/sourcemod/translations/ru/basebans.phrases.txt',
'addons/sourcemod/translations/ru/basecomm.phrases.txt',
'addons/sourcemod/translations/ru/basetriggers.phrases.txt',
'addons/sourcemod/translations/ru/basevotes.phrases.txt',
'addons/sourcemod/translations/ru/clientprefs.phrases.txt',
'addons/sourcemod/translations/ru/common.phrases.txt',
'addons/sourcemod/translations/ru/core.phrases.txt',
'addons/sourcemod/translations/ru/funcommands.phrases.txt',
'addons/sourcemod/translations/ru/funvotes.phrases.txt',
'addons/sourcemod/translations/ru/mapchooser.phrases.txt',
'addons/sourcemod/translations/ru/nextmap.phrases.txt',
'addons/sourcemod/translations/ru/nominations.phrases.txt',
'addons/sourcemod/translations/ru/playercommands.phrases.txt',
'addons/sourcemod/translations/ru/plugin.basecommands.txt',
'addons/sourcemod/translations/ru/reservedslots.phrases.txt',
'addons/sourcemod/translations/ru/rockthevote.phrases.txt',
'addons/sourcemod/translations/ru/slapslay.phrases.txt',
'addons/sourcemod/translations/ru/sounds.phrases.txt',
'addons/sourcemod/translations/ru/sqladmins.phrases.txt',
'addons/sourcemod/translations/sk/adminhelp.phrases.txt',
'addons/sourcemod/translations/sk/adminmenu.phrases.txt',
'addons/sourcemod/translations/sk/antiflood.phrases.txt',
'addons/sourcemod/translations/sk/basebans.phrases.txt',
'addons/sourcemod/translations/sk/basecomm.phrases.txt',
'addons/sourcemod/translations/sk/basetriggers.phrases.txt',
'addons/sourcemod/translations/sk/basevotes.phrases.txt',
'addons/sourcemod/translations/sk/clientprefs.phrases.txt',
'addons/sourcemod/translations/sk/common.phrases.txt',
'addons/sourcemod/translations/sk/core.phrases.txt',
'addons/sourcemod/translations/sk/funcommands.phrases.txt',
'addons/sourcemod/translations/sk/funvotes.phrases.txt',
'addons/sourcemod/translations/sk/mapchooser.phrases.txt',
'addons/sourcemod/translations/sk/nextmap.phrases.txt',
'addons/sourcemod/translations/sk/nominations.phrases.txt',
'addons/sourcemod/translations/sk/playercommands.phrases.txt',
'addons/sourcemod/translations/sk/plugin.basecommands.txt',
'addons/sourcemod/translations/sk/reservedslots.phrases.txt',
'addons/sourcemod/translations/sk/rockthevote.phrases.txt',
'addons/sourcemod/translations/sk/sounds.phrases.txt',
'addons/sourcemod/translations/sk/sqladmins.phrases.txt',
'addons/sourcemod/translations/sounds.phrases.txt',
'addons/sourcemod/translations/sqladmins.phrases.txt',
'addons/sourcemod/translations/sv/adminhelp.phrases.txt',
'addons/sourcemod/translations/sv/adminmenu.phrases.txt',
'addons/sourcemod/translations/sv/antiflood.phrases.txt',
'addons/sourcemod/translations/sv/basebans.phrases.txt',
'addons/sourcemod/translations/sv/basecomm.phrases.txt',
'addons/sourcemod/translations/sv/basetriggers.phrases.txt',
'addons/sourcemod/translations/sv/basevotes.phrases.txt',
'addons/sourcemod/translations/sv/clientprefs.phrases.txt',
'addons/sourcemod/translations/sv/common.phrases.txt',
'addons/sourcemod/translations/sv/core.phrases.txt',
'addons/sourcemod/translations/sv/funcommands.phrases.txt',
'addons/sourcemod/translations/sv/funvotes.phrases.txt',
'addons/sourcemod/translations/sv/mapchooser.phrases.txt',
'addons/sourcemod/translations/sv/nextmap.phrases.txt',
'addons/sourcemod/translations/sv/nominations.phrases.txt',
'addons/sourcemod/translations/sv/playercommands.phrases.txt',
'addons/sourcemod/translations/sv/plugin.basecommands.txt',
'addons/sourcemod/translations/sv/reservedslots.phrases.txt',
'addons/sourcemod/translations/sv/rockthevote.phrases.txt',
'addons/sourcemod/translations/sv/slapslay.phrases.txt',
'addons/sourcemod/translations/sv/sounds.phrases.txt',
'addons/sourcemod/translations/sv/sqladmins.phrases.txt',
'addons/sourcemod/translations/th/adminhelp.phrases.txt',
'addons/sourcemod/translations/th/adminmenu.phrases.txt',
'addons/sourcemod/translations/th/antiflood.phrases.txt',
'addons/sourcemod/translations/th/basebans.phrases.txt',
'addons/sourcemod/translations/th/basecomm.phrases.txt',
'addons/sourcemod/translations/th/basetriggers.phrases.txt',
'addons/sourcemod/translations/th/basevotes.phrases.txt',
'addons/sourcemod/translations/th/clientprefs.phrases.txt',
'addons/sourcemod/translations/th/common.phrases.txt',
'addons/sourcemod/translations/th/core.phrases.txt',
'addons/sourcemod/translations/th/funcommands.phrases.txt',
'addons/sourcemod/translations/th/funvotes.phrases.txt',
'addons/sourcemod/translations/th/mapchooser.phrases.txt',
'addons/sourcemod/translations/th/nextmap.phrases.txt',
'addons/sourcemod/translations/th/nominations.phrases.txt',
'addons/sourcemod/translations/th/playercommands.phrases.txt',
'addons/sourcemod/translations/th/plugin.basecommands.txt',
'addons/sourcemod/translations/th/reservedslots.phrases.txt',
'addons/sourcemod/translations/th/rockthevote.phrases.txt',
'addons/sourcemod/translations/th/sounds.phrases.txt',
'addons/sourcemod/translations/th/sqladmins.phrases.txt',
'addons/sourcemod/translations/tr/adminhelp.phrases.txt',
'addons/sourcemod/translations/tr/adminmenu.phrases.txt',
'addons/sourcemod/translations/tr/antiflood.phrases.txt',
'addons/sourcemod/translations/tr/basebans.phrases.txt',
'addons/sourcemod/translations/tr/basecomm.phrases.txt',
'addons/sourcemod/translations/tr/basetriggers.phrases.txt',
'addons/sourcemod/translations/tr/basevotes.phrases.txt',
'addons/sourcemod/translations/tr/clientprefs.phrases.txt',
'addons/sourcemod/translations/tr/common.phrases.txt',
'addons/sourcemod/translations/tr/core.phrases.txt',
'addons/sourcemod/translations/tr/funcommands.phrases.txt',
'addons/sourcemod/translations/tr/funvotes.phrases.txt',
'addons/sourcemod/translations/tr/mapchooser.phrases.txt',
'addons/sourcemod/translations/tr/nextmap.phrases.txt',
'addons/sourcemod/translations/tr/nominations.phrases.txt',
'addons/sourcemod/translations/tr/playercommands.phrases.txt',
'addons/sourcemod/translations/tr/plugin.basecommands.txt',
'addons/sourcemod/translations/tr/reservedslots.phrases.txt',
'addons/sourcemod/translations/tr/rockthevote.phrases.txt',
'addons/sourcemod/translations/tr/slapslay.phrases.txt',
'addons/sourcemod/translations/tr/sounds.phrases.txt',
'addons/sourcemod/translations/tr/sqladmins.phrases.txt',
'addons/sourcemod/translations/ua/adminhelp.phrases.txt',
'addons/sourcemod/translations/ua/adminmenu.phrases.txt',
'addons/sourcemod/translations/ua/antiflood.phrases.txt',
'addons/sourcemod/translations/ua/basebans.phrases.txt',
'addons/sourcemod/translations/ua/basecomm.phrases.txt',
'addons/sourcemod/translations/ua/basetriggers.phrases.txt',
'addons/sourcemod/translations/ua/basevotes.phrases.txt',
'addons/sourcemod/translations/ua/clientprefs.phrases.txt',
'addons/sourcemod/translations/ua/common.phrases.txt',
'addons/sourcemod/translations/ua/core.phrases.txt',
'addons/sourcemod/translations/ua/funcommands.phrases.txt',
'addons/sourcemod/translations/ua/funvotes.phrases.txt',
'addons/sourcemod/translations/ua/mapchooser.phrases.txt',
'addons/sourcemod/translations/ua/nextmap.phrases.txt',
'addons/sourcemod/translations/ua/nominations.phrases.txt',
'addons/sourcemod/translations/ua/playercommands.phrases.txt',
'addons/sourcemod/translations/ua/plugin.basecommands.txt',
'addons/sourcemod/translations/ua/reservedslots.phrases.txt',
'addons/sourcemod/translations/ua/rockthevote.phrases.txt',
'addons/sourcemod/translations/ua/sounds.phrases.txt',
'addons/sourcemod/translations/ua/sqladmins.phrases.txt',
'addons/sourcemod/translations/vi/adminhelp.phrases.txt',
'addons/sourcemod/translations/vi/adminmenu.phrases.txt',
'addons/sourcemod/translations/vi/antiflood.phrases.txt',
'addons/sourcemod/translations/vi/basebans.phrases.txt',
'addons/sourcemod/translations/vi/basecomm.phrases.txt',
'addons/sourcemod/translations/vi/basetriggers.phrases.txt',
'addons/sourcemod/translations/vi/basevotes.phrases.txt',
'addons/sourcemod/translations/vi/clientprefs.phrases.txt',
'addons/sourcemod/translations/vi/common.phrases.txt',
'addons/sourcemod/translations/vi/core.phrases.txt',
'addons/sourcemod/translations/vi/funcommands.phrases.txt',
'addons/sourcemod/translations/vi/funvotes.phrases.txt',
'addons/sourcemod/translations/vi/mapchooser.phrases.txt',
'addons/sourcemod/translations/vi/nextmap.phrases.txt',
'addons/sourcemod/translations/vi/nominations.phrases.txt',
'addons/sourcemod/translations/vi/playercommands.phrases.txt',
'addons/sourcemod/translations/vi/plugin.basecommands.txt',
'addons/sourcemod/translations/vi/reservedslots.phrases.txt',
'addons/sourcemod/translations/vi/rockthevote.phrases.txt',
'addons/sourcemod/translations/vi/sounds.phrases.txt',
'addons/sourcemod/translations/vi/sqladmins.phrases.txt',
'addons/sourcemod/translations/zho/adminhelp.phrases.txt',
'addons/sourcemod/translations/zho/adminmenu.phrases.txt',
'addons/sourcemod/translations/zho/antiflood.phrases.txt',
'addons/sourcemod/translations/zho/basebans.phrases.txt',
'addons/sourcemod/translations/zho/basecomm.phrases.txt',
'addons/sourcemod/translations/zho/basetriggers.phrases.txt',
'addons/sourcemod/translations/zho/basevotes.phrases.txt',
'addons/sourcemod/translations/zho/clientprefs.phrases.txt',
'addons/sourcemod/translations/zho/common.phrases.txt',
'addons/sourcemod/translations/zho/core.phrases.txt',
'addons/sourcemod/translations/zho/funcommands.phrases.txt',
'addons/sourcemod/translations/zho/funvotes.phrases.txt',
'addons/sourcemod/translations/zho/mapchooser.phrases.txt',
'addons/sourcemod/translations/zho/nextmap.phrases.txt',
'addons/sourcemod/translations/zho/nominations.phrases.txt',
'addons/sourcemod/translations/zho/playercommands.phrases.txt',
'addons/sourcemod/translations/zho/plugin.basecommands.txt',
'addons/sourcemod/translations/zho/reservedslots.phrases.txt',
'addons/sourcemod/translations/zho/rockthevote.phrases.txt',
'addons/sourcemod/translations/zho/sounds.phrases.txt',
'addons/sourcemod/translations/zho/sqladmins.phrases.txt',
'cfg/sourcemod/sm_warmode_off.cfg',
'cfg/sourcemod/sm_warmode_on.cfg',
'cfg/sourcemod/sourcemod.cfg',
]

export const sm1_10_win = ['addons/metamod/sourcemod.vdf',
'addons/sourcemod/bin/sourcemod.2.bgt.dll',
'addons/sourcemod/bin/sourcemod.2.bms.dll',
'addons/sourcemod/bin/sourcemod.2.contagion.dll',
'addons/sourcemod/bin/sourcemod.2.csgo.dll',
'addons/sourcemod/bin/sourcemod.2.css.dll',
'addons/sourcemod/bin/sourcemod.2.darkm.dll',
'addons/sourcemod/bin/sourcemod.2.dods.dll',
'addons/sourcemod/bin/sourcemod.2.doi.dll',
'addons/sourcemod/bin/sourcemod.2.ep1.dll',
'addons/sourcemod/bin/sourcemod.2.ep2.dll',
'addons/sourcemod/bin/sourcemod.2.eye.dll',
'addons/sourcemod/bin/sourcemod.2.hl2dm.dll',
'addons/sourcemod/bin/sourcemod.2.insurgency.dll',
'addons/sourcemod/bin/sourcemod.2.l4d.dll',
'addons/sourcemod/bin/sourcemod.2.l4d2.dll',
'addons/sourcemod/bin/sourcemod.2.nd.dll',
'addons/sourcemod/bin/sourcemod.2.sdk2013.dll',
'addons/sourcemod/bin/sourcemod.2.swarm.dll',
'addons/sourcemod/bin/sourcemod.2.tf2.dll',
'addons/sourcemod/bin/sourcemod.logic.dll',
'addons/sourcemod/bin/sourcemod_mm.dll',
'addons/sourcemod/bin/sourcepawn.jit.x86.dll',
'addons/sourcemod/configs/adminmenu_cfgs.txt',
'addons/sourcemod/configs/adminmenu_custom.txt',
'addons/sourcemod/configs/adminmenu_grouping.txt',
'addons/sourcemod/configs/adminmenu_sorting.txt',
'addons/sourcemod/configs/admins.cfg',
'addons/sourcemod/configs/admins_simple.ini',
'addons/sourcemod/configs/admin_groups.cfg',
'addons/sourcemod/configs/admin_levels.cfg',
'addons/sourcemod/configs/admin_overrides.cfg',
'addons/sourcemod/configs/banreasons.txt',
'addons/sourcemod/configs/core.cfg',
'addons/sourcemod/configs/databases.cfg',
'addons/sourcemod/configs/geoip/GeoIP.dat',
'addons/sourcemod/configs/languages.cfg',
'addons/sourcemod/configs/maplists.cfg',
'addons/sourcemod/configs/sql-init-scripts/mysql/clientprefs-mysql.sql',
'addons/sourcemod/configs/sql-init-scripts/mysql/create_admins.sql',
'addons/sourcemod/configs/sql-init-scripts/mysql/update_admins_r1409.sql',
'addons/sourcemod/configs/sql-init-scripts/sqlite/admins-sqlite.sq3',
'addons/sourcemod/configs/sql-init-scripts/sqlite/clientprefs-sqlite.sq3',
'addons/sourcemod/configs/sql-init-scripts/sqlite/clientprefs-sqlite.sql',
'addons/sourcemod/configs/sql-init-scripts/sqlite/create_admins.sql',
'addons/sourcemod/configs/sql-init-scripts/sqlite/update_admins-r1409.sql',
'addons/sourcemod/extensions/bintools.ext.dll',
'addons/sourcemod/extensions/clientprefs.ext.dll',
'addons/sourcemod/extensions/dbi.mysql.ext.dll',
'addons/sourcemod/extensions/dbi.sqlite.ext.dll',
'addons/sourcemod/extensions/game.cstrike.ext.2.csgo.dll',
'addons/sourcemod/extensions/game.cstrike.ext.2.css.dll',
'addons/sourcemod/extensions/game.tf2.ext.2.tf2.dll',
'addons/sourcemod/extensions/geoip.ext.dll',
'addons/sourcemod/extensions/regex.ext.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.bgt.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.bms.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.contagion.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.csgo.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.css.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.darkm.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.dods.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.doi.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.ep1.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.ep2.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.eye.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.hl2dm.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.insurgency.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.l4d.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.l4d2.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.nd.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.sdk2013.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.swarm.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.tf2.dll',
'addons/sourcemod/extensions/sdktools.ext.2.bgt.dll',
'addons/sourcemod/extensions/sdktools.ext.2.bms.dll',
'addons/sourcemod/extensions/sdktools.ext.2.contagion.dll',
'addons/sourcemod/extensions/sdktools.ext.2.csgo.dll',
'addons/sourcemod/extensions/sdktools.ext.2.css.dll',
'addons/sourcemod/extensions/sdktools.ext.2.darkm.dll',
'addons/sourcemod/extensions/sdktools.ext.2.dods.dll',
'addons/sourcemod/extensions/sdktools.ext.2.doi.dll',
'addons/sourcemod/extensions/sdktools.ext.2.ep1.dll',
'addons/sourcemod/extensions/sdktools.ext.2.ep2.dll',
'addons/sourcemod/extensions/sdktools.ext.2.eye.dll',
'addons/sourcemod/extensions/sdktools.ext.2.hl2dm.dll',
'addons/sourcemod/extensions/sdktools.ext.2.insurgency.dll',
'addons/sourcemod/extensions/sdktools.ext.2.l4d.dll',
'addons/sourcemod/extensions/sdktools.ext.2.l4d2.dll',
'addons/sourcemod/extensions/sdktools.ext.2.nd.dll',
'addons/sourcemod/extensions/sdktools.ext.2.sdk2013.dll',
'addons/sourcemod/extensions/sdktools.ext.2.swarm.dll',
'addons/sourcemod/extensions/sdktools.ext.2.tf2.dll',
'addons/sourcemod/extensions/topmenus.ext.dll',
'addons/sourcemod/extensions/updater.ext.dll',
'addons/sourcemod/extensions/webternet.ext.dll',
'addons/sourcemod/gamedata/core.games/blacklist.plugins.txt',
'addons/sourcemod/gamedata/core.games/common.games.txt',
'addons/sourcemod/gamedata/core.games/engine.bgt.txt',
'addons/sourcemod/gamedata/core.games/engine.blade.txt',
'addons/sourcemod/gamedata/core.games/engine.bms.txt',
'addons/sourcemod/gamedata/core.games/engine.contagion.txt',
'addons/sourcemod/gamedata/core.games/engine.csgo.txt',
'addons/sourcemod/gamedata/core.games/engine.css.txt',
'addons/sourcemod/gamedata/core.games/engine.darkm.txt',
'addons/sourcemod/gamedata/core.games/engine.ep1.txt',
'addons/sourcemod/gamedata/core.games/engine.ep2.txt',
'addons/sourcemod/gamedata/core.games/engine.ep2valve.txt',
'addons/sourcemod/gamedata/core.games/engine.eye.txt',
'addons/sourcemod/gamedata/core.games/engine.insurgency.txt',
'addons/sourcemod/gamedata/core.games/engine.l4d.txt',
'addons/sourcemod/gamedata/core.games/engine.l4d2.txt',
'addons/sourcemod/gamedata/core.games/engine.sdk2013.txt',
'addons/sourcemod/gamedata/core.games/engine.swarm.txt',
'addons/sourcemod/gamedata/core.games/game.dinodday.txt',
'addons/sourcemod/gamedata/core.games/master.games.txt',
'addons/sourcemod/gamedata/funcommands.games.txt',
'addons/sourcemod/gamedata/sdkhooks.games/common.games.txt',
'addons/sourcemod/gamedata/sdkhooks.games/engine.blade.txt',
'addons/sourcemod/gamedata/sdkhooks.games/engine.contagion.txt',
'addons/sourcemod/gamedata/sdkhooks.games/engine.csgo.txt',
'addons/sourcemod/gamedata/sdkhooks.games/engine.darkm.txt',
'addons/sourcemod/gamedata/sdkhooks.games/engine.ep2v.txt',
'addons/sourcemod/gamedata/sdkhooks.games/engine.insurgency.txt',
'addons/sourcemod/gamedata/sdkhooks.games/engine.l4d.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.ag2.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.alienswarm.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.aoc.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.bms.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.cspromod.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.cstrike.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.dinodday.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.doi.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.empires.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.ff.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.fof.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.gesource.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.hidden.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.hl2ctf.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.insurgency.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.kz.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.l4d2.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.modularcombat.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.neotokyo.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.nmrih.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.nucleardawn.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.pvkii.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.reactivedrop.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.sgtls.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.sourceforts.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.synergy.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.zm.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.zpanic.txt',
'addons/sourcemod/gamedata/sdkhooks.games/master.games.txt',
'addons/sourcemod/gamedata/sdktools.games/common.games.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.bgt.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.blade.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.contagion.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.csgo.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.css.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.darkm.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.ep1.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.ep2.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.ep2valve.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.eye.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.insurgency.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.l4d.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.l4d2.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.sdk2013.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.swarm.txt',
'addons/sourcemod/gamedata/sdktools.games/game.ag2.txt',
'addons/sourcemod/gamedata/sdktools.games/game.alienswarm.txt',
'addons/sourcemod/gamedata/sdktools.games/game.aoc.txt',
'addons/sourcemod/gamedata/sdktools.games/game.bg2.txt',
'addons/sourcemod/gamedata/sdktools.games/game.bms.txt',
'addons/sourcemod/gamedata/sdktools.games/game.cspromod.txt',
'addons/sourcemod/gamedata/sdktools.games/game.cstrike.txt',
'addons/sourcemod/gamedata/sdktools.games/game.dinodday.txt',
'addons/sourcemod/gamedata/sdktools.games/game.dod.txt',
'addons/sourcemod/gamedata/sdktools.games/game.doi.txt',
'addons/sourcemod/gamedata/sdktools.games/game.dystopia.txt',
'addons/sourcemod/gamedata/sdktools.games/game.empires.txt',
'addons/sourcemod/gamedata/sdktools.games/game.esmod.txt',
'addons/sourcemod/gamedata/sdktools.games/game.fas.txt',
'addons/sourcemod/gamedata/sdktools.games/game.ff.txt',
'addons/sourcemod/gamedata/sdktools.games/game.fof.txt',
'addons/sourcemod/gamedata/sdktools.games/game.gesource.txt',
'addons/sourcemod/gamedata/sdktools.games/game.hidden.txt',
'addons/sourcemod/gamedata/sdktools.games/game.hl2ctf.txt',
'addons/sourcemod/gamedata/sdktools.games/game.hl2mp.txt',
'addons/sourcemod/gamedata/sdktools.games/game.insurgency.txt',
'addons/sourcemod/gamedata/sdktools.games/game.ios.txt',
'addons/sourcemod/gamedata/sdktools.games/game.kz.txt',
'addons/sourcemod/gamedata/sdktools.games/game.left4dead2.txt',
'addons/sourcemod/gamedata/sdktools.games/game.modularcombat.txt',
'addons/sourcemod/gamedata/sdktools.games/game.neotokyo.txt',
'addons/sourcemod/gamedata/sdktools.games/game.nmrih.txt',
'addons/sourcemod/gamedata/sdktools.games/game.nucleardawn.txt',
'addons/sourcemod/gamedata/sdktools.games/game.obsidian.txt',
'addons/sourcemod/gamedata/sdktools.games/game.pvkii.txt',
'addons/sourcemod/gamedata/sdktools.games/game.reactivedrop.txt',
'addons/sourcemod/gamedata/sdktools.games/game.rnlbeta.txt',
'addons/sourcemod/gamedata/sdktools.games/game.ship.txt',
'addons/sourcemod/gamedata/sdktools.games/game.sourceforts.txt',
'addons/sourcemod/gamedata/sdktools.games/game.synergy.txt',
'addons/sourcemod/gamedata/sdktools.games/game.tf.txt',
'addons/sourcemod/gamedata/sdktools.games/game.zm.txt',
'addons/sourcemod/gamedata/sdktools.games/game.zpanic.txt',
'addons/sourcemod/gamedata/sdktools.games/master.games.txt',
'addons/sourcemod/gamedata/sm-cstrike.games/game.csgo.txt',
'addons/sourcemod/gamedata/sm-cstrike.games/game.css.txt',
'addons/sourcemod/gamedata/sm-cstrike.games/master.games.txt',
'addons/sourcemod/gamedata/sm-tf2.games.txt',
'addons/sourcemod/GPLv2.txt',
'addons/sourcemod/GPLv3.txt',
'addons/sourcemod/LICENSE.txt',
'addons/sourcemod/plugins/admin-flatfile.smx',
'addons/sourcemod/plugins/adminhelp.smx',
'addons/sourcemod/plugins/adminmenu.smx',
'addons/sourcemod/plugins/antiflood.smx',
'addons/sourcemod/plugins/basebans.smx',
'addons/sourcemod/plugins/basechat.smx',
'addons/sourcemod/plugins/basecomm.smx',
'addons/sourcemod/plugins/basecommands.smx',
'addons/sourcemod/plugins/basetriggers.smx',
'addons/sourcemod/plugins/basevotes.smx',
'addons/sourcemod/plugins/clientprefs.smx',
'addons/sourcemod/plugins/disabled/admin-sql-prefetch.smx',
'addons/sourcemod/plugins/disabled/admin-sql-threaded.smx',
'addons/sourcemod/plugins/disabled/mapchooser.smx',
'addons/sourcemod/plugins/disabled/nominations.smx',
'addons/sourcemod/plugins/disabled/randomcycle.smx',
'addons/sourcemod/plugins/disabled/rockthevote.smx',
'addons/sourcemod/plugins/disabled/sql-admin-manager.smx',
'addons/sourcemod/plugins/funcommands.smx',
'addons/sourcemod/plugins/funvotes.smx',
'addons/sourcemod/plugins/nextmap.smx',
'addons/sourcemod/plugins/playercommands.smx',
'addons/sourcemod/plugins/reservedslots.smx',
'addons/sourcemod/plugins/sounds.smx',
'addons/sourcemod/scripting/admin-flatfile/admin-flatfile.sp',
'addons/sourcemod/scripting/admin-flatfile/admin-groups.sp',
'addons/sourcemod/scripting/admin-flatfile/admin-overrides.sp',
'addons/sourcemod/scripting/admin-flatfile/admin-simple.sp',
'addons/sourcemod/scripting/admin-flatfile/admin-users.sp',
'addons/sourcemod/scripting/admin-sql-prefetch.sp',
'addons/sourcemod/scripting/admin-sql-threaded.sp',
'addons/sourcemod/scripting/adminhelp.sp',
'addons/sourcemod/scripting/adminmenu.sp',
'addons/sourcemod/scripting/adminmenu/dynamicmenu.sp',
'addons/sourcemod/scripting/antiflood.sp',
'addons/sourcemod/scripting/basebans.sp',
'addons/sourcemod/scripting/basebans/ban.sp',
'addons/sourcemod/scripting/basechat.sp',
'addons/sourcemod/scripting/basecomm.sp',
'addons/sourcemod/scripting/basecommands.sp',
'addons/sourcemod/scripting/basecommands/cancelvote.sp',
'addons/sourcemod/scripting/basecommands/execcfg.sp',
'addons/sourcemod/scripting/basecommands/kick.sp',
'addons/sourcemod/scripting/basecommands/map.sp',
'addons/sourcemod/scripting/basecommands/reloadadmins.sp',
'addons/sourcemod/scripting/basecommands/who.sp',
'addons/sourcemod/scripting/basecomm/forwards.sp',
'addons/sourcemod/scripting/basecomm/gag.sp',
'addons/sourcemod/scripting/basecomm/natives.sp',
'addons/sourcemod/scripting/basetriggers.sp',
'addons/sourcemod/scripting/basevotes.sp',
'addons/sourcemod/scripting/basevotes/voteban.sp',
'addons/sourcemod/scripting/basevotes/votekick.sp',
'addons/sourcemod/scripting/basevotes/votemap.sp',
'addons/sourcemod/scripting/clientprefs.sp',
'addons/sourcemod/scripting/compile.exe',
'addons/sourcemod/scripting/funcommands.sp',
'addons/sourcemod/scripting/funcommands/beacon.sp',
'addons/sourcemod/scripting/funcommands/blind.sp',
'addons/sourcemod/scripting/funcommands/drug.sp',
'addons/sourcemod/scripting/funcommands/fire.sp',
'addons/sourcemod/scripting/funcommands/gravity.sp',
'addons/sourcemod/scripting/funcommands/ice.sp',
'addons/sourcemod/scripting/funcommands/noclip.sp',
'addons/sourcemod/scripting/funcommands/timebomb.sp',
'addons/sourcemod/scripting/funvotes.sp',
'addons/sourcemod/scripting/funvotes/votealltalk.sp',
'addons/sourcemod/scripting/funvotes/voteburn.sp',
'addons/sourcemod/scripting/funvotes/voteff.sp',
'addons/sourcemod/scripting/funvotes/votegravity.sp',
'addons/sourcemod/scripting/funvotes/voteslay.sp',
'addons/sourcemod/scripting/include/admin.inc',
'addons/sourcemod/scripting/include/adminmenu.inc',
'addons/sourcemod/scripting/include/adt.inc',
'addons/sourcemod/scripting/include/adt_array.inc',
'addons/sourcemod/scripting/include/adt_stack.inc',
'addons/sourcemod/scripting/include/adt_trie.inc',
'addons/sourcemod/scripting/include/banning.inc',
'addons/sourcemod/scripting/include/basecomm.inc',
'addons/sourcemod/scripting/include/bitbuffer.inc',
'addons/sourcemod/scripting/include/clientprefs.inc',
'addons/sourcemod/scripting/include/clients.inc',
'addons/sourcemod/scripting/include/commandfilters.inc',
'addons/sourcemod/scripting/include/commandline.inc',
'addons/sourcemod/scripting/include/console.inc',
'addons/sourcemod/scripting/include/convars.inc',
'addons/sourcemod/scripting/include/core.inc',
'addons/sourcemod/scripting/include/cstrike.inc',
'addons/sourcemod/scripting/include/datapack.inc',
'addons/sourcemod/scripting/include/dbi.inc',
'addons/sourcemod/scripting/include/entity.inc',
'addons/sourcemod/scripting/include/entity_prop_stocks.inc',
'addons/sourcemod/scripting/include/events.inc',
'addons/sourcemod/scripting/include/files.inc',
'addons/sourcemod/scripting/include/float.inc',
'addons/sourcemod/scripting/include/functions.inc',
'addons/sourcemod/scripting/include/geoip.inc',
'addons/sourcemod/scripting/include/halflife.inc',
'addons/sourcemod/scripting/include/handles.inc',
'addons/sourcemod/scripting/include/helpers.inc',
'addons/sourcemod/scripting/include/keyvalues.inc',
'addons/sourcemod/scripting/include/lang.inc',
'addons/sourcemod/scripting/include/logging.inc',
'addons/sourcemod/scripting/include/mapchooser.inc',
'addons/sourcemod/scripting/include/menus.inc',
'addons/sourcemod/scripting/include/nextmap.inc',
'addons/sourcemod/scripting/include/profiler.inc',
'addons/sourcemod/scripting/include/protobuf.inc',
'addons/sourcemod/scripting/include/regex.inc',
'addons/sourcemod/scripting/include/sdkhooks.inc',
'addons/sourcemod/scripting/include/sdktools.inc',
'addons/sourcemod/scripting/include/sdktools_client.inc',
'addons/sourcemod/scripting/include/sdktools_engine.inc',
'addons/sourcemod/scripting/include/sdktools_entinput.inc',
'addons/sourcemod/scripting/include/sdktools_entoutput.inc',
'addons/sourcemod/scripting/include/sdktools_functions.inc',
'addons/sourcemod/scripting/include/sdktools_gamerules.inc',
'addons/sourcemod/scripting/include/sdktools_hooks.inc',
'addons/sourcemod/scripting/include/sdktools_sound.inc',
'addons/sourcemod/scripting/include/sdktools_stocks.inc',
'addons/sourcemod/scripting/include/sdktools_stringtables.inc',
'addons/sourcemod/scripting/include/sdktools_tempents.inc',
'addons/sourcemod/scripting/include/sdktools_tempents_stocks.inc',
'addons/sourcemod/scripting/include/sdktools_trace.inc',
'addons/sourcemod/scripting/include/sdktools_variant_t.inc',
'addons/sourcemod/scripting/include/sdktools_voice.inc',
'addons/sourcemod/scripting/include/sorting.inc',
'addons/sourcemod/scripting/include/sourcemod.inc',
'addons/sourcemod/scripting/include/string.inc',
'addons/sourcemod/scripting/include/testing.inc',
'addons/sourcemod/scripting/include/textparse.inc',
'addons/sourcemod/scripting/include/tf2.inc',
'addons/sourcemod/scripting/include/tf2_stocks.inc',
'addons/sourcemod/scripting/include/timers.inc',
'addons/sourcemod/scripting/include/topmenus.inc',
'addons/sourcemod/scripting/include/usermessages.inc',
'addons/sourcemod/scripting/include/vector.inc',
'addons/sourcemod/scripting/include/version.inc',
'addons/sourcemod/scripting/include/version_auto.inc',
'addons/sourcemod/scripting/mapchooser.sp',
'addons/sourcemod/scripting/nextmap.sp',
'addons/sourcemod/scripting/nominations.sp',
'addons/sourcemod/scripting/playercommands.sp',
'addons/sourcemod/scripting/playercommands/rename.sp',
'addons/sourcemod/scripting/playercommands/slap.sp',
'addons/sourcemod/scripting/playercommands/slay.sp',
'addons/sourcemod/scripting/randomcycle.sp',
'addons/sourcemod/scripting/reservedslots.sp',
'addons/sourcemod/scripting/rockthevote.sp',
'addons/sourcemod/scripting/sounds.sp',
'addons/sourcemod/scripting/spcomp.exe',
'addons/sourcemod/scripting/sql-admin-manager.sp',
'addons/sourcemod/scripting/testsuite/benchmark.sp',
'addons/sourcemod/scripting/testsuite/bug4059.sp',
'addons/sourcemod/scripting/testsuite/callfunctest.sp',
'addons/sourcemod/scripting/testsuite/capstest.sp',
'addons/sourcemod/scripting/testsuite/clientprefstest.sp',
'addons/sourcemod/scripting/testsuite/cstrike-test.sp',
'addons/sourcemod/scripting/testsuite/entpropelements.sp',
'addons/sourcemod/scripting/testsuite/fakenative1.sp',
'addons/sourcemod/scripting/testsuite/fakenative2.sp',
'addons/sourcemod/scripting/testsuite/filetest.sp',
'addons/sourcemod/scripting/testsuite/fwdtest1.sp',
'addons/sourcemod/scripting/testsuite/fwdtest2.sp',
'addons/sourcemod/scripting/testsuite/gamerules-props.sp',
'addons/sourcemod/scripting/testsuite/goto_test.sp',
'addons/sourcemod/scripting/testsuite/keyvalues.sp',
'addons/sourcemod/scripting/testsuite/outputtest.sp',
'addons/sourcemod/scripting/testsuite/ptstest.sp',
'addons/sourcemod/scripting/testsuite/sorttest.sp',
'addons/sourcemod/scripting/testsuite/sqltest.sp',
'addons/sourcemod/scripting/testsuite/sqltest.sql',
'addons/sourcemod/scripting/testsuite/stacktest.sp',
'addons/sourcemod/scripting/testsuite/structtest.sp',
'addons/sourcemod/scripting/testsuite/tf2-test.sp',
'addons/sourcemod/scripting/testsuite/tries.sp',
'addons/sourcemod/translations/adminhelp.phrases.txt',
'addons/sourcemod/translations/adminmenu.phrases.txt',
'addons/sourcemod/translations/antiflood.phrases.txt',
'addons/sourcemod/translations/ar/adminhelp.phrases.txt',
'addons/sourcemod/translations/ar/adminmenu.phrases.txt',
'addons/sourcemod/translations/ar/antiflood.phrases.txt',
'addons/sourcemod/translations/ar/basebans.phrases.txt',
'addons/sourcemod/translations/ar/basecomm.phrases.txt',
'addons/sourcemod/translations/ar/basetriggers.phrases.txt',
'addons/sourcemod/translations/ar/basevotes.phrases.txt',
'addons/sourcemod/translations/ar/clientprefs.phrases.txt',
'addons/sourcemod/translations/ar/common.phrases.txt',
'addons/sourcemod/translations/ar/core.phrases.txt',
'addons/sourcemod/translations/ar/funcommands.phrases.txt',
'addons/sourcemod/translations/ar/funvotes.phrases.txt',
'addons/sourcemod/translations/ar/mapchooser.phrases.txt',
'addons/sourcemod/translations/ar/nextmap.phrases.txt',
'addons/sourcemod/translations/ar/nominations.phrases.txt',
'addons/sourcemod/translations/ar/playercommands.phrases.txt',
'addons/sourcemod/translations/ar/plugin.basecommands.txt',
'addons/sourcemod/translations/ar/reservedslots.phrases.txt',
'addons/sourcemod/translations/ar/rockthevote.phrases.txt',
'addons/sourcemod/translations/ar/sounds.phrases.txt',
'addons/sourcemod/translations/ar/sqladmins.phrases.txt',
'addons/sourcemod/translations/basebans.phrases.txt',
'addons/sourcemod/translations/basecomm.phrases.txt',
'addons/sourcemod/translations/basetriggers.phrases.txt',
'addons/sourcemod/translations/basevotes.phrases.txt',
'addons/sourcemod/translations/bg/adminhelp.phrases.txt',
'addons/sourcemod/translations/bg/adminmenu.phrases.txt',
'addons/sourcemod/translations/bg/antiflood.phrases.txt',
'addons/sourcemod/translations/bg/basebans.phrases.txt',
'addons/sourcemod/translations/bg/basecomm.phrases.txt',
'addons/sourcemod/translations/bg/basetriggers.phrases.txt',
'addons/sourcemod/translations/bg/basevotes.phrases.txt',
'addons/sourcemod/translations/bg/clientprefs.phrases.txt',
'addons/sourcemod/translations/bg/common.phrases.txt',
'addons/sourcemod/translations/bg/core.phrases.txt',
'addons/sourcemod/translations/bg/funcommands.phrases.txt',
'addons/sourcemod/translations/bg/funvotes.phrases.txt',
'addons/sourcemod/translations/bg/mapchooser.phrases.txt',
'addons/sourcemod/translations/bg/nextmap.phrases.txt',
'addons/sourcemod/translations/bg/nominations.phrases.txt',
'addons/sourcemod/translations/bg/playercommands.phrases.txt',
'addons/sourcemod/translations/bg/plugin.basecommands.txt',
'addons/sourcemod/translations/bg/reservedslots.phrases.txt',
'addons/sourcemod/translations/bg/rockthevote.phrases.txt',
'addons/sourcemod/translations/bg/sounds.phrases.txt',
'addons/sourcemod/translations/bg/sqladmins.phrases.txt',
'addons/sourcemod/translations/chi/adminhelp.phrases.txt',
'addons/sourcemod/translations/chi/adminmenu.phrases.txt',
'addons/sourcemod/translations/chi/antiflood.phrases.txt',
'addons/sourcemod/translations/chi/basebans.phrases.txt',
'addons/sourcemod/translations/chi/basecomm.phrases.txt',
'addons/sourcemod/translations/chi/basetriggers.phrases.txt',
'addons/sourcemod/translations/chi/basevotes.phrases.txt',
'addons/sourcemod/translations/chi/clientprefs.phrases.txt',
'addons/sourcemod/translations/chi/common.phrases.txt',
'addons/sourcemod/translations/chi/core.phrases.txt',
'addons/sourcemod/translations/chi/funcommands.phrases.txt',
'addons/sourcemod/translations/chi/funvotes.phrases.txt',
'addons/sourcemod/translations/chi/mapchooser.phrases.txt',
'addons/sourcemod/translations/chi/nextmap.phrases.txt',
'addons/sourcemod/translations/chi/nominations.phrases.txt',
'addons/sourcemod/translations/chi/playercommands.phrases.txt',
'addons/sourcemod/translations/chi/plugin.basecommands.txt',
'addons/sourcemod/translations/chi/reservedslots.phrases.txt',
'addons/sourcemod/translations/chi/rockthevote.phrases.txt',
'addons/sourcemod/translations/chi/slapslay.phrases.txt',
'addons/sourcemod/translations/chi/sounds.phrases.txt',
'addons/sourcemod/translations/chi/sqladmins.phrases.txt',
'addons/sourcemod/translations/clientprefs.phrases.txt',
'addons/sourcemod/translations/common.phrases.txt',
'addons/sourcemod/translations/core.phrases.txt',
'addons/sourcemod/translations/cze/adminhelp.phrases.txt',
'addons/sourcemod/translations/cze/adminmenu.phrases.txt',
'addons/sourcemod/translations/cze/antiflood.phrases.txt',
'addons/sourcemod/translations/cze/basebans.phrases.txt',
'addons/sourcemod/translations/cze/basecomm.phrases.txt',
'addons/sourcemod/translations/cze/basetriggers.phrases.txt',
'addons/sourcemod/translations/cze/basevotes.phrases.txt',
'addons/sourcemod/translations/cze/clientprefs.phrases.txt',
'addons/sourcemod/translations/cze/common.phrases.txt',
'addons/sourcemod/translations/cze/core.phrases.txt',
'addons/sourcemod/translations/cze/funcommands.phrases.txt',
'addons/sourcemod/translations/cze/funvotes.phrases.txt',
'addons/sourcemod/translations/cze/mapchooser.phrases.txt',
'addons/sourcemod/translations/cze/nextmap.phrases.txt',
'addons/sourcemod/translations/cze/nominations.phrases.txt',
'addons/sourcemod/translations/cze/playercommands.phrases.txt',
'addons/sourcemod/translations/cze/plugin.basecommands.txt',
'addons/sourcemod/translations/cze/reservedslots.phrases.txt',
'addons/sourcemod/translations/cze/rockthevote.phrases.txt',
'addons/sourcemod/translations/cze/sounds.phrases.txt',
'addons/sourcemod/translations/cze/sqladmins.phrases.txt',
'addons/sourcemod/translations/da/adminhelp.phrases.txt',
'addons/sourcemod/translations/da/adminmenu.phrases.txt',
'addons/sourcemod/translations/da/antiflood.phrases.txt',
'addons/sourcemod/translations/da/basebans.phrases.txt',
'addons/sourcemod/translations/da/basecomm.phrases.txt',
'addons/sourcemod/translations/da/basetriggers.phrases.txt',
'addons/sourcemod/translations/da/basevotes.phrases.txt',
'addons/sourcemod/translations/da/clientprefs.phrases.txt',
'addons/sourcemod/translations/da/common.phrases.txt',
'addons/sourcemod/translations/da/core.phrases.txt',
'addons/sourcemod/translations/da/funcommands.phrases.txt',
'addons/sourcemod/translations/da/funvotes.phrases.txt',
'addons/sourcemod/translations/da/mapchooser.phrases.txt',
'addons/sourcemod/translations/da/nextmap.phrases.txt',
'addons/sourcemod/translations/da/nominations.phrases.txt',
'addons/sourcemod/translations/da/playercommands.phrases.txt',
'addons/sourcemod/translations/da/plugin.basecommands.txt',
'addons/sourcemod/translations/da/reservedslots.phrases.txt',
'addons/sourcemod/translations/da/rockthevote.phrases.txt',
'addons/sourcemod/translations/da/slapslay.phrases.txt',
'addons/sourcemod/translations/da/sounds.phrases.txt',
'addons/sourcemod/translations/da/sqladmins.phrases.txt',
'addons/sourcemod/translations/de/adminhelp.phrases.txt',
'addons/sourcemod/translations/de/adminmenu.phrases.txt',
'addons/sourcemod/translations/de/antiflood.phrases.txt',
'addons/sourcemod/translations/de/basebans.phrases.txt',
'addons/sourcemod/translations/de/basecomm.phrases.txt',
'addons/sourcemod/translations/de/basetriggers.phrases.txt',
'addons/sourcemod/translations/de/basevotes.phrases.txt',
'addons/sourcemod/translations/de/clientprefs.phrases.txt',
'addons/sourcemod/translations/de/common.phrases.txt',
'addons/sourcemod/translations/de/core.phrases.txt',
'addons/sourcemod/translations/de/funcommands.phrases.txt',
'addons/sourcemod/translations/de/funvotes.phrases.txt',
'addons/sourcemod/translations/de/mapchooser.phrases.txt',
'addons/sourcemod/translations/de/nextmap.phrases.txt',
'addons/sourcemod/translations/de/nominations.phrases.txt',
'addons/sourcemod/translations/de/playercommands.phrases.txt',
'addons/sourcemod/translations/de/plugin.basecommands.txt',
'addons/sourcemod/translations/de/reservedslots.phrases.txt',
'addons/sourcemod/translations/de/rockthevote.phrases.txt',
'addons/sourcemod/translations/de/slapslay.phrases.txt',
'addons/sourcemod/translations/de/sounds.phrases.txt',
'addons/sourcemod/translations/de/sqladmins.phrases.txt',
'addons/sourcemod/translations/el/adminhelp.phrases.txt',
'addons/sourcemod/translations/el/adminmenu.phrases.txt',
'addons/sourcemod/translations/el/antiflood.phrases.txt',
'addons/sourcemod/translations/el/basebans.phrases.txt',
'addons/sourcemod/translations/el/basecomm.phrases.txt',
'addons/sourcemod/translations/el/basetriggers.phrases.txt',
'addons/sourcemod/translations/el/basevotes.phrases.txt',
'addons/sourcemod/translations/el/clientprefs.phrases.txt',
'addons/sourcemod/translations/el/common.phrases.txt',
'addons/sourcemod/translations/el/core.phrases.txt',
'addons/sourcemod/translations/el/funcommands.phrases.txt',
'addons/sourcemod/translations/el/funvotes.phrases.txt',
'addons/sourcemod/translations/el/mapchooser.phrases.txt',
'addons/sourcemod/translations/el/nextmap.phrases.txt',
'addons/sourcemod/translations/el/nominations.phrases.txt',
'addons/sourcemod/translations/el/playercommands.phrases.txt',
'addons/sourcemod/translations/el/plugin.basecommands.txt',
'addons/sourcemod/translations/el/reservedslots.phrases.txt',
'addons/sourcemod/translations/el/rockthevote.phrases.txt',
'addons/sourcemod/translations/el/sounds.phrases.txt',
'addons/sourcemod/translations/el/sqladmins.phrases.txt',
'addons/sourcemod/translations/es/adminhelp.phrases.txt',
'addons/sourcemod/translations/es/adminmenu.phrases.txt',
'addons/sourcemod/translations/es/antiflood.phrases.txt',
'addons/sourcemod/translations/es/basebans.phrases.txt',
'addons/sourcemod/translations/es/basecomm.phrases.txt',
'addons/sourcemod/translations/es/basetriggers.phrases.txt',
'addons/sourcemod/translations/es/basevotes.phrases.txt',
'addons/sourcemod/translations/es/clientprefs.phrases.txt',
'addons/sourcemod/translations/es/common.phrases.txt',
'addons/sourcemod/translations/es/core.phrases.txt',
'addons/sourcemod/translations/es/funcommands.phrases.txt',
'addons/sourcemod/translations/es/funvotes.phrases.txt',
'addons/sourcemod/translations/es/mapchooser.phrases.txt',
'addons/sourcemod/translations/es/nextmap.phrases.txt',
'addons/sourcemod/translations/es/nominations.phrases.txt',
'addons/sourcemod/translations/es/playercommands.phrases.txt',
'addons/sourcemod/translations/es/plugin.basecommands.txt',
'addons/sourcemod/translations/es/reservedslots.phrases.txt',
'addons/sourcemod/translations/es/rockthevote.phrases.txt',
'addons/sourcemod/translations/es/slapslay.phrases.txt',
'addons/sourcemod/translations/es/sounds.phrases.txt',
'addons/sourcemod/translations/es/sqladmins.phrases.txt',
'addons/sourcemod/translations/fi/adminhelp.phrases.txt',
'addons/sourcemod/translations/fi/adminmenu.phrases.txt',
'addons/sourcemod/translations/fi/antiflood.phrases.txt',
'addons/sourcemod/translations/fi/basebans.phrases.txt',
'addons/sourcemod/translations/fi/basecomm.phrases.txt',
'addons/sourcemod/translations/fi/basetriggers.phrases.txt',
'addons/sourcemod/translations/fi/basevotes.phrases.txt',
'addons/sourcemod/translations/fi/clientprefs.phrases.txt',
'addons/sourcemod/translations/fi/common.phrases.txt',
'addons/sourcemod/translations/fi/core.phrases.txt',
'addons/sourcemod/translations/fi/funcommands.phrases.txt',
'addons/sourcemod/translations/fi/funvotes.phrases.txt',
'addons/sourcemod/translations/fi/mapchooser.phrases.txt',
'addons/sourcemod/translations/fi/nextmap.phrases.txt',
'addons/sourcemod/translations/fi/nominations.phrases.txt',
'addons/sourcemod/translations/fi/playercommands.phrases.txt',
'addons/sourcemod/translations/fi/plugin.basecommands.txt',
'addons/sourcemod/translations/fi/reservedslots.phrases.txt',
'addons/sourcemod/translations/fi/rockthevote.phrases.txt',
'addons/sourcemod/translations/fi/sounds.phrases.txt',
'addons/sourcemod/translations/fi/sqladmins.phrases.txt',
'addons/sourcemod/translations/fr/adminhelp.phrases.txt',
'addons/sourcemod/translations/fr/adminmenu.phrases.txt',
'addons/sourcemod/translations/fr/antiflood.phrases.txt',
'addons/sourcemod/translations/fr/basebans.phrases.txt',
'addons/sourcemod/translations/fr/basecomm.phrases.txt',
'addons/sourcemod/translations/fr/basetriggers.phrases.txt',
'addons/sourcemod/translations/fr/basevotes.phrases.txt',
'addons/sourcemod/translations/fr/clientprefs.phrases.txt',
'addons/sourcemod/translations/fr/common.phrases.txt',
'addons/sourcemod/translations/fr/core.phrases.txt',
'addons/sourcemod/translations/fr/funcommands.phrases.txt',
'addons/sourcemod/translations/fr/funvotes.phrases.txt',
'addons/sourcemod/translations/fr/mapchooser.phrases.txt',
'addons/sourcemod/translations/fr/nextmap.phrases.txt',
'addons/sourcemod/translations/fr/nominations.phrases.txt',
'addons/sourcemod/translations/fr/playercommands.phrases.txt',
'addons/sourcemod/translations/fr/plugin.basecommands.txt',
'addons/sourcemod/translations/fr/reservedslots.phrases.txt',
'addons/sourcemod/translations/fr/rockthevote.phrases.txt',
'addons/sourcemod/translations/fr/slapslay.phrases.txt',
'addons/sourcemod/translations/fr/sounds.phrases.txt',
'addons/sourcemod/translations/fr/sqladmins.phrases.txt',
'addons/sourcemod/translations/funcommands.phrases.txt',
'addons/sourcemod/translations/funvotes.phrases.txt',
'addons/sourcemod/translations/he/adminhelp.phrases.txt',
'addons/sourcemod/translations/he/adminmenu.phrases.txt',
'addons/sourcemod/translations/he/antiflood.phrases.txt',
'addons/sourcemod/translations/he/basebans.phrases.txt',
'addons/sourcemod/translations/he/basecomm.phrases.txt',
'addons/sourcemod/translations/he/basetriggers.phrases.txt',
'addons/sourcemod/translations/he/basevotes.phrases.txt',
'addons/sourcemod/translations/he/clientprefs.phrases.txt',
'addons/sourcemod/translations/he/common.phrases.txt',
'addons/sourcemod/translations/he/core.phrases.txt',
'addons/sourcemod/translations/he/funcommands.phrases.txt',
'addons/sourcemod/translations/he/funvotes.phrases.txt',
'addons/sourcemod/translations/he/mapchooser.phrases.txt',
'addons/sourcemod/translations/he/nextmap.phrases.txt',
'addons/sourcemod/translations/he/nominations.phrases.txt',
'addons/sourcemod/translations/he/playercommands.phrases.txt',
'addons/sourcemod/translations/he/plugin.basecommands.txt',
'addons/sourcemod/translations/he/reservedslots.phrases.txt',
'addons/sourcemod/translations/he/rockthevote.phrases.txt',
'addons/sourcemod/translations/he/sounds.phrases.txt',
'addons/sourcemod/translations/he/sqladmins.phrases.txt',
'addons/sourcemod/translations/hu/adminhelp.phrases.txt',
'addons/sourcemod/translations/hu/adminmenu.phrases.txt',
'addons/sourcemod/translations/hu/antiflood.phrases.txt',
'addons/sourcemod/translations/hu/basebans.phrases.txt',
'addons/sourcemod/translations/hu/basecomm.phrases.txt',
'addons/sourcemod/translations/hu/basetriggers.phrases.txt',
'addons/sourcemod/translations/hu/basevotes.phrases.txt',
'addons/sourcemod/translations/hu/clientprefs.phrases.txt',
'addons/sourcemod/translations/hu/common.phrases.txt',
'addons/sourcemod/translations/hu/core.phrases.txt',
'addons/sourcemod/translations/hu/funcommands.phrases.txt',
'addons/sourcemod/translations/hu/funvotes.phrases.txt',
'addons/sourcemod/translations/hu/mapchooser.phrases.txt',
'addons/sourcemod/translations/hu/nextmap.phrases.txt',
'addons/sourcemod/translations/hu/nominations.phrases.txt',
'addons/sourcemod/translations/hu/playercommands.phrases.txt',
'addons/sourcemod/translations/hu/plugin.basecommands.txt',
'addons/sourcemod/translations/hu/reservedslots.phrases.txt',
'addons/sourcemod/translations/hu/rockthevote.phrases.txt',
'addons/sourcemod/translations/hu/slapslay.phrases.txt',
'addons/sourcemod/translations/hu/sounds.phrases.txt',
'addons/sourcemod/translations/hu/sqladmins.phrases.txt',
'addons/sourcemod/translations/it/adminhelp.phrases.txt',
'addons/sourcemod/translations/it/adminmenu.phrases.txt',
'addons/sourcemod/translations/it/antiflood.phrases.txt',
'addons/sourcemod/translations/it/basebans.phrases.txt',
'addons/sourcemod/translations/it/basecomm.phrases.txt',
'addons/sourcemod/translations/it/basetriggers.phrases.txt',
'addons/sourcemod/translations/it/basevotes.phrases.txt',
'addons/sourcemod/translations/it/clientprefs.phrases.txt',
'addons/sourcemod/translations/it/common.phrases.txt',
'addons/sourcemod/translations/it/core.phrases.txt',
'addons/sourcemod/translations/it/funcommands.phrases.txt',
'addons/sourcemod/translations/it/funvotes.phrases.txt',
'addons/sourcemod/translations/it/mapchooser.phrases.txt',
'addons/sourcemod/translations/it/nextmap.phrases.txt',
'addons/sourcemod/translations/it/nominations.phrases.txt',
'addons/sourcemod/translations/it/playercommands.phrases.txt',
'addons/sourcemod/translations/it/plugin.basecommands.txt',
'addons/sourcemod/translations/it/reservedslots.phrases.txt',
'addons/sourcemod/translations/it/rockthevote.phrases.txt',
'addons/sourcemod/translations/it/sounds.phrases.txt',
'addons/sourcemod/translations/it/sqladmins.phrases.txt',
'addons/sourcemod/translations/jp/adminhelp.phrases.txt',
'addons/sourcemod/translations/jp/adminmenu.phrases.txt',
'addons/sourcemod/translations/jp/antiflood.phrases.txt',
'addons/sourcemod/translations/jp/basebans.phrases.txt',
'addons/sourcemod/translations/jp/basecomm.phrases.txt',
'addons/sourcemod/translations/jp/basetriggers.phrases.txt',
'addons/sourcemod/translations/jp/basevotes.phrases.txt',
'addons/sourcemod/translations/jp/clientprefs.phrases.txt',
'addons/sourcemod/translations/jp/common.phrases.txt',
'addons/sourcemod/translations/jp/core.phrases.txt',
'addons/sourcemod/translations/jp/funcommands.phrases.txt',
'addons/sourcemod/translations/jp/funvotes.phrases.txt',
'addons/sourcemod/translations/jp/mapchooser.phrases.txt',
'addons/sourcemod/translations/jp/nextmap.phrases.txt',
'addons/sourcemod/translations/jp/nominations.phrases.txt',
'addons/sourcemod/translations/jp/playercommands.phrases.txt',
'addons/sourcemod/translations/jp/plugin.basecommands.txt',
'addons/sourcemod/translations/jp/reservedslots.phrases.txt',
'addons/sourcemod/translations/jp/rockthevote.phrases.txt',
'addons/sourcemod/translations/jp/slapslay.phrases.txt',
'addons/sourcemod/translations/jp/sounds.phrases.txt',
'addons/sourcemod/translations/jp/sqladmins.phrases.txt',
'addons/sourcemod/translations/ko/adminhelp.phrases.txt',
'addons/sourcemod/translations/ko/adminmenu.phrases.txt',
'addons/sourcemod/translations/ko/antiflood.phrases.txt',
'addons/sourcemod/translations/ko/basebans.phrases.txt',
'addons/sourcemod/translations/ko/basecomm.phrases.txt',
'addons/sourcemod/translations/ko/basetriggers.phrases.txt',
'addons/sourcemod/translations/ko/basevotes.phrases.txt',
'addons/sourcemod/translations/ko/clientprefs.phrases.txt',
'addons/sourcemod/translations/ko/common.phrases.txt',
'addons/sourcemod/translations/ko/core.phrases.txt',
'addons/sourcemod/translations/ko/funcommands.phrases.txt',
'addons/sourcemod/translations/ko/funvotes.phrases.txt',
'addons/sourcemod/translations/ko/mapchooser.phrases.txt',
'addons/sourcemod/translations/ko/nextmap.phrases.txt',
'addons/sourcemod/translations/ko/nominations.phrases.txt',
'addons/sourcemod/translations/ko/playercommands.phrases.txt',
'addons/sourcemod/translations/ko/plugin.basecommands.txt',
'addons/sourcemod/translations/ko/reservedslots.phrases.txt',
'addons/sourcemod/translations/ko/rockthevote.phrases.txt',
'addons/sourcemod/translations/ko/sounds.phrases.txt',
'addons/sourcemod/translations/ko/sqladmins.phrases.txt',
'addons/sourcemod/translations/lt/adminhelp.phrases.txt',
'addons/sourcemod/translations/lt/adminmenu.phrases.txt',
'addons/sourcemod/translations/lt/antiflood.phrases.txt',
'addons/sourcemod/translations/lt/basebans.phrases.txt',
'addons/sourcemod/translations/lt/basecomm.phrases.txt',
'addons/sourcemod/translations/lt/basetriggers.phrases.txt',
'addons/sourcemod/translations/lt/basevotes.phrases.txt',
'addons/sourcemod/translations/lt/clientprefs.phrases.txt',
'addons/sourcemod/translations/lt/common.phrases.txt',
'addons/sourcemod/translations/lt/core.phrases.txt',
'addons/sourcemod/translations/lt/funcommands.phrases.txt',
'addons/sourcemod/translations/lt/funvotes.phrases.txt',
'addons/sourcemod/translations/lt/mapchooser.phrases.txt',
'addons/sourcemod/translations/lt/nextmap.phrases.txt',
'addons/sourcemod/translations/lt/nominations.phrases.txt',
'addons/sourcemod/translations/lt/playercommands.phrases.txt',
'addons/sourcemod/translations/lt/plugin.basecommands.txt',
'addons/sourcemod/translations/lt/reservedslots.phrases.txt',
'addons/sourcemod/translations/lt/rockthevote.phrases.txt',
'addons/sourcemod/translations/lt/sounds.phrases.txt',
'addons/sourcemod/translations/lt/sqladmins.phrases.txt',
'addons/sourcemod/translations/lv/adminhelp.phrases.txt',
'addons/sourcemod/translations/lv/adminmenu.phrases.txt',
'addons/sourcemod/translations/lv/antiflood.phrases.txt',
'addons/sourcemod/translations/lv/basebans.phrases.txt',
'addons/sourcemod/translations/lv/basecomm.phrases.txt',
'addons/sourcemod/translations/lv/basetriggers.phrases.txt',
'addons/sourcemod/translations/lv/basevotes.phrases.txt',
'addons/sourcemod/translations/lv/clientprefs.phrases.txt',
'addons/sourcemod/translations/lv/common.phrases.txt',
'addons/sourcemod/translations/lv/core.phrases.txt',
'addons/sourcemod/translations/lv/funcommands.phrases.txt',
'addons/sourcemod/translations/lv/funvotes.phrases.txt',
'addons/sourcemod/translations/lv/mapchooser.phrases.txt',
'addons/sourcemod/translations/lv/nextmap.phrases.txt',
'addons/sourcemod/translations/lv/nominations.phrases.txt',
'addons/sourcemod/translations/lv/playercommands.phrases.txt',
'addons/sourcemod/translations/lv/plugin.basecommands.txt',
'addons/sourcemod/translations/lv/reservedslots.phrases.txt',
'addons/sourcemod/translations/lv/rockthevote.phrases.txt',
'addons/sourcemod/translations/lv/slapslay.phrases.txt',
'addons/sourcemod/translations/lv/sounds.phrases.txt',
'addons/sourcemod/translations/lv/sqladmins.phrases.txt',
'addons/sourcemod/translations/mapchooser.phrases.txt',
'addons/sourcemod/translations/nextmap.phrases.txt',
'addons/sourcemod/translations/nl/adminhelp.phrases.txt',
'addons/sourcemod/translations/nl/adminmenu.phrases.txt',
'addons/sourcemod/translations/nl/antiflood.phrases.txt',
'addons/sourcemod/translations/nl/basebans.phrases.txt',
'addons/sourcemod/translations/nl/basecomm.phrases.txt',
'addons/sourcemod/translations/nl/basetriggers.phrases.txt',
'addons/sourcemod/translations/nl/basevotes.phrases.txt',
'addons/sourcemod/translations/nl/clientprefs.phrases.txt',
'addons/sourcemod/translations/nl/common.phrases.txt',
'addons/sourcemod/translations/nl/core.phrases.txt',
'addons/sourcemod/translations/nl/funcommands.phrases.txt',
'addons/sourcemod/translations/nl/funvotes.phrases.txt',
'addons/sourcemod/translations/nl/mapchooser.phrases.txt',
'addons/sourcemod/translations/nl/nextmap.phrases.txt',
'addons/sourcemod/translations/nl/nominations.phrases.txt',
'addons/sourcemod/translations/nl/playercommands.phrases.txt',
'addons/sourcemod/translations/nl/plugin.basecommands.txt',
'addons/sourcemod/translations/nl/reservedslots.phrases.txt',
'addons/sourcemod/translations/nl/rockthevote.phrases.txt',
'addons/sourcemod/translations/nl/sounds.phrases.txt',
'addons/sourcemod/translations/nl/sqladmins.phrases.txt',
'addons/sourcemod/translations/nominations.phrases.txt',
'addons/sourcemod/translations/no/adminhelp.phrases.txt',
'addons/sourcemod/translations/no/adminmenu.phrases.txt',
'addons/sourcemod/translations/no/antiflood.phrases.txt',
'addons/sourcemod/translations/no/basebans.phrases.txt',
'addons/sourcemod/translations/no/basecomm.phrases.txt',
'addons/sourcemod/translations/no/basetriggers.phrases.txt',
'addons/sourcemod/translations/no/basevotes.phrases.txt',
'addons/sourcemod/translations/no/clientprefs.phrases.txt',
'addons/sourcemod/translations/no/common.phrases.txt',
'addons/sourcemod/translations/no/core.phrases.txt',
'addons/sourcemod/translations/no/funcommands.phrases.txt',
'addons/sourcemod/translations/no/funvotes.phrases.txt',
'addons/sourcemod/translations/no/mapchooser.phrases.txt',
'addons/sourcemod/translations/no/nextmap.phrases.txt',
'addons/sourcemod/translations/no/nominations.phrases.txt',
'addons/sourcemod/translations/no/playercommands.phrases.txt',
'addons/sourcemod/translations/no/plugin.basecommands.txt',
'addons/sourcemod/translations/no/reservedslots.phrases.txt',
'addons/sourcemod/translations/no/rockthevote.phrases.txt',
'addons/sourcemod/translations/no/slapslay.phrases.txt',
'addons/sourcemod/translations/no/sounds.phrases.txt',
'addons/sourcemod/translations/no/sqladmins.phrases.txt',
'addons/sourcemod/translations/playercommands.phrases.txt',
'addons/sourcemod/translations/plugin.basecommands.txt',
'addons/sourcemod/translations/pl/adminhelp.phrases.txt',
'addons/sourcemod/translations/pl/adminmenu.phrases.txt',
'addons/sourcemod/translations/pl/antiflood.phrases.txt',
'addons/sourcemod/translations/pl/basebans.phrases.txt',
'addons/sourcemod/translations/pl/basecomm.phrases.txt',
'addons/sourcemod/translations/pl/basetriggers.phrases.txt',
'addons/sourcemod/translations/pl/basevotes.phrases.txt',
'addons/sourcemod/translations/pl/clientprefs.phrases.txt',
'addons/sourcemod/translations/pl/common.phrases.txt',
'addons/sourcemod/translations/pl/core.phrases.txt',
'addons/sourcemod/translations/pl/funcommands.phrases.txt',
'addons/sourcemod/translations/pl/funvotes.phrases.txt',
'addons/sourcemod/translations/pl/mapchooser.phrases.txt',
'addons/sourcemod/translations/pl/nextmap.phrases.txt',
'addons/sourcemod/translations/pl/nominations.phrases.txt',
'addons/sourcemod/translations/pl/playercommands.phrases.txt',
'addons/sourcemod/translations/pl/plugin.basecommands.txt',
'addons/sourcemod/translations/pl/reservedslots.phrases.txt',
'addons/sourcemod/translations/pl/rockthevote.phrases.txt',
'addons/sourcemod/translations/pl/slapslay.phrases.txt',
'addons/sourcemod/translations/pl/sounds.phrases.txt',
'addons/sourcemod/translations/pl/sqladmins.phrases.txt',
'addons/sourcemod/translations/pt/adminhelp.phrases.txt',
'addons/sourcemod/translations/pt/adminmenu.phrases.txt',
'addons/sourcemod/translations/pt/antiflood.phrases.txt',
'addons/sourcemod/translations/pt/basebans.phrases.txt',
'addons/sourcemod/translations/pt/basecomm.phrases.txt',
'addons/sourcemod/translations/pt/basetriggers.phrases.txt',
'addons/sourcemod/translations/pt/basevotes.phrases.txt',
'addons/sourcemod/translations/pt/clientprefs.phrases.txt',
'addons/sourcemod/translations/pt/common.phrases.txt',
'addons/sourcemod/translations/pt/core.phrases.txt',
'addons/sourcemod/translations/pt/funcommands.phrases.txt',
'addons/sourcemod/translations/pt/funvotes.phrases.txt',
'addons/sourcemod/translations/pt/mapchooser.phrases.txt',
'addons/sourcemod/translations/pt/nextmap.phrases.txt',
'addons/sourcemod/translations/pt/nominations.phrases.txt',
'addons/sourcemod/translations/pt/playercommands.phrases.txt',
'addons/sourcemod/translations/pt/plugin.basecommands.txt',
'addons/sourcemod/translations/pt/reservedslots.phrases.txt',
'addons/sourcemod/translations/pt/rockthevote.phrases.txt',
'addons/sourcemod/translations/pt/slapslay.phrases.txt',
'addons/sourcemod/translations/pt/sounds.phrases.txt',
'addons/sourcemod/translations/pt/sqladmins.phrases.txt',
'addons/sourcemod/translations/pt_p/adminhelp.phrases.txt',
'addons/sourcemod/translations/pt_p/adminmenu.phrases.txt',
'addons/sourcemod/translations/pt_p/antiflood.phrases.txt',
'addons/sourcemod/translations/pt_p/basebans.phrases.txt',
'addons/sourcemod/translations/pt_p/basecomm.phrases.txt',
'addons/sourcemod/translations/pt_p/basetriggers.phrases.txt',
'addons/sourcemod/translations/pt_p/basevotes.phrases.txt',
'addons/sourcemod/translations/pt_p/clientprefs.phrases.txt',
'addons/sourcemod/translations/pt_p/common.phrases.txt',
'addons/sourcemod/translations/pt_p/core.phrases.txt',
'addons/sourcemod/translations/pt_p/funcommands.phrases.txt',
'addons/sourcemod/translations/pt_p/funvotes.phrases.txt',
'addons/sourcemod/translations/pt_p/mapchooser.phrases.txt',
'addons/sourcemod/translations/pt_p/nextmap.phrases.txt',
'addons/sourcemod/translations/pt_p/nominations.phrases.txt',
'addons/sourcemod/translations/pt_p/playercommands.phrases.txt',
'addons/sourcemod/translations/pt_p/plugin.basecommands.txt',
'addons/sourcemod/translations/pt_p/reservedslots.phrases.txt',
'addons/sourcemod/translations/pt_p/rockthevote.phrases.txt',
'addons/sourcemod/translations/pt_p/sounds.phrases.txt',
'addons/sourcemod/translations/pt_p/sqladmins.phrases.txt',
'addons/sourcemod/translations/reservedslots.phrases.txt',
'addons/sourcemod/translations/rockthevote.phrases.txt',
'addons/sourcemod/translations/ro/adminhelp.phrases.txt',
'addons/sourcemod/translations/ro/adminmenu.phrases.txt',
'addons/sourcemod/translations/ro/antiflood.phrases.txt',
'addons/sourcemod/translations/ro/basebans.phrases.txt',
'addons/sourcemod/translations/ro/basecomm.phrases.txt',
'addons/sourcemod/translations/ro/basetriggers.phrases.txt',
'addons/sourcemod/translations/ro/basevotes.phrases.txt',
'addons/sourcemod/translations/ro/clientprefs.phrases.txt',
'addons/sourcemod/translations/ro/common.phrases.txt',
'addons/sourcemod/translations/ro/core.phrases.txt',
'addons/sourcemod/translations/ro/funcommands.phrases.txt',
'addons/sourcemod/translations/ro/funvotes.phrases.txt',
'addons/sourcemod/translations/ro/mapchooser.phrases.txt',
'addons/sourcemod/translations/ro/nextmap.phrases.txt',
'addons/sourcemod/translations/ro/nominations.phrases.txt',
'addons/sourcemod/translations/ro/playercommands.phrases.txt',
'addons/sourcemod/translations/ro/plugin.basecommands.txt',
'addons/sourcemod/translations/ro/reservedslots.phrases.txt',
'addons/sourcemod/translations/ro/rockthevote.phrases.txt',
'addons/sourcemod/translations/ro/slapslay.phrases.txt',
'addons/sourcemod/translations/ro/sounds.phrases.txt',
'addons/sourcemod/translations/ro/sqladmins.phrases.txt',
'addons/sourcemod/translations/ru/adminhelp.phrases.txt',
'addons/sourcemod/translations/ru/adminmenu.phrases.txt',
'addons/sourcemod/translations/ru/antiflood.phrases.txt',
'addons/sourcemod/translations/ru/basebans.phrases.txt',
'addons/sourcemod/translations/ru/basecomm.phrases.txt',
'addons/sourcemod/translations/ru/basetriggers.phrases.txt',
'addons/sourcemod/translations/ru/basevotes.phrases.txt',
'addons/sourcemod/translations/ru/clientprefs.phrases.txt',
'addons/sourcemod/translations/ru/common.phrases.txt',
'addons/sourcemod/translations/ru/core.phrases.txt',
'addons/sourcemod/translations/ru/funcommands.phrases.txt',
'addons/sourcemod/translations/ru/funvotes.phrases.txt',
'addons/sourcemod/translations/ru/mapchooser.phrases.txt',
'addons/sourcemod/translations/ru/nextmap.phrases.txt',
'addons/sourcemod/translations/ru/nominations.phrases.txt',
'addons/sourcemod/translations/ru/playercommands.phrases.txt',
'addons/sourcemod/translations/ru/plugin.basecommands.txt',
'addons/sourcemod/translations/ru/reservedslots.phrases.txt',
'addons/sourcemod/translations/ru/rockthevote.phrases.txt',
'addons/sourcemod/translations/ru/slapslay.phrases.txt',
'addons/sourcemod/translations/ru/sounds.phrases.txt',
'addons/sourcemod/translations/ru/sqladmins.phrases.txt',
'addons/sourcemod/translations/sk/adminhelp.phrases.txt',
'addons/sourcemod/translations/sk/adminmenu.phrases.txt',
'addons/sourcemod/translations/sk/antiflood.phrases.txt',
'addons/sourcemod/translations/sk/basebans.phrases.txt',
'addons/sourcemod/translations/sk/basecomm.phrases.txt',
'addons/sourcemod/translations/sk/basetriggers.phrases.txt',
'addons/sourcemod/translations/sk/basevotes.phrases.txt',
'addons/sourcemod/translations/sk/clientprefs.phrases.txt',
'addons/sourcemod/translations/sk/common.phrases.txt',
'addons/sourcemod/translations/sk/core.phrases.txt',
'addons/sourcemod/translations/sk/funcommands.phrases.txt',
'addons/sourcemod/translations/sk/funvotes.phrases.txt',
'addons/sourcemod/translations/sk/mapchooser.phrases.txt',
'addons/sourcemod/translations/sk/nextmap.phrases.txt',
'addons/sourcemod/translations/sk/nominations.phrases.txt',
'addons/sourcemod/translations/sk/playercommands.phrases.txt',
'addons/sourcemod/translations/sk/plugin.basecommands.txt',
'addons/sourcemod/translations/sk/reservedslots.phrases.txt',
'addons/sourcemod/translations/sk/rockthevote.phrases.txt',
'addons/sourcemod/translations/sk/sounds.phrases.txt',
'addons/sourcemod/translations/sk/sqladmins.phrases.txt',
'addons/sourcemod/translations/sounds.phrases.txt',
'addons/sourcemod/translations/sqladmins.phrases.txt',
'addons/sourcemod/translations/sv/adminhelp.phrases.txt',
'addons/sourcemod/translations/sv/adminmenu.phrases.txt',
'addons/sourcemod/translations/sv/antiflood.phrases.txt',
'addons/sourcemod/translations/sv/basebans.phrases.txt',
'addons/sourcemod/translations/sv/basecomm.phrases.txt',
'addons/sourcemod/translations/sv/basetriggers.phrases.txt',
'addons/sourcemod/translations/sv/basevotes.phrases.txt',
'addons/sourcemod/translations/sv/clientprefs.phrases.txt',
'addons/sourcemod/translations/sv/common.phrases.txt',
'addons/sourcemod/translations/sv/core.phrases.txt',
'addons/sourcemod/translations/sv/funcommands.phrases.txt',
'addons/sourcemod/translations/sv/funvotes.phrases.txt',
'addons/sourcemod/translations/sv/mapchooser.phrases.txt',
'addons/sourcemod/translations/sv/nextmap.phrases.txt',
'addons/sourcemod/translations/sv/nominations.phrases.txt',
'addons/sourcemod/translations/sv/playercommands.phrases.txt',
'addons/sourcemod/translations/sv/plugin.basecommands.txt',
'addons/sourcemod/translations/sv/reservedslots.phrases.txt',
'addons/sourcemod/translations/sv/rockthevote.phrases.txt',
'addons/sourcemod/translations/sv/slapslay.phrases.txt',
'addons/sourcemod/translations/sv/sounds.phrases.txt',
'addons/sourcemod/translations/sv/sqladmins.phrases.txt',
'addons/sourcemod/translations/th/adminhelp.phrases.txt',
'addons/sourcemod/translations/th/adminmenu.phrases.txt',
'addons/sourcemod/translations/th/antiflood.phrases.txt',
'addons/sourcemod/translations/th/basebans.phrases.txt',
'addons/sourcemod/translations/th/basecomm.phrases.txt',
'addons/sourcemod/translations/th/basetriggers.phrases.txt',
'addons/sourcemod/translations/th/basevotes.phrases.txt',
'addons/sourcemod/translations/th/clientprefs.phrases.txt',
'addons/sourcemod/translations/th/common.phrases.txt',
'addons/sourcemod/translations/th/core.phrases.txt',
'addons/sourcemod/translations/th/funcommands.phrases.txt',
'addons/sourcemod/translations/th/funvotes.phrases.txt',
'addons/sourcemod/translations/th/mapchooser.phrases.txt',
'addons/sourcemod/translations/th/nextmap.phrases.txt',
'addons/sourcemod/translations/th/nominations.phrases.txt',
'addons/sourcemod/translations/th/playercommands.phrases.txt',
'addons/sourcemod/translations/th/plugin.basecommands.txt',
'addons/sourcemod/translations/th/reservedslots.phrases.txt',
'addons/sourcemod/translations/th/rockthevote.phrases.txt',
'addons/sourcemod/translations/th/sounds.phrases.txt',
'addons/sourcemod/translations/th/sqladmins.phrases.txt',
'addons/sourcemod/translations/tr/adminhelp.phrases.txt',
'addons/sourcemod/translations/tr/adminmenu.phrases.txt',
'addons/sourcemod/translations/tr/antiflood.phrases.txt',
'addons/sourcemod/translations/tr/basebans.phrases.txt',
'addons/sourcemod/translations/tr/basecomm.phrases.txt',
'addons/sourcemod/translations/tr/basetriggers.phrases.txt',
'addons/sourcemod/translations/tr/basevotes.phrases.txt',
'addons/sourcemod/translations/tr/clientprefs.phrases.txt',
'addons/sourcemod/translations/tr/common.phrases.txt',
'addons/sourcemod/translations/tr/core.phrases.txt',
'addons/sourcemod/translations/tr/funcommands.phrases.txt',
'addons/sourcemod/translations/tr/funvotes.phrases.txt',
'addons/sourcemod/translations/tr/mapchooser.phrases.txt',
'addons/sourcemod/translations/tr/nextmap.phrases.txt',
'addons/sourcemod/translations/tr/nominations.phrases.txt',
'addons/sourcemod/translations/tr/playercommands.phrases.txt',
'addons/sourcemod/translations/tr/plugin.basecommands.txt',
'addons/sourcemod/translations/tr/reservedslots.phrases.txt',
'addons/sourcemod/translations/tr/rockthevote.phrases.txt',
'addons/sourcemod/translations/tr/slapslay.phrases.txt',
'addons/sourcemod/translations/tr/sounds.phrases.txt',
'addons/sourcemod/translations/tr/sqladmins.phrases.txt',
'addons/sourcemod/translations/ua/adminhelp.phrases.txt',
'addons/sourcemod/translations/ua/adminmenu.phrases.txt',
'addons/sourcemod/translations/ua/antiflood.phrases.txt',
'addons/sourcemod/translations/ua/basebans.phrases.txt',
'addons/sourcemod/translations/ua/basecomm.phrases.txt',
'addons/sourcemod/translations/ua/basetriggers.phrases.txt',
'addons/sourcemod/translations/ua/basevotes.phrases.txt',
'addons/sourcemod/translations/ua/clientprefs.phrases.txt',
'addons/sourcemod/translations/ua/common.phrases.txt',
'addons/sourcemod/translations/ua/core.phrases.txt',
'addons/sourcemod/translations/ua/funcommands.phrases.txt',
'addons/sourcemod/translations/ua/funvotes.phrases.txt',
'addons/sourcemod/translations/ua/mapchooser.phrases.txt',
'addons/sourcemod/translations/ua/nextmap.phrases.txt',
'addons/sourcemod/translations/ua/nominations.phrases.txt',
'addons/sourcemod/translations/ua/playercommands.phrases.txt',
'addons/sourcemod/translations/ua/plugin.basecommands.txt',
'addons/sourcemod/translations/ua/reservedslots.phrases.txt',
'addons/sourcemod/translations/ua/rockthevote.phrases.txt',
'addons/sourcemod/translations/ua/sounds.phrases.txt',
'addons/sourcemod/translations/ua/sqladmins.phrases.txt',
'addons/sourcemod/translations/vi/adminhelp.phrases.txt',
'addons/sourcemod/translations/vi/adminmenu.phrases.txt',
'addons/sourcemod/translations/vi/antiflood.phrases.txt',
'addons/sourcemod/translations/vi/basebans.phrases.txt',
'addons/sourcemod/translations/vi/basecomm.phrases.txt',
'addons/sourcemod/translations/vi/basetriggers.phrases.txt',
'addons/sourcemod/translations/vi/basevotes.phrases.txt',
'addons/sourcemod/translations/vi/clientprefs.phrases.txt',
'addons/sourcemod/translations/vi/common.phrases.txt',
'addons/sourcemod/translations/vi/core.phrases.txt',
'addons/sourcemod/translations/vi/funcommands.phrases.txt',
'addons/sourcemod/translations/vi/funvotes.phrases.txt',
'addons/sourcemod/translations/vi/mapchooser.phrases.txt',
'addons/sourcemod/translations/vi/nextmap.phrases.txt',
'addons/sourcemod/translations/vi/nominations.phrases.txt',
'addons/sourcemod/translations/vi/playercommands.phrases.txt',
'addons/sourcemod/translations/vi/plugin.basecommands.txt',
'addons/sourcemod/translations/vi/reservedslots.phrases.txt',
'addons/sourcemod/translations/vi/rockthevote.phrases.txt',
'addons/sourcemod/translations/vi/sounds.phrases.txt',
'addons/sourcemod/translations/vi/sqladmins.phrases.txt',
'addons/sourcemod/translations/zho/adminhelp.phrases.txt',
'addons/sourcemod/translations/zho/adminmenu.phrases.txt',
'addons/sourcemod/translations/zho/antiflood.phrases.txt',
'addons/sourcemod/translations/zho/basebans.phrases.txt',
'addons/sourcemod/translations/zho/basecomm.phrases.txt',
'addons/sourcemod/translations/zho/basetriggers.phrases.txt',
'addons/sourcemod/translations/zho/basevotes.phrases.txt',
'addons/sourcemod/translations/zho/clientprefs.phrases.txt',
'addons/sourcemod/translations/zho/common.phrases.txt',
'addons/sourcemod/translations/zho/core.phrases.txt',
'addons/sourcemod/translations/zho/funcommands.phrases.txt',
'addons/sourcemod/translations/zho/funvotes.phrases.txt',
'addons/sourcemod/translations/zho/mapchooser.phrases.txt',
'addons/sourcemod/translations/zho/nextmap.phrases.txt',
'addons/sourcemod/translations/zho/nominations.phrases.txt',
'addons/sourcemod/translations/zho/playercommands.phrases.txt',
'addons/sourcemod/translations/zho/plugin.basecommands.txt',
'addons/sourcemod/translations/zho/reservedslots.phrases.txt',
'addons/sourcemod/translations/zho/rockthevote.phrases.txt',
'addons/sourcemod/translations/zho/sounds.phrases.txt',
'addons/sourcemod/translations/zho/sqladmins.phrases.txt',
'cfg/sourcemod/sm_warmode_off.cfg',
'cfg/sourcemod/sm_warmode_on.cfg',
'cfg/sourcemod/sourcemod.cfg',
]

export const sm1_11_win = ['addons/metamod/sourcemod.vdf',
'addons/sourcemod/bin/sourcemod.2.bgt.dll',
'addons/sourcemod/bin/sourcemod.2.blade.dll',
'addons/sourcemod/bin/sourcemod.2.bms.dll',
'addons/sourcemod/bin/sourcemod.2.contagion.dll',
'addons/sourcemod/bin/sourcemod.2.csgo.dll',
'addons/sourcemod/bin/sourcemod.2.css.dll',
'addons/sourcemod/bin/sourcemod.2.darkm.dll',
'addons/sourcemod/bin/sourcemod.2.dods.dll',
'addons/sourcemod/bin/sourcemod.2.doi.dll',
'addons/sourcemod/bin/sourcemod.2.ep1.dll',
'addons/sourcemod/bin/sourcemod.2.ep2.dll',
'addons/sourcemod/bin/sourcemod.2.eye.dll',
'addons/sourcemod/bin/sourcemod.2.hl2dm.dll',
'addons/sourcemod/bin/sourcemod.2.insurgency.dll',
'addons/sourcemod/bin/sourcemod.2.l4d.dll',
'addons/sourcemod/bin/sourcemod.2.l4d2.dll',
'addons/sourcemod/bin/sourcemod.2.nd.dll',
'addons/sourcemod/bin/sourcemod.2.sdk2013.dll',
'addons/sourcemod/bin/sourcemod.2.swarm.dll',
'addons/sourcemod/bin/sourcemod.2.tf2.dll',
'addons/sourcemod/bin/sourcemod.logic.dll',
'addons/sourcemod/bin/sourcemod_mm.dll',
'addons/sourcemod/bin/sourcemod_mm.x64.dll',
'addons/sourcemod/bin/sourcepawn.jit.x86.dll',
'addons/sourcemod/bin/x64/libsourcepawn.dll',
'addons/sourcemod/bin/x64/sourcemod.2.blade.dll',
'addons/sourcemod/bin/x64/sourcemod.logic.dll',
'addons/sourcemod/configs/adminmenu_cfgs.txt',
'addons/sourcemod/configs/adminmenu_custom.txt',
'addons/sourcemod/configs/adminmenu_grouping.txt',
'addons/sourcemod/configs/adminmenu_sorting.txt',
'addons/sourcemod/configs/admins.cfg',
'addons/sourcemod/configs/admins_simple.ini',
'addons/sourcemod/configs/admin_groups.cfg',
'addons/sourcemod/configs/admin_levels.cfg',
'addons/sourcemod/configs/admin_overrides.cfg',
'addons/sourcemod/configs/banreasons.txt',
'addons/sourcemod/configs/core.cfg',
'addons/sourcemod/configs/databases.cfg',
'addons/sourcemod/configs/geoip/GeoLite2-City.mmdb',
'addons/sourcemod/configs/languages.cfg',
'addons/sourcemod/configs/maplists.cfg',
'addons/sourcemod/configs/sql-init-scripts/mysql/clientprefs-mysql.sql',
'addons/sourcemod/configs/sql-init-scripts/mysql/create_admins.sql',
'addons/sourcemod/configs/sql-init-scripts/mysql/update_admins_r1409.sql',
'addons/sourcemod/configs/sql-init-scripts/pgsql/clientprefs-pgsql.sql',
'addons/sourcemod/configs/sql-init-scripts/pgsql/create_admins.sql',
'addons/sourcemod/configs/sql-init-scripts/sqlite/admins-sqlite.sq3',
'addons/sourcemod/configs/sql-init-scripts/sqlite/clientprefs-sqlite.sq3',
'addons/sourcemod/configs/sql-init-scripts/sqlite/clientprefs-sqlite.sql',
'addons/sourcemod/configs/sql-init-scripts/sqlite/create_admins.sql',
'addons/sourcemod/configs/sql-init-scripts/sqlite/update_admins-r1409.sql',
'addons/sourcemod/extensions/bintools.ext.dll',
'addons/sourcemod/extensions/clientprefs.ext.dll',
'addons/sourcemod/extensions/dbi.mysql.ext.dll',
'addons/sourcemod/extensions/dbi.pgsql.ext.dll',
'addons/sourcemod/extensions/dbi.sqlite.ext.dll',
'addons/sourcemod/extensions/dhooks.ext.dll',
'addons/sourcemod/extensions/game.cstrike.ext.2.csgo.dll',
'addons/sourcemod/extensions/game.cstrike.ext.2.css.dll',
'addons/sourcemod/extensions/game.tf2.ext.2.tf2.dll',
'addons/sourcemod/extensions/geoip.ext.dll',
'addons/sourcemod/extensions/regex.ext.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.bgt.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.blade.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.bms.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.contagion.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.csgo.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.css.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.darkm.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.dods.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.doi.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.ep1.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.ep2.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.eye.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.hl2dm.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.insurgency.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.l4d.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.l4d2.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.nd.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.sdk2013.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.swarm.dll',
'addons/sourcemod/extensions/sdkhooks.ext.2.tf2.dll',
'addons/sourcemod/extensions/sdktools.ext.2.bgt.dll',
'addons/sourcemod/extensions/sdktools.ext.2.blade.dll',
'addons/sourcemod/extensions/sdktools.ext.2.bms.dll',
'addons/sourcemod/extensions/sdktools.ext.2.contagion.dll',
'addons/sourcemod/extensions/sdktools.ext.2.csgo.dll',
'addons/sourcemod/extensions/sdktools.ext.2.css.dll',
'addons/sourcemod/extensions/sdktools.ext.2.darkm.dll',
'addons/sourcemod/extensions/sdktools.ext.2.dods.dll',
'addons/sourcemod/extensions/sdktools.ext.2.doi.dll',
'addons/sourcemod/extensions/sdktools.ext.2.ep1.dll',
'addons/sourcemod/extensions/sdktools.ext.2.ep2.dll',
'addons/sourcemod/extensions/sdktools.ext.2.eye.dll',
'addons/sourcemod/extensions/sdktools.ext.2.hl2dm.dll',
'addons/sourcemod/extensions/sdktools.ext.2.insurgency.dll',
'addons/sourcemod/extensions/sdktools.ext.2.l4d.dll',
'addons/sourcemod/extensions/sdktools.ext.2.l4d2.dll',
'addons/sourcemod/extensions/sdktools.ext.2.nd.dll',
'addons/sourcemod/extensions/sdktools.ext.2.sdk2013.dll',
'addons/sourcemod/extensions/sdktools.ext.2.swarm.dll',
'addons/sourcemod/extensions/sdktools.ext.2.tf2.dll',
'addons/sourcemod/extensions/topmenus.ext.dll',
'addons/sourcemod/extensions/updater.ext.dll',
'addons/sourcemod/extensions/webternet.ext.dll',
'addons/sourcemod/extensions/x64/bintools.ext.dll',
'addons/sourcemod/extensions/x64/clientprefs.ext.dll',
'addons/sourcemod/extensions/x64/dbi.mysql.ext.dll',
'addons/sourcemod/extensions/x64/dbi.pgsql.ext.dll',
'addons/sourcemod/extensions/x64/dbi.sqlite.ext.dll',
'addons/sourcemod/extensions/x64/geoip.ext.dll',
'addons/sourcemod/extensions/x64/regex.ext.dll',
'addons/sourcemod/extensions/x64/sdkhooks.ext.2.blade.dll',
'addons/sourcemod/extensions/x64/sdktools.ext.2.blade.dll',
'addons/sourcemod/extensions/x64/topmenus.ext.dll',
'addons/sourcemod/extensions/x64/updater.ext.dll',
'addons/sourcemod/extensions/x64/webternet.ext.dll',
'addons/sourcemod/gamedata/core.games/blocklist.plugins.txt',
'addons/sourcemod/gamedata/core.games/common.games.txt',
'addons/sourcemod/gamedata/core.games/engine.bgt.txt',
'addons/sourcemod/gamedata/core.games/engine.blade.txt',
'addons/sourcemod/gamedata/core.games/engine.bms.txt',
'addons/sourcemod/gamedata/core.games/engine.contagion.txt',
'addons/sourcemod/gamedata/core.games/engine.csgo.txt',
'addons/sourcemod/gamedata/core.games/engine.css.txt',
'addons/sourcemod/gamedata/core.games/engine.darkm.txt',
'addons/sourcemod/gamedata/core.games/engine.ep1.txt',
'addons/sourcemod/gamedata/core.games/engine.ep2.txt',
'addons/sourcemod/gamedata/core.games/engine.ep2valve.txt',
'addons/sourcemod/gamedata/core.games/engine.eye.txt',
'addons/sourcemod/gamedata/core.games/engine.insurgency.txt',
'addons/sourcemod/gamedata/core.games/engine.l4d.txt',
'addons/sourcemod/gamedata/core.games/engine.l4d2.txt',
'addons/sourcemod/gamedata/core.games/engine.sdk2013.txt',
'addons/sourcemod/gamedata/core.games/engine.swarm.txt',
'addons/sourcemod/gamedata/core.games/game.dinodday.txt',
'addons/sourcemod/gamedata/core.games/master.games.txt',
'addons/sourcemod/gamedata/funcommands.games.txt',
'addons/sourcemod/gamedata/sdkhooks.games/common.games.txt',
'addons/sourcemod/gamedata/sdkhooks.games/engine.blade.txt',
'addons/sourcemod/gamedata/sdkhooks.games/engine.contagion.txt',
'addons/sourcemod/gamedata/sdkhooks.games/engine.csgo.txt',
'addons/sourcemod/gamedata/sdkhooks.games/engine.darkm.txt',
'addons/sourcemod/gamedata/sdkhooks.games/engine.ep2v.txt',
'addons/sourcemod/gamedata/sdkhooks.games/engine.insurgency.txt',
'addons/sourcemod/gamedata/sdkhooks.games/engine.l4d.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.ag2.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.alienswarm.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.aoc.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.bms.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.cspromod.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.cstrike.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.dinodday.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.doi.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.empires.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.ff.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.fof.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.gesource.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.hidden.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.hl2ctf.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.insurgency.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.kz.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.l4d2.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.modularcombat.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.neotokyo.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.nmrih.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.nucleardawn.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.pvkii.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.reactivedrop.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.sgtls.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.sourceforts.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.synergy.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.zm.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.zpanic.txt',
'addons/sourcemod/gamedata/sdkhooks.games/master.games.txt',
'addons/sourcemod/gamedata/sdktools.games/common.games.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.bgt.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.blade.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.contagion.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.csgo.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.css.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.darkm.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.ep1.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.ep2.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.ep2valve.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.eye.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.insurgency.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.l4d.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.l4d2.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.sdk2013.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.swarm.txt',
'addons/sourcemod/gamedata/sdktools.games/game.ag2.txt',
'addons/sourcemod/gamedata/sdktools.games/game.alienswarm.txt',
'addons/sourcemod/gamedata/sdktools.games/game.aoc.txt',
'addons/sourcemod/gamedata/sdktools.games/game.bg2.txt',
'addons/sourcemod/gamedata/sdktools.games/game.bms.txt',
'addons/sourcemod/gamedata/sdktools.games/game.cspromod.txt',
'addons/sourcemod/gamedata/sdktools.games/game.cstrike.txt',
'addons/sourcemod/gamedata/sdktools.games/game.dinodday.txt',
'addons/sourcemod/gamedata/sdktools.games/game.dod.txt',
'addons/sourcemod/gamedata/sdktools.games/game.doi.txt',
'addons/sourcemod/gamedata/sdktools.games/game.dystopia.txt',
'addons/sourcemod/gamedata/sdktools.games/game.empires.txt',
'addons/sourcemod/gamedata/sdktools.games/game.esmod.txt',
'addons/sourcemod/gamedata/sdktools.games/game.fas.txt',
'addons/sourcemod/gamedata/sdktools.games/game.ff.txt',
'addons/sourcemod/gamedata/sdktools.games/game.fof.txt',
'addons/sourcemod/gamedata/sdktools.games/game.gesource.txt',
'addons/sourcemod/gamedata/sdktools.games/game.hidden.txt',
'addons/sourcemod/gamedata/sdktools.games/game.hl2ctf.txt',
'addons/sourcemod/gamedata/sdktools.games/game.hl2mp.txt',
'addons/sourcemod/gamedata/sdktools.games/game.insurgency.txt',
'addons/sourcemod/gamedata/sdktools.games/game.ios.txt',
'addons/sourcemod/gamedata/sdktools.games/game.kz.txt',
'addons/sourcemod/gamedata/sdktools.games/game.left4dead2.txt',
'addons/sourcemod/gamedata/sdktools.games/game.modularcombat.txt',
'addons/sourcemod/gamedata/sdktools.games/game.neotokyo.txt',
'addons/sourcemod/gamedata/sdktools.games/game.nmrih.txt',
'addons/sourcemod/gamedata/sdktools.games/game.nucleardawn.txt',
'addons/sourcemod/gamedata/sdktools.games/game.obsidian.txt',
'addons/sourcemod/gamedata/sdktools.games/game.pvkii.txt',
'addons/sourcemod/gamedata/sdktools.games/game.reactivedrop.txt',
'addons/sourcemod/gamedata/sdktools.games/game.rnlbeta.txt',
'addons/sourcemod/gamedata/sdktools.games/game.ship.txt',
'addons/sourcemod/gamedata/sdktools.games/game.sourceforts.txt',
'addons/sourcemod/gamedata/sdktools.games/game.synergy.txt',
'addons/sourcemod/gamedata/sdktools.games/game.tf.txt',
'addons/sourcemod/gamedata/sdktools.games/game.zm.txt',
'addons/sourcemod/gamedata/sdktools.games/game.zpanic.txt',
'addons/sourcemod/gamedata/sdktools.games/master.games.txt',
'addons/sourcemod/gamedata/sm-cstrike.games/game.csgo.txt',
'addons/sourcemod/gamedata/sm-cstrike.games/game.css.txt',
'addons/sourcemod/gamedata/sm-cstrike.games/master.games.txt',
'addons/sourcemod/gamedata/sm-tf2.games.txt',
'addons/sourcemod/GPLv2.txt',
'addons/sourcemod/GPLv3.txt',
'addons/sourcemod/LICENSE.txt',
'addons/sourcemod/plugins/admin-flatfile.smx',
'addons/sourcemod/plugins/adminhelp.smx',
'addons/sourcemod/plugins/adminmenu.smx',
'addons/sourcemod/plugins/antiflood.smx',
'addons/sourcemod/plugins/basebans.smx',
'addons/sourcemod/plugins/basechat.smx',
'addons/sourcemod/plugins/basecomm.smx',
'addons/sourcemod/plugins/basecommands.smx',
'addons/sourcemod/plugins/basetriggers.smx',
'addons/sourcemod/plugins/basevotes.smx',
'addons/sourcemod/plugins/clientprefs.smx',
'addons/sourcemod/plugins/disabled/admin-sql-prefetch.smx',
'addons/sourcemod/plugins/disabled/admin-sql-threaded.smx',
'addons/sourcemod/plugins/disabled/mapchooser.smx',
'addons/sourcemod/plugins/disabled/nominations.smx',
'addons/sourcemod/plugins/disabled/randomcycle.smx',
'addons/sourcemod/plugins/disabled/rockthevote.smx',
'addons/sourcemod/plugins/disabled/sql-admin-manager.smx',
'addons/sourcemod/plugins/funcommands.smx',
'addons/sourcemod/plugins/funvotes.smx',
'addons/sourcemod/plugins/nextmap.smx',
'addons/sourcemod/plugins/playercommands.smx',
'addons/sourcemod/plugins/reservedslots.smx',
'addons/sourcemod/plugins/sounds.smx',
'addons/sourcemod/scripting/admin-flatfile/admin-flatfile.sp',
'addons/sourcemod/scripting/admin-flatfile/admin-groups.sp',
'addons/sourcemod/scripting/admin-flatfile/admin-overrides.sp',
'addons/sourcemod/scripting/admin-flatfile/admin-simple.sp',
'addons/sourcemod/scripting/admin-flatfile/admin-users.sp',
'addons/sourcemod/scripting/admin-sql-prefetch.sp',
'addons/sourcemod/scripting/admin-sql-threaded.sp',
'addons/sourcemod/scripting/adminhelp.sp',
'addons/sourcemod/scripting/adminmenu.sp',
'addons/sourcemod/scripting/adminmenu/dynamicmenu.sp',
'addons/sourcemod/scripting/antiflood.sp',
'addons/sourcemod/scripting/basebans.sp',
'addons/sourcemod/scripting/basebans/ban.sp',
'addons/sourcemod/scripting/basechat.sp',
'addons/sourcemod/scripting/basecomm.sp',
'addons/sourcemod/scripting/basecommands.sp',
'addons/sourcemod/scripting/basecommands/cancelvote.sp',
'addons/sourcemod/scripting/basecommands/execcfg.sp',
'addons/sourcemod/scripting/basecommands/kick.sp',
'addons/sourcemod/scripting/basecommands/map.sp',
'addons/sourcemod/scripting/basecommands/reloadadmins.sp',
'addons/sourcemod/scripting/basecommands/who.sp',
'addons/sourcemod/scripting/basecomm/forwards.sp',
'addons/sourcemod/scripting/basecomm/gag.sp',
'addons/sourcemod/scripting/basecomm/natives.sp',
'addons/sourcemod/scripting/basetriggers.sp',
'addons/sourcemod/scripting/basevotes.sp',
'addons/sourcemod/scripting/basevotes/voteban.sp',
'addons/sourcemod/scripting/basevotes/votekick.sp',
'addons/sourcemod/scripting/basevotes/votemap.sp',
'addons/sourcemod/scripting/clientprefs.sp',
'addons/sourcemod/scripting/compile.exe',
'addons/sourcemod/scripting/funcommands.sp',
'addons/sourcemod/scripting/funcommands/beacon.sp',
'addons/sourcemod/scripting/funcommands/blind.sp',
'addons/sourcemod/scripting/funcommands/drug.sp',
'addons/sourcemod/scripting/funcommands/fire.sp',
'addons/sourcemod/scripting/funcommands/gravity.sp',
'addons/sourcemod/scripting/funcommands/ice.sp',
'addons/sourcemod/scripting/funcommands/noclip.sp',
'addons/sourcemod/scripting/funcommands/timebomb.sp',
'addons/sourcemod/scripting/funvotes.sp',
'addons/sourcemod/scripting/funvotes/votealltalk.sp',
'addons/sourcemod/scripting/funvotes/voteburn.sp',
'addons/sourcemod/scripting/funvotes/voteff.sp',
'addons/sourcemod/scripting/funvotes/votegravity.sp',
'addons/sourcemod/scripting/funvotes/voteslay.sp',
'addons/sourcemod/scripting/include/admin.inc',
'addons/sourcemod/scripting/include/adminmenu.inc',
'addons/sourcemod/scripting/include/adt.inc',
'addons/sourcemod/scripting/include/adt_array.inc',
'addons/sourcemod/scripting/include/adt_stack.inc',
'addons/sourcemod/scripting/include/adt_trie.inc',
'addons/sourcemod/scripting/include/banning.inc',
'addons/sourcemod/scripting/include/basecomm.inc',
'addons/sourcemod/scripting/include/bitbuffer.inc',
'addons/sourcemod/scripting/include/clientprefs.inc',
'addons/sourcemod/scripting/include/clients.inc',
'addons/sourcemod/scripting/include/commandfilters.inc',
'addons/sourcemod/scripting/include/commandline.inc',
'addons/sourcemod/scripting/include/console.inc',
'addons/sourcemod/scripting/include/convars.inc',
'addons/sourcemod/scripting/include/core.inc',
'addons/sourcemod/scripting/include/cstrike.inc',
'addons/sourcemod/scripting/include/datapack.inc',
'addons/sourcemod/scripting/include/dbi.inc',
'addons/sourcemod/scripting/include/dhooks.inc',
'addons/sourcemod/scripting/include/entity.inc',
'addons/sourcemod/scripting/include/entity_prop_stocks.inc',
'addons/sourcemod/scripting/include/events.inc',
'addons/sourcemod/scripting/include/files.inc',
'addons/sourcemod/scripting/include/float.inc',
'addons/sourcemod/scripting/include/functions.inc',
'addons/sourcemod/scripting/include/geoip.inc',
'addons/sourcemod/scripting/include/halflife.inc',
'addons/sourcemod/scripting/include/handles.inc',
'addons/sourcemod/scripting/include/helpers.inc',
'addons/sourcemod/scripting/include/keyvalues.inc',
'addons/sourcemod/scripting/include/lang.inc',
'addons/sourcemod/scripting/include/logging.inc',
'addons/sourcemod/scripting/include/mapchooser.inc',
'addons/sourcemod/scripting/include/menus.inc',
'addons/sourcemod/scripting/include/nextmap.inc',
'addons/sourcemod/scripting/include/profiler.inc',
'addons/sourcemod/scripting/include/protobuf.inc',
'addons/sourcemod/scripting/include/regex.inc',
'addons/sourcemod/scripting/include/sdkhooks.inc',
'addons/sourcemod/scripting/include/sdktools.inc',
'addons/sourcemod/scripting/include/sdktools_client.inc',
'addons/sourcemod/scripting/include/sdktools_engine.inc',
'addons/sourcemod/scripting/include/sdktools_entinput.inc',
'addons/sourcemod/scripting/include/sdktools_entoutput.inc',
'addons/sourcemod/scripting/include/sdktools_functions.inc',
'addons/sourcemod/scripting/include/sdktools_gamerules.inc',
'addons/sourcemod/scripting/include/sdktools_hooks.inc',
'addons/sourcemod/scripting/include/sdktools_sound.inc',
'addons/sourcemod/scripting/include/sdktools_stocks.inc',
'addons/sourcemod/scripting/include/sdktools_stringtables.inc',
'addons/sourcemod/scripting/include/sdktools_tempents.inc',
'addons/sourcemod/scripting/include/sdktools_tempents_stocks.inc',
'addons/sourcemod/scripting/include/sdktools_trace.inc',
'addons/sourcemod/scripting/include/sdktools_variant_t.inc',
'addons/sourcemod/scripting/include/sdktools_voice.inc',
'addons/sourcemod/scripting/include/sorting.inc',
'addons/sourcemod/scripting/include/sourcemod.inc',
'addons/sourcemod/scripting/include/string.inc',
'addons/sourcemod/scripting/include/testing.inc',
'addons/sourcemod/scripting/include/textparse.inc',
'addons/sourcemod/scripting/include/tf2.inc',
'addons/sourcemod/scripting/include/tf2_stocks.inc',
'addons/sourcemod/scripting/include/timers.inc',
'addons/sourcemod/scripting/include/topmenus.inc',
'addons/sourcemod/scripting/include/usermessages.inc',
'addons/sourcemod/scripting/include/vector.inc',
'addons/sourcemod/scripting/include/version.inc',
'addons/sourcemod/scripting/include/version_auto.inc',
'addons/sourcemod/scripting/mapchooser.sp',
'addons/sourcemod/scripting/nextmap.sp',
'addons/sourcemod/scripting/nominations.sp',
'addons/sourcemod/scripting/playercommands.sp',
'addons/sourcemod/scripting/playercommands/rename.sp',
'addons/sourcemod/scripting/playercommands/slap.sp',
'addons/sourcemod/scripting/playercommands/slay.sp',
'addons/sourcemod/scripting/randomcycle.sp',
'addons/sourcemod/scripting/reservedslots.sp',
'addons/sourcemod/scripting/rockthevote.sp',
'addons/sourcemod/scripting/sounds.sp',
'addons/sourcemod/scripting/spcomp.exe',
'addons/sourcemod/scripting/spcomp64.exe',
'addons/sourcemod/scripting/sql-admin-manager.sp',
'addons/sourcemod/scripting/testsuite/benchmark.sp',
'addons/sourcemod/scripting/testsuite/bug4059.sp',
'addons/sourcemod/scripting/testsuite/callfunctest.sp',
'addons/sourcemod/scripting/testsuite/capstest.sp',
'addons/sourcemod/scripting/testsuite/clientprefstest.sp',
'addons/sourcemod/scripting/testsuite/cstrike-test.sp',
'addons/sourcemod/scripting/testsuite/entpropelements.sp',
'addons/sourcemod/scripting/testsuite/fakenative1.sp',
'addons/sourcemod/scripting/testsuite/fakenative2.sp',
'addons/sourcemod/scripting/testsuite/filetest.sp',
'addons/sourcemod/scripting/testsuite/findmap.sp',
'addons/sourcemod/scripting/testsuite/floats.sp',
'addons/sourcemod/scripting/testsuite/fwdtest1.sp',
'addons/sourcemod/scripting/testsuite/fwdtest2.sp',
'addons/sourcemod/scripting/testsuite/gamerules-props.sp',
'addons/sourcemod/scripting/testsuite/goto_test.sp',
'addons/sourcemod/scripting/testsuite/keyvalues.sp',
'addons/sourcemod/scripting/testsuite/mapdisplayname.sp',
'addons/sourcemod/scripting/testsuite/outputtest.sp',
'addons/sourcemod/scripting/testsuite/ptstest.sp',
'addons/sourcemod/scripting/testsuite/sorttest.sp',
'addons/sourcemod/scripting/testsuite/sqltest.sp',
'addons/sourcemod/scripting/testsuite/sqltest.sql',
'addons/sourcemod/scripting/testsuite/stacktest.sp',
'addons/sourcemod/scripting/testsuite/structtest.sp',
'addons/sourcemod/scripting/testsuite/tf2-test.sp',
'addons/sourcemod/scripting/testsuite/tries.sp',
'addons/sourcemod/translations/adminhelp.phrases.txt',
'addons/sourcemod/translations/adminmenu.phrases.txt',
'addons/sourcemod/translations/antiflood.phrases.txt',
'addons/sourcemod/translations/ar/adminhelp.phrases.txt',
'addons/sourcemod/translations/ar/adminmenu.phrases.txt',
'addons/sourcemod/translations/ar/antiflood.phrases.txt',
'addons/sourcemod/translations/ar/basebans.phrases.txt',
'addons/sourcemod/translations/ar/basecomm.phrases.txt',
'addons/sourcemod/translations/ar/basetriggers.phrases.txt',
'addons/sourcemod/translations/ar/basevotes.phrases.txt',
'addons/sourcemod/translations/ar/clientprefs.phrases.txt',
'addons/sourcemod/translations/ar/common.phrases.txt',
'addons/sourcemod/translations/ar/core.phrases.txt',
'addons/sourcemod/translations/ar/funcommands.phrases.txt',
'addons/sourcemod/translations/ar/funvotes.phrases.txt',
'addons/sourcemod/translations/ar/mapchooser.phrases.txt',
'addons/sourcemod/translations/ar/nextmap.phrases.txt',
'addons/sourcemod/translations/ar/nominations.phrases.txt',
'addons/sourcemod/translations/ar/playercommands.phrases.txt',
'addons/sourcemod/translations/ar/plugin.basecommands.txt',
'addons/sourcemod/translations/ar/reservedslots.phrases.txt',
'addons/sourcemod/translations/ar/rockthevote.phrases.txt',
'addons/sourcemod/translations/ar/sounds.phrases.txt',
'addons/sourcemod/translations/ar/sqladmins.phrases.txt',
'addons/sourcemod/translations/basebans.phrases.txt',
'addons/sourcemod/translations/basecomm.phrases.txt',
'addons/sourcemod/translations/basetriggers.phrases.txt',
'addons/sourcemod/translations/basevotes.phrases.txt',
'addons/sourcemod/translations/bg/adminhelp.phrases.txt',
'addons/sourcemod/translations/bg/adminmenu.phrases.txt',
'addons/sourcemod/translations/bg/antiflood.phrases.txt',
'addons/sourcemod/translations/bg/basebans.phrases.txt',
'addons/sourcemod/translations/bg/basecomm.phrases.txt',
'addons/sourcemod/translations/bg/basetriggers.phrases.txt',
'addons/sourcemod/translations/bg/basevotes.phrases.txt',
'addons/sourcemod/translations/bg/clientprefs.phrases.txt',
'addons/sourcemod/translations/bg/common.phrases.txt',
'addons/sourcemod/translations/bg/core.phrases.txt',
'addons/sourcemod/translations/bg/funcommands.phrases.txt',
'addons/sourcemod/translations/bg/funvotes.phrases.txt',
'addons/sourcemod/translations/bg/mapchooser.phrases.txt',
'addons/sourcemod/translations/bg/nextmap.phrases.txt',
'addons/sourcemod/translations/bg/nominations.phrases.txt',
'addons/sourcemod/translations/bg/playercommands.phrases.txt',
'addons/sourcemod/translations/bg/plugin.basecommands.txt',
'addons/sourcemod/translations/bg/reservedslots.phrases.txt',
'addons/sourcemod/translations/bg/rockthevote.phrases.txt',
'addons/sourcemod/translations/bg/sounds.phrases.txt',
'addons/sourcemod/translations/bg/sqladmins.phrases.txt',
'addons/sourcemod/translations/chi/adminhelp.phrases.txt',
'addons/sourcemod/translations/chi/adminmenu.phrases.txt',
'addons/sourcemod/translations/chi/antiflood.phrases.txt',
'addons/sourcemod/translations/chi/basebans.phrases.txt',
'addons/sourcemod/translations/chi/basecomm.phrases.txt',
'addons/sourcemod/translations/chi/basetriggers.phrases.txt',
'addons/sourcemod/translations/chi/basevotes.phrases.txt',
'addons/sourcemod/translations/chi/clientprefs.phrases.txt',
'addons/sourcemod/translations/chi/common.phrases.txt',
'addons/sourcemod/translations/chi/core.phrases.txt',
'addons/sourcemod/translations/chi/funcommands.phrases.txt',
'addons/sourcemod/translations/chi/funvotes.phrases.txt',
'addons/sourcemod/translations/chi/mapchooser.phrases.txt',
'addons/sourcemod/translations/chi/nextmap.phrases.txt',
'addons/sourcemod/translations/chi/nominations.phrases.txt',
'addons/sourcemod/translations/chi/playercommands.phrases.txt',
'addons/sourcemod/translations/chi/plugin.basecommands.txt',
'addons/sourcemod/translations/chi/reservedslots.phrases.txt',
'addons/sourcemod/translations/chi/rockthevote.phrases.txt',
'addons/sourcemod/translations/chi/slapslay.phrases.txt',
'addons/sourcemod/translations/chi/sounds.phrases.txt',
'addons/sourcemod/translations/chi/sqladmins.phrases.txt',
'addons/sourcemod/translations/clientprefs.phrases.txt',
'addons/sourcemod/translations/common.phrases.txt',
'addons/sourcemod/translations/core.phrases.txt',
'addons/sourcemod/translations/cze/adminhelp.phrases.txt',
'addons/sourcemod/translations/cze/adminmenu.phrases.txt',
'addons/sourcemod/translations/cze/antiflood.phrases.txt',
'addons/sourcemod/translations/cze/basebans.phrases.txt',
'addons/sourcemod/translations/cze/basecomm.phrases.txt',
'addons/sourcemod/translations/cze/basetriggers.phrases.txt',
'addons/sourcemod/translations/cze/basevotes.phrases.txt',
'addons/sourcemod/translations/cze/clientprefs.phrases.txt',
'addons/sourcemod/translations/cze/common.phrases.txt',
'addons/sourcemod/translations/cze/core.phrases.txt',
'addons/sourcemod/translations/cze/funcommands.phrases.txt',
'addons/sourcemod/translations/cze/funvotes.phrases.txt',
'addons/sourcemod/translations/cze/mapchooser.phrases.txt',
'addons/sourcemod/translations/cze/nextmap.phrases.txt',
'addons/sourcemod/translations/cze/nominations.phrases.txt',
'addons/sourcemod/translations/cze/playercommands.phrases.txt',
'addons/sourcemod/translations/cze/plugin.basecommands.txt',
'addons/sourcemod/translations/cze/reservedslots.phrases.txt',
'addons/sourcemod/translations/cze/rockthevote.phrases.txt',
'addons/sourcemod/translations/cze/sounds.phrases.txt',
'addons/sourcemod/translations/cze/sqladmins.phrases.txt',
'addons/sourcemod/translations/da/adminhelp.phrases.txt',
'addons/sourcemod/translations/da/adminmenu.phrases.txt',
'addons/sourcemod/translations/da/antiflood.phrases.txt',
'addons/sourcemod/translations/da/basebans.phrases.txt',
'addons/sourcemod/translations/da/basecomm.phrases.txt',
'addons/sourcemod/translations/da/basetriggers.phrases.txt',
'addons/sourcemod/translations/da/basevotes.phrases.txt',
'addons/sourcemod/translations/da/clientprefs.phrases.txt',
'addons/sourcemod/translations/da/common.phrases.txt',
'addons/sourcemod/translations/da/core.phrases.txt',
'addons/sourcemod/translations/da/funcommands.phrases.txt',
'addons/sourcemod/translations/da/funvotes.phrases.txt',
'addons/sourcemod/translations/da/mapchooser.phrases.txt',
'addons/sourcemod/translations/da/nextmap.phrases.txt',
'addons/sourcemod/translations/da/nominations.phrases.txt',
'addons/sourcemod/translations/da/playercommands.phrases.txt',
'addons/sourcemod/translations/da/plugin.basecommands.txt',
'addons/sourcemod/translations/da/reservedslots.phrases.txt',
'addons/sourcemod/translations/da/rockthevote.phrases.txt',
'addons/sourcemod/translations/da/slapslay.phrases.txt',
'addons/sourcemod/translations/da/sounds.phrases.txt',
'addons/sourcemod/translations/da/sqladmins.phrases.txt',
'addons/sourcemod/translations/de/adminhelp.phrases.txt',
'addons/sourcemod/translations/de/adminmenu.phrases.txt',
'addons/sourcemod/translations/de/antiflood.phrases.txt',
'addons/sourcemod/translations/de/basebans.phrases.txt',
'addons/sourcemod/translations/de/basecomm.phrases.txt',
'addons/sourcemod/translations/de/basetriggers.phrases.txt',
'addons/sourcemod/translations/de/basevotes.phrases.txt',
'addons/sourcemod/translations/de/clientprefs.phrases.txt',
'addons/sourcemod/translations/de/common.phrases.txt',
'addons/sourcemod/translations/de/core.phrases.txt',
'addons/sourcemod/translations/de/funcommands.phrases.txt',
'addons/sourcemod/translations/de/funvotes.phrases.txt',
'addons/sourcemod/translations/de/mapchooser.phrases.txt',
'addons/sourcemod/translations/de/nextmap.phrases.txt',
'addons/sourcemod/translations/de/nominations.phrases.txt',
'addons/sourcemod/translations/de/playercommands.phrases.txt',
'addons/sourcemod/translations/de/plugin.basecommands.txt',
'addons/sourcemod/translations/de/reservedslots.phrases.txt',
'addons/sourcemod/translations/de/rockthevote.phrases.txt',
'addons/sourcemod/translations/de/slapslay.phrases.txt',
'addons/sourcemod/translations/de/sounds.phrases.txt',
'addons/sourcemod/translations/de/sqladmins.phrases.txt',
'addons/sourcemod/translations/el/adminhelp.phrases.txt',
'addons/sourcemod/translations/el/adminmenu.phrases.txt',
'addons/sourcemod/translations/el/antiflood.phrases.txt',
'addons/sourcemod/translations/el/basebans.phrases.txt',
'addons/sourcemod/translations/el/basecomm.phrases.txt',
'addons/sourcemod/translations/el/basetriggers.phrases.txt',
'addons/sourcemod/translations/el/basevotes.phrases.txt',
'addons/sourcemod/translations/el/clientprefs.phrases.txt',
'addons/sourcemod/translations/el/common.phrases.txt',
'addons/sourcemod/translations/el/core.phrases.txt',
'addons/sourcemod/translations/el/funcommands.phrases.txt',
'addons/sourcemod/translations/el/funvotes.phrases.txt',
'addons/sourcemod/translations/el/mapchooser.phrases.txt',
'addons/sourcemod/translations/el/nextmap.phrases.txt',
'addons/sourcemod/translations/el/nominations.phrases.txt',
'addons/sourcemod/translations/el/playercommands.phrases.txt',
'addons/sourcemod/translations/el/plugin.basecommands.txt',
'addons/sourcemod/translations/el/reservedslots.phrases.txt',
'addons/sourcemod/translations/el/rockthevote.phrases.txt',
'addons/sourcemod/translations/el/sounds.phrases.txt',
'addons/sourcemod/translations/el/sqladmins.phrases.txt',
'addons/sourcemod/translations/es/adminhelp.phrases.txt',
'addons/sourcemod/translations/es/adminmenu.phrases.txt',
'addons/sourcemod/translations/es/antiflood.phrases.txt',
'addons/sourcemod/translations/es/basebans.phrases.txt',
'addons/sourcemod/translations/es/basecomm.phrases.txt',
'addons/sourcemod/translations/es/basetriggers.phrases.txt',
'addons/sourcemod/translations/es/basevotes.phrases.txt',
'addons/sourcemod/translations/es/clientprefs.phrases.txt',
'addons/sourcemod/translations/es/common.phrases.txt',
'addons/sourcemod/translations/es/core.phrases.txt',
'addons/sourcemod/translations/es/funcommands.phrases.txt',
'addons/sourcemod/translations/es/funvotes.phrases.txt',
'addons/sourcemod/translations/es/mapchooser.phrases.txt',
'addons/sourcemod/translations/es/nextmap.phrases.txt',
'addons/sourcemod/translations/es/nominations.phrases.txt',
'addons/sourcemod/translations/es/playercommands.phrases.txt',
'addons/sourcemod/translations/es/plugin.basecommands.txt',
'addons/sourcemod/translations/es/reservedslots.phrases.txt',
'addons/sourcemod/translations/es/rockthevote.phrases.txt',
'addons/sourcemod/translations/es/slapslay.phrases.txt',
'addons/sourcemod/translations/es/sounds.phrases.txt',
'addons/sourcemod/translations/es/sqladmins.phrases.txt',
'addons/sourcemod/translations/fi/adminhelp.phrases.txt',
'addons/sourcemod/translations/fi/adminmenu.phrases.txt',
'addons/sourcemod/translations/fi/antiflood.phrases.txt',
'addons/sourcemod/translations/fi/basebans.phrases.txt',
'addons/sourcemod/translations/fi/basecomm.phrases.txt',
'addons/sourcemod/translations/fi/basetriggers.phrases.txt',
'addons/sourcemod/translations/fi/basevotes.phrases.txt',
'addons/sourcemod/translations/fi/clientprefs.phrases.txt',
'addons/sourcemod/translations/fi/common.phrases.txt',
'addons/sourcemod/translations/fi/core.phrases.txt',
'addons/sourcemod/translations/fi/funcommands.phrases.txt',
'addons/sourcemod/translations/fi/funvotes.phrases.txt',
'addons/sourcemod/translations/fi/mapchooser.phrases.txt',
'addons/sourcemod/translations/fi/nextmap.phrases.txt',
'addons/sourcemod/translations/fi/nominations.phrases.txt',
'addons/sourcemod/translations/fi/playercommands.phrases.txt',
'addons/sourcemod/translations/fi/plugin.basecommands.txt',
'addons/sourcemod/translations/fi/reservedslots.phrases.txt',
'addons/sourcemod/translations/fi/rockthevote.phrases.txt',
'addons/sourcemod/translations/fi/sounds.phrases.txt',
'addons/sourcemod/translations/fi/sqladmins.phrases.txt',
'addons/sourcemod/translations/fr/adminhelp.phrases.txt',
'addons/sourcemod/translations/fr/adminmenu.phrases.txt',
'addons/sourcemod/translations/fr/antiflood.phrases.txt',
'addons/sourcemod/translations/fr/basebans.phrases.txt',
'addons/sourcemod/translations/fr/basecomm.phrases.txt',
'addons/sourcemod/translations/fr/basetriggers.phrases.txt',
'addons/sourcemod/translations/fr/basevotes.phrases.txt',
'addons/sourcemod/translations/fr/clientprefs.phrases.txt',
'addons/sourcemod/translations/fr/common.phrases.txt',
'addons/sourcemod/translations/fr/core.phrases.txt',
'addons/sourcemod/translations/fr/funcommands.phrases.txt',
'addons/sourcemod/translations/fr/funvotes.phrases.txt',
'addons/sourcemod/translations/fr/mapchooser.phrases.txt',
'addons/sourcemod/translations/fr/nextmap.phrases.txt',
'addons/sourcemod/translations/fr/nominations.phrases.txt',
'addons/sourcemod/translations/fr/playercommands.phrases.txt',
'addons/sourcemod/translations/fr/plugin.basecommands.txt',
'addons/sourcemod/translations/fr/reservedslots.phrases.txt',
'addons/sourcemod/translations/fr/rockthevote.phrases.txt',
'addons/sourcemod/translations/fr/slapslay.phrases.txt',
'addons/sourcemod/translations/fr/sounds.phrases.txt',
'addons/sourcemod/translations/fr/sqladmins.phrases.txt',
'addons/sourcemod/translations/funcommands.phrases.txt',
'addons/sourcemod/translations/funvotes.phrases.txt',
'addons/sourcemod/translations/he/adminhelp.phrases.txt',
'addons/sourcemod/translations/he/adminmenu.phrases.txt',
'addons/sourcemod/translations/he/antiflood.phrases.txt',
'addons/sourcemod/translations/he/basebans.phrases.txt',
'addons/sourcemod/translations/he/basecomm.phrases.txt',
'addons/sourcemod/translations/he/basetriggers.phrases.txt',
'addons/sourcemod/translations/he/basevotes.phrases.txt',
'addons/sourcemod/translations/he/clientprefs.phrases.txt',
'addons/sourcemod/translations/he/common.phrases.txt',
'addons/sourcemod/translations/he/core.phrases.txt',
'addons/sourcemod/translations/he/funcommands.phrases.txt',
'addons/sourcemod/translations/he/funvotes.phrases.txt',
'addons/sourcemod/translations/he/mapchooser.phrases.txt',
'addons/sourcemod/translations/he/nextmap.phrases.txt',
'addons/sourcemod/translations/he/nominations.phrases.txt',
'addons/sourcemod/translations/he/playercommands.phrases.txt',
'addons/sourcemod/translations/he/plugin.basecommands.txt',
'addons/sourcemod/translations/he/reservedslots.phrases.txt',
'addons/sourcemod/translations/he/rockthevote.phrases.txt',
'addons/sourcemod/translations/he/sounds.phrases.txt',
'addons/sourcemod/translations/he/sqladmins.phrases.txt',
'addons/sourcemod/translations/hu/adminhelp.phrases.txt',
'addons/sourcemod/translations/hu/adminmenu.phrases.txt',
'addons/sourcemod/translations/hu/antiflood.phrases.txt',
'addons/sourcemod/translations/hu/basebans.phrases.txt',
'addons/sourcemod/translations/hu/basecomm.phrases.txt',
'addons/sourcemod/translations/hu/basetriggers.phrases.txt',
'addons/sourcemod/translations/hu/basevotes.phrases.txt',
'addons/sourcemod/translations/hu/clientprefs.phrases.txt',
'addons/sourcemod/translations/hu/common.phrases.txt',
'addons/sourcemod/translations/hu/core.phrases.txt',
'addons/sourcemod/translations/hu/funcommands.phrases.txt',
'addons/sourcemod/translations/hu/funvotes.phrases.txt',
'addons/sourcemod/translations/hu/mapchooser.phrases.txt',
'addons/sourcemod/translations/hu/nextmap.phrases.txt',
'addons/sourcemod/translations/hu/nominations.phrases.txt',
'addons/sourcemod/translations/hu/playercommands.phrases.txt',
'addons/sourcemod/translations/hu/plugin.basecommands.txt',
'addons/sourcemod/translations/hu/reservedslots.phrases.txt',
'addons/sourcemod/translations/hu/rockthevote.phrases.txt',
'addons/sourcemod/translations/hu/slapslay.phrases.txt',
'addons/sourcemod/translations/hu/sounds.phrases.txt',
'addons/sourcemod/translations/hu/sqladmins.phrases.txt',
'addons/sourcemod/translations/it/adminhelp.phrases.txt',
'addons/sourcemod/translations/it/adminmenu.phrases.txt',
'addons/sourcemod/translations/it/antiflood.phrases.txt',
'addons/sourcemod/translations/it/basebans.phrases.txt',
'addons/sourcemod/translations/it/basecomm.phrases.txt',
'addons/sourcemod/translations/it/basetriggers.phrases.txt',
'addons/sourcemod/translations/it/basevotes.phrases.txt',
'addons/sourcemod/translations/it/clientprefs.phrases.txt',
'addons/sourcemod/translations/it/common.phrases.txt',
'addons/sourcemod/translations/it/core.phrases.txt',
'addons/sourcemod/translations/it/funcommands.phrases.txt',
'addons/sourcemod/translations/it/funvotes.phrases.txt',
'addons/sourcemod/translations/it/mapchooser.phrases.txt',
'addons/sourcemod/translations/it/nextmap.phrases.txt',
'addons/sourcemod/translations/it/nominations.phrases.txt',
'addons/sourcemod/translations/it/playercommands.phrases.txt',
'addons/sourcemod/translations/it/plugin.basecommands.txt',
'addons/sourcemod/translations/it/reservedslots.phrases.txt',
'addons/sourcemod/translations/it/rockthevote.phrases.txt',
'addons/sourcemod/translations/it/sounds.phrases.txt',
'addons/sourcemod/translations/it/sqladmins.phrases.txt',
'addons/sourcemod/translations/jp/adminhelp.phrases.txt',
'addons/sourcemod/translations/jp/adminmenu.phrases.txt',
'addons/sourcemod/translations/jp/antiflood.phrases.txt',
'addons/sourcemod/translations/jp/basebans.phrases.txt',
'addons/sourcemod/translations/jp/basecomm.phrases.txt',
'addons/sourcemod/translations/jp/basetriggers.phrases.txt',
'addons/sourcemod/translations/jp/basevotes.phrases.txt',
'addons/sourcemod/translations/jp/clientprefs.phrases.txt',
'addons/sourcemod/translations/jp/common.phrases.txt',
'addons/sourcemod/translations/jp/core.phrases.txt',
'addons/sourcemod/translations/jp/funcommands.phrases.txt',
'addons/sourcemod/translations/jp/funvotes.phrases.txt',
'addons/sourcemod/translations/jp/mapchooser.phrases.txt',
'addons/sourcemod/translations/jp/nextmap.phrases.txt',
'addons/sourcemod/translations/jp/nominations.phrases.txt',
'addons/sourcemod/translations/jp/playercommands.phrases.txt',
'addons/sourcemod/translations/jp/plugin.basecommands.txt',
'addons/sourcemod/translations/jp/reservedslots.phrases.txt',
'addons/sourcemod/translations/jp/rockthevote.phrases.txt',
'addons/sourcemod/translations/jp/slapslay.phrases.txt',
'addons/sourcemod/translations/jp/sounds.phrases.txt',
'addons/sourcemod/translations/jp/sqladmins.phrases.txt',
'addons/sourcemod/translations/ko/adminhelp.phrases.txt',
'addons/sourcemod/translations/ko/adminmenu.phrases.txt',
'addons/sourcemod/translations/ko/antiflood.phrases.txt',
'addons/sourcemod/translations/ko/basebans.phrases.txt',
'addons/sourcemod/translations/ko/basecomm.phrases.txt',
'addons/sourcemod/translations/ko/basetriggers.phrases.txt',
'addons/sourcemod/translations/ko/basevotes.phrases.txt',
'addons/sourcemod/translations/ko/clientprefs.phrases.txt',
'addons/sourcemod/translations/ko/common.phrases.txt',
'addons/sourcemod/translations/ko/core.phrases.txt',
'addons/sourcemod/translations/ko/funcommands.phrases.txt',
'addons/sourcemod/translations/ko/funvotes.phrases.txt',
'addons/sourcemod/translations/ko/mapchooser.phrases.txt',
'addons/sourcemod/translations/ko/nextmap.phrases.txt',
'addons/sourcemod/translations/ko/nominations.phrases.txt',
'addons/sourcemod/translations/ko/playercommands.phrases.txt',
'addons/sourcemod/translations/ko/plugin.basecommands.txt',
'addons/sourcemod/translations/ko/reservedslots.phrases.txt',
'addons/sourcemod/translations/ko/rockthevote.phrases.txt',
'addons/sourcemod/translations/ko/sounds.phrases.txt',
'addons/sourcemod/translations/ko/sqladmins.phrases.txt',
'addons/sourcemod/translations/lt/adminhelp.phrases.txt',
'addons/sourcemod/translations/lt/adminmenu.phrases.txt',
'addons/sourcemod/translations/lt/antiflood.phrases.txt',
'addons/sourcemod/translations/lt/basebans.phrases.txt',
'addons/sourcemod/translations/lt/basecomm.phrases.txt',
'addons/sourcemod/translations/lt/basetriggers.phrases.txt',
'addons/sourcemod/translations/lt/basevotes.phrases.txt',
'addons/sourcemod/translations/lt/clientprefs.phrases.txt',
'addons/sourcemod/translations/lt/common.phrases.txt',
'addons/sourcemod/translations/lt/core.phrases.txt',
'addons/sourcemod/translations/lt/funcommands.phrases.txt',
'addons/sourcemod/translations/lt/funvotes.phrases.txt',
'addons/sourcemod/translations/lt/mapchooser.phrases.txt',
'addons/sourcemod/translations/lt/nextmap.phrases.txt',
'addons/sourcemod/translations/lt/nominations.phrases.txt',
'addons/sourcemod/translations/lt/playercommands.phrases.txt',
'addons/sourcemod/translations/lt/plugin.basecommands.txt',
'addons/sourcemod/translations/lt/reservedslots.phrases.txt',
'addons/sourcemod/translations/lt/rockthevote.phrases.txt',
'addons/sourcemod/translations/lt/sounds.phrases.txt',
'addons/sourcemod/translations/lt/sqladmins.phrases.txt',
'addons/sourcemod/translations/lv/adminhelp.phrases.txt',
'addons/sourcemod/translations/lv/adminmenu.phrases.txt',
'addons/sourcemod/translations/lv/antiflood.phrases.txt',
'addons/sourcemod/translations/lv/basebans.phrases.txt',
'addons/sourcemod/translations/lv/basecomm.phrases.txt',
'addons/sourcemod/translations/lv/basetriggers.phrases.txt',
'addons/sourcemod/translations/lv/basevotes.phrases.txt',
'addons/sourcemod/translations/lv/clientprefs.phrases.txt',
'addons/sourcemod/translations/lv/common.phrases.txt',
'addons/sourcemod/translations/lv/core.phrases.txt',
'addons/sourcemod/translations/lv/funcommands.phrases.txt',
'addons/sourcemod/translations/lv/funvotes.phrases.txt',
'addons/sourcemod/translations/lv/mapchooser.phrases.txt',
'addons/sourcemod/translations/lv/nextmap.phrases.txt',
'addons/sourcemod/translations/lv/nominations.phrases.txt',
'addons/sourcemod/translations/lv/playercommands.phrases.txt',
'addons/sourcemod/translations/lv/plugin.basecommands.txt',
'addons/sourcemod/translations/lv/reservedslots.phrases.txt',
'addons/sourcemod/translations/lv/rockthevote.phrases.txt',
'addons/sourcemod/translations/lv/slapslay.phrases.txt',
'addons/sourcemod/translations/lv/sounds.phrases.txt',
'addons/sourcemod/translations/lv/sqladmins.phrases.txt',
'addons/sourcemod/translations/mapchooser.phrases.txt',
'addons/sourcemod/translations/nextmap.phrases.txt',
'addons/sourcemod/translations/nl/adminhelp.phrases.txt',
'addons/sourcemod/translations/nl/adminmenu.phrases.txt',
'addons/sourcemod/translations/nl/antiflood.phrases.txt',
'addons/sourcemod/translations/nl/basebans.phrases.txt',
'addons/sourcemod/translations/nl/basecomm.phrases.txt',
'addons/sourcemod/translations/nl/basetriggers.phrases.txt',
'addons/sourcemod/translations/nl/basevotes.phrases.txt',
'addons/sourcemod/translations/nl/clientprefs.phrases.txt',
'addons/sourcemod/translations/nl/common.phrases.txt',
'addons/sourcemod/translations/nl/core.phrases.txt',
'addons/sourcemod/translations/nl/funcommands.phrases.txt',
'addons/sourcemod/translations/nl/funvotes.phrases.txt',
'addons/sourcemod/translations/nl/mapchooser.phrases.txt',
'addons/sourcemod/translations/nl/nextmap.phrases.txt',
'addons/sourcemod/translations/nl/nominations.phrases.txt',
'addons/sourcemod/translations/nl/playercommands.phrases.txt',
'addons/sourcemod/translations/nl/plugin.basecommands.txt',
'addons/sourcemod/translations/nl/reservedslots.phrases.txt',
'addons/sourcemod/translations/nl/rockthevote.phrases.txt',
'addons/sourcemod/translations/nl/sounds.phrases.txt',
'addons/sourcemod/translations/nl/sqladmins.phrases.txt',
'addons/sourcemod/translations/nominations.phrases.txt',
'addons/sourcemod/translations/no/adminhelp.phrases.txt',
'addons/sourcemod/translations/no/adminmenu.phrases.txt',
'addons/sourcemod/translations/no/antiflood.phrases.txt',
'addons/sourcemod/translations/no/basebans.phrases.txt',
'addons/sourcemod/translations/no/basecomm.phrases.txt',
'addons/sourcemod/translations/no/basetriggers.phrases.txt',
'addons/sourcemod/translations/no/basevotes.phrases.txt',
'addons/sourcemod/translations/no/clientprefs.phrases.txt',
'addons/sourcemod/translations/no/common.phrases.txt',
'addons/sourcemod/translations/no/core.phrases.txt',
'addons/sourcemod/translations/no/funcommands.phrases.txt',
'addons/sourcemod/translations/no/funvotes.phrases.txt',
'addons/sourcemod/translations/no/mapchooser.phrases.txt',
'addons/sourcemod/translations/no/nextmap.phrases.txt',
'addons/sourcemod/translations/no/nominations.phrases.txt',
'addons/sourcemod/translations/no/playercommands.phrases.txt',
'addons/sourcemod/translations/no/plugin.basecommands.txt',
'addons/sourcemod/translations/no/reservedslots.phrases.txt',
'addons/sourcemod/translations/no/rockthevote.phrases.txt',
'addons/sourcemod/translations/no/slapslay.phrases.txt',
'addons/sourcemod/translations/no/sounds.phrases.txt',
'addons/sourcemod/translations/no/sqladmins.phrases.txt',
'addons/sourcemod/translations/playercommands.phrases.txt',
'addons/sourcemod/translations/plugin.basecommands.txt',
'addons/sourcemod/translations/pl/adminhelp.phrases.txt',
'addons/sourcemod/translations/pl/adminmenu.phrases.txt',
'addons/sourcemod/translations/pl/antiflood.phrases.txt',
'addons/sourcemod/translations/pl/basebans.phrases.txt',
'addons/sourcemod/translations/pl/basecomm.phrases.txt',
'addons/sourcemod/translations/pl/basetriggers.phrases.txt',
'addons/sourcemod/translations/pl/basevotes.phrases.txt',
'addons/sourcemod/translations/pl/clientprefs.phrases.txt',
'addons/sourcemod/translations/pl/common.phrases.txt',
'addons/sourcemod/translations/pl/core.phrases.txt',
'addons/sourcemod/translations/pl/funcommands.phrases.txt',
'addons/sourcemod/translations/pl/funvotes.phrases.txt',
'addons/sourcemod/translations/pl/mapchooser.phrases.txt',
'addons/sourcemod/translations/pl/nextmap.phrases.txt',
'addons/sourcemod/translations/pl/nominations.phrases.txt',
'addons/sourcemod/translations/pl/playercommands.phrases.txt',
'addons/sourcemod/translations/pl/plugin.basecommands.txt',
'addons/sourcemod/translations/pl/reservedslots.phrases.txt',
'addons/sourcemod/translations/pl/rockthevote.phrases.txt',
'addons/sourcemod/translations/pl/slapslay.phrases.txt',
'addons/sourcemod/translations/pl/sounds.phrases.txt',
'addons/sourcemod/translations/pl/sqladmins.phrases.txt',
'addons/sourcemod/translations/pt/adminhelp.phrases.txt',
'addons/sourcemod/translations/pt/adminmenu.phrases.txt',
'addons/sourcemod/translations/pt/antiflood.phrases.txt',
'addons/sourcemod/translations/pt/basebans.phrases.txt',
'addons/sourcemod/translations/pt/basecomm.phrases.txt',
'addons/sourcemod/translations/pt/basetriggers.phrases.txt',
'addons/sourcemod/translations/pt/basevotes.phrases.txt',
'addons/sourcemod/translations/pt/clientprefs.phrases.txt',
'addons/sourcemod/translations/pt/common.phrases.txt',
'addons/sourcemod/translations/pt/core.phrases.txt',
'addons/sourcemod/translations/pt/funcommands.phrases.txt',
'addons/sourcemod/translations/pt/funvotes.phrases.txt',
'addons/sourcemod/translations/pt/mapchooser.phrases.txt',
'addons/sourcemod/translations/pt/nextmap.phrases.txt',
'addons/sourcemod/translations/pt/nominations.phrases.txt',
'addons/sourcemod/translations/pt/playercommands.phrases.txt',
'addons/sourcemod/translations/pt/plugin.basecommands.txt',
'addons/sourcemod/translations/pt/reservedslots.phrases.txt',
'addons/sourcemod/translations/pt/rockthevote.phrases.txt',
'addons/sourcemod/translations/pt/slapslay.phrases.txt',
'addons/sourcemod/translations/pt/sounds.phrases.txt',
'addons/sourcemod/translations/pt/sqladmins.phrases.txt',
'addons/sourcemod/translations/pt_p/adminhelp.phrases.txt',
'addons/sourcemod/translations/pt_p/adminmenu.phrases.txt',
'addons/sourcemod/translations/pt_p/antiflood.phrases.txt',
'addons/sourcemod/translations/pt_p/basebans.phrases.txt',
'addons/sourcemod/translations/pt_p/basecomm.phrases.txt',
'addons/sourcemod/translations/pt_p/basetriggers.phrases.txt',
'addons/sourcemod/translations/pt_p/basevotes.phrases.txt',
'addons/sourcemod/translations/pt_p/clientprefs.phrases.txt',
'addons/sourcemod/translations/pt_p/common.phrases.txt',
'addons/sourcemod/translations/pt_p/core.phrases.txt',
'addons/sourcemod/translations/pt_p/funcommands.phrases.txt',
'addons/sourcemod/translations/pt_p/funvotes.phrases.txt',
'addons/sourcemod/translations/pt_p/mapchooser.phrases.txt',
'addons/sourcemod/translations/pt_p/nextmap.phrases.txt',
'addons/sourcemod/translations/pt_p/nominations.phrases.txt',
'addons/sourcemod/translations/pt_p/playercommands.phrases.txt',
'addons/sourcemod/translations/pt_p/plugin.basecommands.txt',
'addons/sourcemod/translations/pt_p/reservedslots.phrases.txt',
'addons/sourcemod/translations/pt_p/rockthevote.phrases.txt',
'addons/sourcemod/translations/pt_p/sounds.phrases.txt',
'addons/sourcemod/translations/pt_p/sqladmins.phrases.txt',
'addons/sourcemod/translations/reservedslots.phrases.txt',
'addons/sourcemod/translations/rockthevote.phrases.txt',
'addons/sourcemod/translations/ro/adminhelp.phrases.txt',
'addons/sourcemod/translations/ro/adminmenu.phrases.txt',
'addons/sourcemod/translations/ro/antiflood.phrases.txt',
'addons/sourcemod/translations/ro/basebans.phrases.txt',
'addons/sourcemod/translations/ro/basecomm.phrases.txt',
'addons/sourcemod/translations/ro/basetriggers.phrases.txt',
'addons/sourcemod/translations/ro/basevotes.phrases.txt',
'addons/sourcemod/translations/ro/clientprefs.phrases.txt',
'addons/sourcemod/translations/ro/common.phrases.txt',
'addons/sourcemod/translations/ro/core.phrases.txt',
'addons/sourcemod/translations/ro/funcommands.phrases.txt',
'addons/sourcemod/translations/ro/funvotes.phrases.txt',
'addons/sourcemod/translations/ro/mapchooser.phrases.txt',
'addons/sourcemod/translations/ro/nextmap.phrases.txt',
'addons/sourcemod/translations/ro/nominations.phrases.txt',
'addons/sourcemod/translations/ro/playercommands.phrases.txt',
'addons/sourcemod/translations/ro/plugin.basecommands.txt',
'addons/sourcemod/translations/ro/reservedslots.phrases.txt',
'addons/sourcemod/translations/ro/rockthevote.phrases.txt',
'addons/sourcemod/translations/ro/slapslay.phrases.txt',
'addons/sourcemod/translations/ro/sounds.phrases.txt',
'addons/sourcemod/translations/ro/sqladmins.phrases.txt',
'addons/sourcemod/translations/ru/adminhelp.phrases.txt',
'addons/sourcemod/translations/ru/adminmenu.phrases.txt',
'addons/sourcemod/translations/ru/antiflood.phrases.txt',
'addons/sourcemod/translations/ru/basebans.phrases.txt',
'addons/sourcemod/translations/ru/basecomm.phrases.txt',
'addons/sourcemod/translations/ru/basetriggers.phrases.txt',
'addons/sourcemod/translations/ru/basevotes.phrases.txt',
'addons/sourcemod/translations/ru/clientprefs.phrases.txt',
'addons/sourcemod/translations/ru/common.phrases.txt',
'addons/sourcemod/translations/ru/core.phrases.txt',
'addons/sourcemod/translations/ru/funcommands.phrases.txt',
'addons/sourcemod/translations/ru/funvotes.phrases.txt',
'addons/sourcemod/translations/ru/mapchooser.phrases.txt',
'addons/sourcemod/translations/ru/nextmap.phrases.txt',
'addons/sourcemod/translations/ru/nominations.phrases.txt',
'addons/sourcemod/translations/ru/playercommands.phrases.txt',
'addons/sourcemod/translations/ru/plugin.basecommands.txt',
'addons/sourcemod/translations/ru/reservedslots.phrases.txt',
'addons/sourcemod/translations/ru/rockthevote.phrases.txt',
'addons/sourcemod/translations/ru/slapslay.phrases.txt',
'addons/sourcemod/translations/ru/sounds.phrases.txt',
'addons/sourcemod/translations/ru/sqladmins.phrases.txt',
'addons/sourcemod/translations/sk/adminhelp.phrases.txt',
'addons/sourcemod/translations/sk/adminmenu.phrases.txt',
'addons/sourcemod/translations/sk/antiflood.phrases.txt',
'addons/sourcemod/translations/sk/basebans.phrases.txt',
'addons/sourcemod/translations/sk/basecomm.phrases.txt',
'addons/sourcemod/translations/sk/basetriggers.phrases.txt',
'addons/sourcemod/translations/sk/basevotes.phrases.txt',
'addons/sourcemod/translations/sk/clientprefs.phrases.txt',
'addons/sourcemod/translations/sk/common.phrases.txt',
'addons/sourcemod/translations/sk/core.phrases.txt',
'addons/sourcemod/translations/sk/funcommands.phrases.txt',
'addons/sourcemod/translations/sk/funvotes.phrases.txt',
'addons/sourcemod/translations/sk/mapchooser.phrases.txt',
'addons/sourcemod/translations/sk/nextmap.phrases.txt',
'addons/sourcemod/translations/sk/nominations.phrases.txt',
'addons/sourcemod/translations/sk/playercommands.phrases.txt',
'addons/sourcemod/translations/sk/plugin.basecommands.txt',
'addons/sourcemod/translations/sk/reservedslots.phrases.txt',
'addons/sourcemod/translations/sk/rockthevote.phrases.txt',
'addons/sourcemod/translations/sk/sounds.phrases.txt',
'addons/sourcemod/translations/sk/sqladmins.phrases.txt',
'addons/sourcemod/translations/sounds.phrases.txt',
'addons/sourcemod/translations/sqladmins.phrases.txt',
'addons/sourcemod/translations/sv/adminhelp.phrases.txt',
'addons/sourcemod/translations/sv/adminmenu.phrases.txt',
'addons/sourcemod/translations/sv/antiflood.phrases.txt',
'addons/sourcemod/translations/sv/basebans.phrases.txt',
'addons/sourcemod/translations/sv/basecomm.phrases.txt',
'addons/sourcemod/translations/sv/basetriggers.phrases.txt',
'addons/sourcemod/translations/sv/basevotes.phrases.txt',
'addons/sourcemod/translations/sv/clientprefs.phrases.txt',
'addons/sourcemod/translations/sv/common.phrases.txt',
'addons/sourcemod/translations/sv/core.phrases.txt',
'addons/sourcemod/translations/sv/funcommands.phrases.txt',
'addons/sourcemod/translations/sv/funvotes.phrases.txt',
'addons/sourcemod/translations/sv/mapchooser.phrases.txt',
'addons/sourcemod/translations/sv/nextmap.phrases.txt',
'addons/sourcemod/translations/sv/nominations.phrases.txt',
'addons/sourcemod/translations/sv/playercommands.phrases.txt',
'addons/sourcemod/translations/sv/plugin.basecommands.txt',
'addons/sourcemod/translations/sv/reservedslots.phrases.txt',
'addons/sourcemod/translations/sv/rockthevote.phrases.txt',
'addons/sourcemod/translations/sv/slapslay.phrases.txt',
'addons/sourcemod/translations/sv/sounds.phrases.txt',
'addons/sourcemod/translations/sv/sqladmins.phrases.txt',
'addons/sourcemod/translations/th/adminhelp.phrases.txt',
'addons/sourcemod/translations/th/adminmenu.phrases.txt',
'addons/sourcemod/translations/th/antiflood.phrases.txt',
'addons/sourcemod/translations/th/basebans.phrases.txt',
'addons/sourcemod/translations/th/basecomm.phrases.txt',
'addons/sourcemod/translations/th/basetriggers.phrases.txt',
'addons/sourcemod/translations/th/basevotes.phrases.txt',
'addons/sourcemod/translations/th/clientprefs.phrases.txt',
'addons/sourcemod/translations/th/common.phrases.txt',
'addons/sourcemod/translations/th/core.phrases.txt',
'addons/sourcemod/translations/th/funcommands.phrases.txt',
'addons/sourcemod/translations/th/funvotes.phrases.txt',
'addons/sourcemod/translations/th/mapchooser.phrases.txt',
'addons/sourcemod/translations/th/nextmap.phrases.txt',
'addons/sourcemod/translations/th/nominations.phrases.txt',
'addons/sourcemod/translations/th/playercommands.phrases.txt',
'addons/sourcemod/translations/th/plugin.basecommands.txt',
'addons/sourcemod/translations/th/reservedslots.phrases.txt',
'addons/sourcemod/translations/th/rockthevote.phrases.txt',
'addons/sourcemod/translations/th/sounds.phrases.txt',
'addons/sourcemod/translations/th/sqladmins.phrases.txt',
'addons/sourcemod/translations/tr/adminhelp.phrases.txt',
'addons/sourcemod/translations/tr/adminmenu.phrases.txt',
'addons/sourcemod/translations/tr/antiflood.phrases.txt',
'addons/sourcemod/translations/tr/basebans.phrases.txt',
'addons/sourcemod/translations/tr/basecomm.phrases.txt',
'addons/sourcemod/translations/tr/basetriggers.phrases.txt',
'addons/sourcemod/translations/tr/basevotes.phrases.txt',
'addons/sourcemod/translations/tr/clientprefs.phrases.txt',
'addons/sourcemod/translations/tr/common.phrases.txt',
'addons/sourcemod/translations/tr/core.phrases.txt',
'addons/sourcemod/translations/tr/funcommands.phrases.txt',
'addons/sourcemod/translations/tr/funvotes.phrases.txt',
'addons/sourcemod/translations/tr/mapchooser.phrases.txt',
'addons/sourcemod/translations/tr/nextmap.phrases.txt',
'addons/sourcemod/translations/tr/nominations.phrases.txt',
'addons/sourcemod/translations/tr/playercommands.phrases.txt',
'addons/sourcemod/translations/tr/plugin.basecommands.txt',
'addons/sourcemod/translations/tr/reservedslots.phrases.txt',
'addons/sourcemod/translations/tr/rockthevote.phrases.txt',
'addons/sourcemod/translations/tr/slapslay.phrases.txt',
'addons/sourcemod/translations/tr/sounds.phrases.txt',
'addons/sourcemod/translations/tr/sqladmins.phrases.txt',
'addons/sourcemod/translations/ua/adminhelp.phrases.txt',
'addons/sourcemod/translations/ua/adminmenu.phrases.txt',
'addons/sourcemod/translations/ua/antiflood.phrases.txt',
'addons/sourcemod/translations/ua/basebans.phrases.txt',
'addons/sourcemod/translations/ua/basecomm.phrases.txt',
'addons/sourcemod/translations/ua/basetriggers.phrases.txt',
'addons/sourcemod/translations/ua/basevotes.phrases.txt',
'addons/sourcemod/translations/ua/clientprefs.phrases.txt',
'addons/sourcemod/translations/ua/common.phrases.txt',
'addons/sourcemod/translations/ua/core.phrases.txt',
'addons/sourcemod/translations/ua/funcommands.phrases.txt',
'addons/sourcemod/translations/ua/funvotes.phrases.txt',
'addons/sourcemod/translations/ua/mapchooser.phrases.txt',
'addons/sourcemod/translations/ua/nextmap.phrases.txt',
'addons/sourcemod/translations/ua/nominations.phrases.txt',
'addons/sourcemod/translations/ua/playercommands.phrases.txt',
'addons/sourcemod/translations/ua/plugin.basecommands.txt',
'addons/sourcemod/translations/ua/reservedslots.phrases.txt',
'addons/sourcemod/translations/ua/rockthevote.phrases.txt',
'addons/sourcemod/translations/ua/sounds.phrases.txt',
'addons/sourcemod/translations/ua/sqladmins.phrases.txt',
'addons/sourcemod/translations/vi/adminhelp.phrases.txt',
'addons/sourcemod/translations/vi/adminmenu.phrases.txt',
'addons/sourcemod/translations/vi/antiflood.phrases.txt',
'addons/sourcemod/translations/vi/basebans.phrases.txt',
'addons/sourcemod/translations/vi/basecomm.phrases.txt',
'addons/sourcemod/translations/vi/basetriggers.phrases.txt',
'addons/sourcemod/translations/vi/basevotes.phrases.txt',
'addons/sourcemod/translations/vi/clientprefs.phrases.txt',
'addons/sourcemod/translations/vi/common.phrases.txt',
'addons/sourcemod/translations/vi/core.phrases.txt',
'addons/sourcemod/translations/vi/funcommands.phrases.txt',
'addons/sourcemod/translations/vi/funvotes.phrases.txt',
'addons/sourcemod/translations/vi/mapchooser.phrases.txt',
'addons/sourcemod/translations/vi/nextmap.phrases.txt',
'addons/sourcemod/translations/vi/nominations.phrases.txt',
'addons/sourcemod/translations/vi/playercommands.phrases.txt',
'addons/sourcemod/translations/vi/plugin.basecommands.txt',
'addons/sourcemod/translations/vi/reservedslots.phrases.txt',
'addons/sourcemod/translations/vi/rockthevote.phrases.txt',
'addons/sourcemod/translations/vi/sounds.phrases.txt',
'addons/sourcemod/translations/vi/sqladmins.phrases.txt',
'addons/sourcemod/translations/zho/adminhelp.phrases.txt',
'addons/sourcemod/translations/zho/adminmenu.phrases.txt',
'addons/sourcemod/translations/zho/antiflood.phrases.txt',
'addons/sourcemod/translations/zho/basebans.phrases.txt',
'addons/sourcemod/translations/zho/basecomm.phrases.txt',
'addons/sourcemod/translations/zho/basetriggers.phrases.txt',
'addons/sourcemod/translations/zho/basevotes.phrases.txt',
'addons/sourcemod/translations/zho/clientprefs.phrases.txt',
'addons/sourcemod/translations/zho/common.phrases.txt',
'addons/sourcemod/translations/zho/core.phrases.txt',
'addons/sourcemod/translations/zho/funcommands.phrases.txt',
'addons/sourcemod/translations/zho/funvotes.phrases.txt',
'addons/sourcemod/translations/zho/mapchooser.phrases.txt',
'addons/sourcemod/translations/zho/nextmap.phrases.txt',
'addons/sourcemod/translations/zho/nominations.phrases.txt',
'addons/sourcemod/translations/zho/playercommands.phrases.txt',
'addons/sourcemod/translations/zho/plugin.basecommands.txt',
'addons/sourcemod/translations/zho/reservedslots.phrases.txt',
'addons/sourcemod/translations/zho/rockthevote.phrases.txt',
'addons/sourcemod/translations/zho/sounds.phrases.txt',
'addons/sourcemod/translations/zho/sqladmins.phrases.txt',
'cfg/sourcemod/sm_warmode_off.cfg',
'cfg/sourcemod/sm_warmode_on.cfg',
'cfg/sourcemod/sourcemod.cfg',
]

export const sm1_11_linux = ['addons/metamod/sourcemod.vdf',
'addons/sourcemod/bin/sourcemod.2.bms.so',
'addons/sourcemod/bin/sourcemod.2.csgo.so',
'addons/sourcemod/bin/sourcemod.2.css.so',
'addons/sourcemod/bin/sourcemod.2.dods.so',
'addons/sourcemod/bin/sourcemod.2.doi.so',
'addons/sourcemod/bin/sourcemod.2.ep1.so',
'addons/sourcemod/bin/sourcemod.2.ep2.so',
'addons/sourcemod/bin/sourcemod.2.hl2dm.so',
'addons/sourcemod/bin/sourcemod.2.insurgency.so',
'addons/sourcemod/bin/sourcemod.2.l4d.so',
'addons/sourcemod/bin/sourcemod.2.l4d2.so',
'addons/sourcemod/bin/sourcemod.2.nd.so',
'addons/sourcemod/bin/sourcemod.2.sdk2013.so',
'addons/sourcemod/bin/sourcemod.2.tf2.so',
'addons/sourcemod/bin/sourcemod.logic.so',
'addons/sourcemod/bin/sourcemod_mm.x64.so',
'addons/sourcemod/bin/sourcemod_mm_i486.so',
'addons/sourcemod/bin/sourcepawn.jit.x86.so',
'addons/sourcemod/bin/x64/libsourcepawn.so',
'addons/sourcemod/bin/x64/sourcemod.2.blade.so',
'addons/sourcemod/bin/x64/sourcemod.2.csgo.so',
'addons/sourcemod/bin/x64/sourcemod.logic.so',
'addons/sourcemod/configs/adminmenu_cfgs.txt',
'addons/sourcemod/configs/adminmenu_custom.txt',
'addons/sourcemod/configs/adminmenu_grouping.txt',
'addons/sourcemod/configs/adminmenu_sorting.txt',
'addons/sourcemod/configs/admins.cfg',
'addons/sourcemod/configs/admins_simple.ini',
'addons/sourcemod/configs/admin_groups.cfg',
'addons/sourcemod/configs/admin_levels.cfg',
'addons/sourcemod/configs/admin_overrides.cfg',
'addons/sourcemod/configs/banreasons.txt',
'addons/sourcemod/configs/core.cfg',
'addons/sourcemod/configs/databases.cfg',
'addons/sourcemod/configs/geoip/GeoLite2-City.mmdb',
'addons/sourcemod/configs/languages.cfg',
'addons/sourcemod/configs/maplists.cfg',
'addons/sourcemod/configs/sql-init-scripts/mysql/clientprefs-mysql.sql',
'addons/sourcemod/configs/sql-init-scripts/mysql/create_admins.sql',
'addons/sourcemod/configs/sql-init-scripts/mysql/update_admins_r1409.sql',
'addons/sourcemod/configs/sql-init-scripts/pgsql/clientprefs-pgsql.sql',
'addons/sourcemod/configs/sql-init-scripts/pgsql/create_admins.sql',
'addons/sourcemod/configs/sql-init-scripts/sqlite/admins-sqlite.sq3',
'addons/sourcemod/configs/sql-init-scripts/sqlite/clientprefs-sqlite.sq3',
'addons/sourcemod/configs/sql-init-scripts/sqlite/clientprefs-sqlite.sql',
'addons/sourcemod/configs/sql-init-scripts/sqlite/create_admins.sql',
'addons/sourcemod/configs/sql-init-scripts/sqlite/update_admins-r1409.sql',
'addons/sourcemod/extensions/bintools.ext.so',
'addons/sourcemod/extensions/clientprefs.ext.so',
'addons/sourcemod/extensions/dbi.mysql.ext.so',
'addons/sourcemod/extensions/dbi.pgsql.ext.so',
'addons/sourcemod/extensions/dbi.sqlite.ext.so',
'addons/sourcemod/extensions/dhooks.ext.so',
'addons/sourcemod/extensions/game.cstrike.ext.2.csgo.so',
'addons/sourcemod/extensions/game.cstrike.ext.2.css.so',
'addons/sourcemod/extensions/game.tf2.ext.2.tf2.so',
'addons/sourcemod/extensions/geoip.ext.so',
'addons/sourcemod/extensions/regex.ext.so',
'addons/sourcemod/extensions/sdkhooks.ext.2.bms.so',
'addons/sourcemod/extensions/sdkhooks.ext.2.csgo.so',
'addons/sourcemod/extensions/sdkhooks.ext.2.css.so',
'addons/sourcemod/extensions/sdkhooks.ext.2.dods.so',
'addons/sourcemod/extensions/sdkhooks.ext.2.doi.so',
'addons/sourcemod/extensions/sdkhooks.ext.2.ep1.so',
'addons/sourcemod/extensions/sdkhooks.ext.2.ep2.so',
'addons/sourcemod/extensions/sdkhooks.ext.2.hl2dm.so',
'addons/sourcemod/extensions/sdkhooks.ext.2.insurgency.so',
'addons/sourcemod/extensions/sdkhooks.ext.2.l4d.so',
'addons/sourcemod/extensions/sdkhooks.ext.2.l4d2.so',
'addons/sourcemod/extensions/sdkhooks.ext.2.nd.so',
'addons/sourcemod/extensions/sdkhooks.ext.2.sdk2013.so',
'addons/sourcemod/extensions/sdkhooks.ext.2.tf2.so',
'addons/sourcemod/extensions/sdktools.ext.2.bms.so',
'addons/sourcemod/extensions/sdktools.ext.2.csgo.so',
'addons/sourcemod/extensions/sdktools.ext.2.css.so',
'addons/sourcemod/extensions/sdktools.ext.2.dods.so',
'addons/sourcemod/extensions/sdktools.ext.2.doi.so',
'addons/sourcemod/extensions/sdktools.ext.2.ep1.so',
'addons/sourcemod/extensions/sdktools.ext.2.ep2.so',
'addons/sourcemod/extensions/sdktools.ext.2.hl2dm.so',
'addons/sourcemod/extensions/sdktools.ext.2.insurgency.so',
'addons/sourcemod/extensions/sdktools.ext.2.l4d.so',
'addons/sourcemod/extensions/sdktools.ext.2.l4d2.so',
'addons/sourcemod/extensions/sdktools.ext.2.nd.so',
'addons/sourcemod/extensions/sdktools.ext.2.sdk2013.so',
'addons/sourcemod/extensions/sdktools.ext.2.tf2.so',
'addons/sourcemod/extensions/topmenus.ext.so',
'addons/sourcemod/extensions/updater.ext.so',
'addons/sourcemod/extensions/webternet.ext.so',
'addons/sourcemod/extensions/x64/bintools.ext.so',
'addons/sourcemod/extensions/x64/clientprefs.ext.so',
'addons/sourcemod/extensions/x64/dbi.mysql.ext.so',
'addons/sourcemod/extensions/x64/dbi.pgsql.ext.so',
'addons/sourcemod/extensions/x64/dbi.sqlite.ext.so',
'addons/sourcemod/extensions/x64/game.cstrike.ext.2.csgo.so',
'addons/sourcemod/extensions/x64/geoip.ext.so',
'addons/sourcemod/extensions/x64/regex.ext.so',
'addons/sourcemod/extensions/x64/sdkhooks.ext.2.blade.so',
'addons/sourcemod/extensions/x64/sdkhooks.ext.2.csgo.so',
'addons/sourcemod/extensions/x64/sdktools.ext.2.blade.so',
'addons/sourcemod/extensions/x64/sdktools.ext.2.csgo.so',
'addons/sourcemod/extensions/x64/topmenus.ext.so',
'addons/sourcemod/extensions/x64/updater.ext.so',
'addons/sourcemod/extensions/x64/webternet.ext.so',
'addons/sourcemod/gamedata/core.games/blocklist.plugins.txt',
'addons/sourcemod/gamedata/core.games/common.games.txt',
'addons/sourcemod/gamedata/core.games/engine.bgt.txt',
'addons/sourcemod/gamedata/core.games/engine.blade.txt',
'addons/sourcemod/gamedata/core.games/engine.bms.txt',
'addons/sourcemod/gamedata/core.games/engine.contagion.txt',
'addons/sourcemod/gamedata/core.games/engine.csgo.txt',
'addons/sourcemod/gamedata/core.games/engine.css.txt',
'addons/sourcemod/gamedata/core.games/engine.darkm.txt',
'addons/sourcemod/gamedata/core.games/engine.ep1.txt',
'addons/sourcemod/gamedata/core.games/engine.ep2.txt',
'addons/sourcemod/gamedata/core.games/engine.ep2valve.txt',
'addons/sourcemod/gamedata/core.games/engine.eye.txt',
'addons/sourcemod/gamedata/core.games/engine.insurgency.txt',
'addons/sourcemod/gamedata/core.games/engine.l4d.txt',
'addons/sourcemod/gamedata/core.games/engine.l4d2.txt',
'addons/sourcemod/gamedata/core.games/engine.sdk2013.txt',
'addons/sourcemod/gamedata/core.games/engine.swarm.txt',
'addons/sourcemod/gamedata/core.games/game.dinodday.txt',
'addons/sourcemod/gamedata/core.games/master.games.txt',
'addons/sourcemod/gamedata/funcommands.games.txt',
'addons/sourcemod/gamedata/sdkhooks.games/common.games.txt',
'addons/sourcemod/gamedata/sdkhooks.games/engine.blade.txt',
'addons/sourcemod/gamedata/sdkhooks.games/engine.contagion.txt',
'addons/sourcemod/gamedata/sdkhooks.games/engine.csgo.txt',
'addons/sourcemod/gamedata/sdkhooks.games/engine.darkm.txt',
'addons/sourcemod/gamedata/sdkhooks.games/engine.ep2v.txt',
'addons/sourcemod/gamedata/sdkhooks.games/engine.insurgency.txt',
'addons/sourcemod/gamedata/sdkhooks.games/engine.l4d.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.ag2.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.alienswarm.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.aoc.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.bms.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.cspromod.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.cstrike.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.dinodday.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.doi.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.empires.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.ff.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.fof.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.gesource.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.hidden.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.hl2ctf.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.insurgency.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.kz.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.l4d2.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.modularcombat.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.neotokyo.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.nmrih.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.nucleardawn.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.pvkii.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.reactivedrop.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.sgtls.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.sourceforts.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.synergy.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.zm.txt',
'addons/sourcemod/gamedata/sdkhooks.games/game.zpanic.txt',
'addons/sourcemod/gamedata/sdkhooks.games/master.games.txt',
'addons/sourcemod/gamedata/sdktools.games/common.games.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.bgt.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.blade.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.contagion.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.csgo.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.css.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.darkm.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.ep1.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.ep2.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.ep2valve.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.eye.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.insurgency.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.l4d.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.l4d2.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.sdk2013.txt',
'addons/sourcemod/gamedata/sdktools.games/engine.swarm.txt',
'addons/sourcemod/gamedata/sdktools.games/game.ag2.txt',
'addons/sourcemod/gamedata/sdktools.games/game.alienswarm.txt',
'addons/sourcemod/gamedata/sdktools.games/game.aoc.txt',
'addons/sourcemod/gamedata/sdktools.games/game.bg2.txt',
'addons/sourcemod/gamedata/sdktools.games/game.bms.txt',
'addons/sourcemod/gamedata/sdktools.games/game.cspromod.txt',
'addons/sourcemod/gamedata/sdktools.games/game.cstrike.txt',
'addons/sourcemod/gamedata/sdktools.games/game.dinodday.txt',
'addons/sourcemod/gamedata/sdktools.games/game.dod.txt',
'addons/sourcemod/gamedata/sdktools.games/game.doi.txt',
'addons/sourcemod/gamedata/sdktools.games/game.dystopia.txt',
'addons/sourcemod/gamedata/sdktools.games/game.empires.txt',
'addons/sourcemod/gamedata/sdktools.games/game.esmod.txt',
'addons/sourcemod/gamedata/sdktools.games/game.fas.txt',
'addons/sourcemod/gamedata/sdktools.games/game.ff.txt',
'addons/sourcemod/gamedata/sdktools.games/game.fof.txt',
'addons/sourcemod/gamedata/sdktools.games/game.gesource.txt',
'addons/sourcemod/gamedata/sdktools.games/game.hidden.txt',
'addons/sourcemod/gamedata/sdktools.games/game.hl2ctf.txt',
'addons/sourcemod/gamedata/sdktools.games/game.hl2mp.txt',
'addons/sourcemod/gamedata/sdktools.games/game.insurgency.txt',
'addons/sourcemod/gamedata/sdktools.games/game.ios.txt',
'addons/sourcemod/gamedata/sdktools.games/game.kz.txt',
'addons/sourcemod/gamedata/sdktools.games/game.left4dead2.txt',
'addons/sourcemod/gamedata/sdktools.games/game.modularcombat.txt',
'addons/sourcemod/gamedata/sdktools.games/game.neotokyo.txt',
'addons/sourcemod/gamedata/sdktools.games/game.nmrih.txt',
'addons/sourcemod/gamedata/sdktools.games/game.nucleardawn.txt',
'addons/sourcemod/gamedata/sdktools.games/game.obsidian.txt',
'addons/sourcemod/gamedata/sdktools.games/game.pvkii.txt',
'addons/sourcemod/gamedata/sdktools.games/game.reactivedrop.txt',
'addons/sourcemod/gamedata/sdktools.games/game.rnlbeta.txt',
'addons/sourcemod/gamedata/sdktools.games/game.ship.txt',
'addons/sourcemod/gamedata/sdktools.games/game.sourceforts.txt',
'addons/sourcemod/gamedata/sdktools.games/game.synergy.txt',
'addons/sourcemod/gamedata/sdktools.games/game.tf.txt',
'addons/sourcemod/gamedata/sdktools.games/game.zm.txt',
'addons/sourcemod/gamedata/sdktools.games/game.zpanic.txt',
'addons/sourcemod/gamedata/sdktools.games/master.games.txt',
'addons/sourcemod/gamedata/sm-cstrike.games/game.csgo.txt',
'addons/sourcemod/gamedata/sm-cstrike.games/game.css.txt',
'addons/sourcemod/gamedata/sm-cstrike.games/master.games.txt',
'addons/sourcemod/gamedata/sm-tf2.games.txt',
'addons/sourcemod/GPLv2.txt',
'addons/sourcemod/GPLv3.txt',
'addons/sourcemod/LICENSE.txt',
'addons/sourcemod/plugins/admin-flatfile.smx',
'addons/sourcemod/plugins/adminhelp.smx',
'addons/sourcemod/plugins/adminmenu.smx',
'addons/sourcemod/plugins/antiflood.smx',
'addons/sourcemod/plugins/basebans.smx',
'addons/sourcemod/plugins/basechat.smx',
'addons/sourcemod/plugins/basecomm.smx',
'addons/sourcemod/plugins/basecommands.smx',
'addons/sourcemod/plugins/basetriggers.smx',
'addons/sourcemod/plugins/basevotes.smx',
'addons/sourcemod/plugins/clientprefs.smx',
'addons/sourcemod/plugins/disabled/admin-sql-prefetch.smx',
'addons/sourcemod/plugins/disabled/admin-sql-threaded.smx',
'addons/sourcemod/plugins/disabled/mapchooser.smx',
'addons/sourcemod/plugins/disabled/nominations.smx',
'addons/sourcemod/plugins/disabled/randomcycle.smx',
'addons/sourcemod/plugins/disabled/rockthevote.smx',
'addons/sourcemod/plugins/disabled/sql-admin-manager.smx',
'addons/sourcemod/plugins/funcommands.smx',
'addons/sourcemod/plugins/funvotes.smx',
'addons/sourcemod/plugins/nextmap.smx',
'addons/sourcemod/plugins/playercommands.smx',
'addons/sourcemod/plugins/reservedslots.smx',
'addons/sourcemod/plugins/sounds.smx',
'addons/sourcemod/scripting/admin-flatfile/admin-flatfile.sp',
'addons/sourcemod/scripting/admin-flatfile/admin-groups.sp',
'addons/sourcemod/scripting/admin-flatfile/admin-overrides.sp',
'addons/sourcemod/scripting/admin-flatfile/admin-simple.sp',
'addons/sourcemod/scripting/admin-flatfile/admin-users.sp',
'addons/sourcemod/scripting/admin-sql-prefetch.sp',
'addons/sourcemod/scripting/admin-sql-threaded.sp',
'addons/sourcemod/scripting/adminhelp.sp',
'addons/sourcemod/scripting/adminmenu.sp',
'addons/sourcemod/scripting/adminmenu/dynamicmenu.sp',
'addons/sourcemod/scripting/antiflood.sp',
'addons/sourcemod/scripting/basebans.sp',
'addons/sourcemod/scripting/basebans/ban.sp',
'addons/sourcemod/scripting/basechat.sp',
'addons/sourcemod/scripting/basecomm.sp',
'addons/sourcemod/scripting/basecommands.sp',
'addons/sourcemod/scripting/basecommands/cancelvote.sp',
'addons/sourcemod/scripting/basecommands/execcfg.sp',
'addons/sourcemod/scripting/basecommands/kick.sp',
'addons/sourcemod/scripting/basecommands/map.sp',
'addons/sourcemod/scripting/basecommands/reloadadmins.sp',
'addons/sourcemod/scripting/basecommands/who.sp',
'addons/sourcemod/scripting/basecomm/forwards.sp',
'addons/sourcemod/scripting/basecomm/gag.sp',
'addons/sourcemod/scripting/basecomm/natives.sp',
'addons/sourcemod/scripting/basetriggers.sp',
'addons/sourcemod/scripting/basevotes.sp',
'addons/sourcemod/scripting/basevotes/voteban.sp',
'addons/sourcemod/scripting/basevotes/votekick.sp',
'addons/sourcemod/scripting/basevotes/votemap.sp',
'addons/sourcemod/scripting/clientprefs.sp',
'addons/sourcemod/scripting/compile.sh',
'addons/sourcemod/scripting/funcommands.sp',
'addons/sourcemod/scripting/funcommands/beacon.sp',
'addons/sourcemod/scripting/funcommands/blind.sp',
'addons/sourcemod/scripting/funcommands/drug.sp',
'addons/sourcemod/scripting/funcommands/fire.sp',
'addons/sourcemod/scripting/funcommands/gravity.sp',
'addons/sourcemod/scripting/funcommands/ice.sp',
'addons/sourcemod/scripting/funcommands/noclip.sp',
'addons/sourcemod/scripting/funcommands/timebomb.sp',
'addons/sourcemod/scripting/funvotes.sp',
'addons/sourcemod/scripting/funvotes/votealltalk.sp',
'addons/sourcemod/scripting/funvotes/voteburn.sp',
'addons/sourcemod/scripting/funvotes/voteff.sp',
'addons/sourcemod/scripting/funvotes/votegravity.sp',
'addons/sourcemod/scripting/funvotes/voteslay.sp',
'addons/sourcemod/scripting/include/admin.inc',
'addons/sourcemod/scripting/include/adminmenu.inc',
'addons/sourcemod/scripting/include/adt.inc',
'addons/sourcemod/scripting/include/adt_array.inc',
'addons/sourcemod/scripting/include/adt_stack.inc',
'addons/sourcemod/scripting/include/adt_trie.inc',
'addons/sourcemod/scripting/include/banning.inc',
'addons/sourcemod/scripting/include/basecomm.inc',
'addons/sourcemod/scripting/include/bitbuffer.inc',
'addons/sourcemod/scripting/include/clientprefs.inc',
'addons/sourcemod/scripting/include/clients.inc',
'addons/sourcemod/scripting/include/commandfilters.inc',
'addons/sourcemod/scripting/include/commandline.inc',
'addons/sourcemod/scripting/include/console.inc',
'addons/sourcemod/scripting/include/convars.inc',
'addons/sourcemod/scripting/include/core.inc',
'addons/sourcemod/scripting/include/cstrike.inc',
'addons/sourcemod/scripting/include/datapack.inc',
'addons/sourcemod/scripting/include/dbi.inc',
'addons/sourcemod/scripting/include/dhooks.inc',
'addons/sourcemod/scripting/include/entity.inc',
'addons/sourcemod/scripting/include/entity_prop_stocks.inc',
'addons/sourcemod/scripting/include/events.inc',
'addons/sourcemod/scripting/include/files.inc',
'addons/sourcemod/scripting/include/float.inc',
'addons/sourcemod/scripting/include/functions.inc',
'addons/sourcemod/scripting/include/geoip.inc',
'addons/sourcemod/scripting/include/halflife.inc',
'addons/sourcemod/scripting/include/handles.inc',
'addons/sourcemod/scripting/include/helpers.inc',
'addons/sourcemod/scripting/include/keyvalues.inc',
'addons/sourcemod/scripting/include/lang.inc',
'addons/sourcemod/scripting/include/logging.inc',
'addons/sourcemod/scripting/include/mapchooser.inc',
'addons/sourcemod/scripting/include/menus.inc',
'addons/sourcemod/scripting/include/nextmap.inc',
'addons/sourcemod/scripting/include/profiler.inc',
'addons/sourcemod/scripting/include/protobuf.inc',
'addons/sourcemod/scripting/include/regex.inc',
'addons/sourcemod/scripting/include/sdkhooks.inc',
'addons/sourcemod/scripting/include/sdktools.inc',
'addons/sourcemod/scripting/include/sdktools_client.inc',
'addons/sourcemod/scripting/include/sdktools_engine.inc',
'addons/sourcemod/scripting/include/sdktools_entinput.inc',
'addons/sourcemod/scripting/include/sdktools_entoutput.inc',
'addons/sourcemod/scripting/include/sdktools_functions.inc',
'addons/sourcemod/scripting/include/sdktools_gamerules.inc',
'addons/sourcemod/scripting/include/sdktools_hooks.inc',
'addons/sourcemod/scripting/include/sdktools_sound.inc',
'addons/sourcemod/scripting/include/sdktools_stocks.inc',
'addons/sourcemod/scripting/include/sdktools_stringtables.inc',
'addons/sourcemod/scripting/include/sdktools_tempents.inc',
'addons/sourcemod/scripting/include/sdktools_tempents_stocks.inc',
'addons/sourcemod/scripting/include/sdktools_trace.inc',
'addons/sourcemod/scripting/include/sdktools_variant_t.inc',
'addons/sourcemod/scripting/include/sdktools_voice.inc',
'addons/sourcemod/scripting/include/sorting.inc',
'addons/sourcemod/scripting/include/sourcemod.inc',
'addons/sourcemod/scripting/include/string.inc',
'addons/sourcemod/scripting/include/testing.inc',
'addons/sourcemod/scripting/include/textparse.inc',
'addons/sourcemod/scripting/include/tf2.inc',
'addons/sourcemod/scripting/include/tf2_stocks.inc',
'addons/sourcemod/scripting/include/timers.inc',
'addons/sourcemod/scripting/include/topmenus.inc',
'addons/sourcemod/scripting/include/usermessages.inc',
'addons/sourcemod/scripting/include/vector.inc',
'addons/sourcemod/scripting/include/version.inc',
'addons/sourcemod/scripting/include/version_auto.inc',
'addons/sourcemod/scripting/mapchooser.sp',
'addons/sourcemod/scripting/nextmap.sp',
'addons/sourcemod/scripting/nominations.sp',
'addons/sourcemod/scripting/playercommands.sp',
'addons/sourcemod/scripting/playercommands/rename.sp',
'addons/sourcemod/scripting/playercommands/slap.sp',
'addons/sourcemod/scripting/playercommands/slay.sp',
'addons/sourcemod/scripting/randomcycle.sp',
'addons/sourcemod/scripting/reservedslots.sp',
'addons/sourcemod/scripting/rockthevote.sp',
'addons/sourcemod/scripting/sounds.sp',
'addons/sourcemod/scripting/spcomp',
'addons/sourcemod/scripting/spcomp64',
'addons/sourcemod/scripting/sql-admin-manager.sp',
'addons/sourcemod/scripting/testsuite/benchmark.sp',
'addons/sourcemod/scripting/testsuite/bug4059.sp',
'addons/sourcemod/scripting/testsuite/callfunctest.sp',
'addons/sourcemod/scripting/testsuite/capstest.sp',
'addons/sourcemod/scripting/testsuite/clientprefstest.sp',
'addons/sourcemod/scripting/testsuite/cstrike-test.sp',
'addons/sourcemod/scripting/testsuite/entpropelements.sp',
'addons/sourcemod/scripting/testsuite/fakenative1.sp',
'addons/sourcemod/scripting/testsuite/fakenative2.sp',
'addons/sourcemod/scripting/testsuite/filetest.sp',
'addons/sourcemod/scripting/testsuite/findmap.sp',
'addons/sourcemod/scripting/testsuite/floats.sp',
'addons/sourcemod/scripting/testsuite/fwdtest1.sp',
'addons/sourcemod/scripting/testsuite/fwdtest2.sp',
'addons/sourcemod/scripting/testsuite/gamerules-props.sp',
'addons/sourcemod/scripting/testsuite/goto_test.sp',
'addons/sourcemod/scripting/testsuite/keyvalues.sp',
'addons/sourcemod/scripting/testsuite/mapdisplayname.sp',
'addons/sourcemod/scripting/testsuite/outputtest.sp',
'addons/sourcemod/scripting/testsuite/ptstest.sp',
'addons/sourcemod/scripting/testsuite/sorttest.sp',
'addons/sourcemod/scripting/testsuite/sqltest.sp',
'addons/sourcemod/scripting/testsuite/sqltest.sql',
'addons/sourcemod/scripting/testsuite/stacktest.sp',
'addons/sourcemod/scripting/testsuite/structtest.sp',
'addons/sourcemod/scripting/testsuite/tf2-test.sp',
'addons/sourcemod/scripting/testsuite/tries.sp',
'addons/sourcemod/translations/adminhelp.phrases.txt',
'addons/sourcemod/translations/adminmenu.phrases.txt',
'addons/sourcemod/translations/antiflood.phrases.txt',
'addons/sourcemod/translations/ar/adminhelp.phrases.txt',
'addons/sourcemod/translations/ar/adminmenu.phrases.txt',
'addons/sourcemod/translations/ar/antiflood.phrases.txt',
'addons/sourcemod/translations/ar/basebans.phrases.txt',
'addons/sourcemod/translations/ar/basecomm.phrases.txt',
'addons/sourcemod/translations/ar/basetriggers.phrases.txt',
'addons/sourcemod/translations/ar/basevotes.phrases.txt',
'addons/sourcemod/translations/ar/clientprefs.phrases.txt',
'addons/sourcemod/translations/ar/common.phrases.txt',
'addons/sourcemod/translations/ar/core.phrases.txt',
'addons/sourcemod/translations/ar/funcommands.phrases.txt',
'addons/sourcemod/translations/ar/funvotes.phrases.txt',
'addons/sourcemod/translations/ar/mapchooser.phrases.txt',
'addons/sourcemod/translations/ar/nextmap.phrases.txt',
'addons/sourcemod/translations/ar/nominations.phrases.txt',
'addons/sourcemod/translations/ar/playercommands.phrases.txt',
'addons/sourcemod/translations/ar/plugin.basecommands.txt',
'addons/sourcemod/translations/ar/reservedslots.phrases.txt',
'addons/sourcemod/translations/ar/rockthevote.phrases.txt',
'addons/sourcemod/translations/ar/sounds.phrases.txt',
'addons/sourcemod/translations/ar/sqladmins.phrases.txt',
'addons/sourcemod/translations/basebans.phrases.txt',
'addons/sourcemod/translations/basecomm.phrases.txt',
'addons/sourcemod/translations/basetriggers.phrases.txt',
'addons/sourcemod/translations/basevotes.phrases.txt',
'addons/sourcemod/translations/bg/adminhelp.phrases.txt',
'addons/sourcemod/translations/bg/adminmenu.phrases.txt',
'addons/sourcemod/translations/bg/antiflood.phrases.txt',
'addons/sourcemod/translations/bg/basebans.phrases.txt',
'addons/sourcemod/translations/bg/basecomm.phrases.txt',
'addons/sourcemod/translations/bg/basetriggers.phrases.txt',
'addons/sourcemod/translations/bg/basevotes.phrases.txt',
'addons/sourcemod/translations/bg/clientprefs.phrases.txt',
'addons/sourcemod/translations/bg/common.phrases.txt',
'addons/sourcemod/translations/bg/core.phrases.txt',
'addons/sourcemod/translations/bg/funcommands.phrases.txt',
'addons/sourcemod/translations/bg/funvotes.phrases.txt',
'addons/sourcemod/translations/bg/mapchooser.phrases.txt',
'addons/sourcemod/translations/bg/nextmap.phrases.txt',
'addons/sourcemod/translations/bg/nominations.phrases.txt',
'addons/sourcemod/translations/bg/playercommands.phrases.txt',
'addons/sourcemod/translations/bg/plugin.basecommands.txt',
'addons/sourcemod/translations/bg/reservedslots.phrases.txt',
'addons/sourcemod/translations/bg/rockthevote.phrases.txt',
'addons/sourcemod/translations/bg/sounds.phrases.txt',
'addons/sourcemod/translations/bg/sqladmins.phrases.txt',
'addons/sourcemod/translations/chi/adminhelp.phrases.txt',
'addons/sourcemod/translations/chi/adminmenu.phrases.txt',
'addons/sourcemod/translations/chi/antiflood.phrases.txt',
'addons/sourcemod/translations/chi/basebans.phrases.txt',
'addons/sourcemod/translations/chi/basecomm.phrases.txt',
'addons/sourcemod/translations/chi/basetriggers.phrases.txt',
'addons/sourcemod/translations/chi/basevotes.phrases.txt',
'addons/sourcemod/translations/chi/clientprefs.phrases.txt',
'addons/sourcemod/translations/chi/common.phrases.txt',
'addons/sourcemod/translations/chi/core.phrases.txt',
'addons/sourcemod/translations/chi/funcommands.phrases.txt',
'addons/sourcemod/translations/chi/funvotes.phrases.txt',
'addons/sourcemod/translations/chi/mapchooser.phrases.txt',
'addons/sourcemod/translations/chi/nextmap.phrases.txt',
'addons/sourcemod/translations/chi/nominations.phrases.txt',
'addons/sourcemod/translations/chi/playercommands.phrases.txt',
'addons/sourcemod/translations/chi/plugin.basecommands.txt',
'addons/sourcemod/translations/chi/reservedslots.phrases.txt',
'addons/sourcemod/translations/chi/rockthevote.phrases.txt',
'addons/sourcemod/translations/chi/slapslay.phrases.txt',
'addons/sourcemod/translations/chi/sounds.phrases.txt',
'addons/sourcemod/translations/chi/sqladmins.phrases.txt',
'addons/sourcemod/translations/clientprefs.phrases.txt',
'addons/sourcemod/translations/common.phrases.txt',
'addons/sourcemod/translations/core.phrases.txt',
'addons/sourcemod/translations/cze/adminhelp.phrases.txt',
'addons/sourcemod/translations/cze/adminmenu.phrases.txt',
'addons/sourcemod/translations/cze/antiflood.phrases.txt',
'addons/sourcemod/translations/cze/basebans.phrases.txt',
'addons/sourcemod/translations/cze/basecomm.phrases.txt',
'addons/sourcemod/translations/cze/basetriggers.phrases.txt',
'addons/sourcemod/translations/cze/basevotes.phrases.txt',
'addons/sourcemod/translations/cze/clientprefs.phrases.txt',
'addons/sourcemod/translations/cze/common.phrases.txt',
'addons/sourcemod/translations/cze/core.phrases.txt',
'addons/sourcemod/translations/cze/funcommands.phrases.txt',
'addons/sourcemod/translations/cze/funvotes.phrases.txt',
'addons/sourcemod/translations/cze/mapchooser.phrases.txt',
'addons/sourcemod/translations/cze/nextmap.phrases.txt',
'addons/sourcemod/translations/cze/nominations.phrases.txt',
'addons/sourcemod/translations/cze/playercommands.phrases.txt',
'addons/sourcemod/translations/cze/plugin.basecommands.txt',
'addons/sourcemod/translations/cze/reservedslots.phrases.txt',
'addons/sourcemod/translations/cze/rockthevote.phrases.txt',
'addons/sourcemod/translations/cze/sounds.phrases.txt',
'addons/sourcemod/translations/cze/sqladmins.phrases.txt',
'addons/sourcemod/translations/da/adminhelp.phrases.txt',
'addons/sourcemod/translations/da/adminmenu.phrases.txt',
'addons/sourcemod/translations/da/antiflood.phrases.txt',
'addons/sourcemod/translations/da/basebans.phrases.txt',
'addons/sourcemod/translations/da/basecomm.phrases.txt',
'addons/sourcemod/translations/da/basetriggers.phrases.txt',
'addons/sourcemod/translations/da/basevotes.phrases.txt',
'addons/sourcemod/translations/da/clientprefs.phrases.txt',
'addons/sourcemod/translations/da/common.phrases.txt',
'addons/sourcemod/translations/da/core.phrases.txt',
'addons/sourcemod/translations/da/funcommands.phrases.txt',
'addons/sourcemod/translations/da/funvotes.phrases.txt',
'addons/sourcemod/translations/da/mapchooser.phrases.txt',
'addons/sourcemod/translations/da/nextmap.phrases.txt',
'addons/sourcemod/translations/da/nominations.phrases.txt',
'addons/sourcemod/translations/da/playercommands.phrases.txt',
'addons/sourcemod/translations/da/plugin.basecommands.txt',
'addons/sourcemod/translations/da/reservedslots.phrases.txt',
'addons/sourcemod/translations/da/rockthevote.phrases.txt',
'addons/sourcemod/translations/da/slapslay.phrases.txt',
'addons/sourcemod/translations/da/sounds.phrases.txt',
'addons/sourcemod/translations/da/sqladmins.phrases.txt',
'addons/sourcemod/translations/de/adminhelp.phrases.txt',
'addons/sourcemod/translations/de/adminmenu.phrases.txt',
'addons/sourcemod/translations/de/antiflood.phrases.txt',
'addons/sourcemod/translations/de/basebans.phrases.txt',
'addons/sourcemod/translations/de/basecomm.phrases.txt',
'addons/sourcemod/translations/de/basetriggers.phrases.txt',
'addons/sourcemod/translations/de/basevotes.phrases.txt',
'addons/sourcemod/translations/de/clientprefs.phrases.txt',
'addons/sourcemod/translations/de/common.phrases.txt',
'addons/sourcemod/translations/de/core.phrases.txt',
'addons/sourcemod/translations/de/funcommands.phrases.txt',
'addons/sourcemod/translations/de/funvotes.phrases.txt',
'addons/sourcemod/translations/de/mapchooser.phrases.txt',
'addons/sourcemod/translations/de/nextmap.phrases.txt',
'addons/sourcemod/translations/de/nominations.phrases.txt',
'addons/sourcemod/translations/de/playercommands.phrases.txt',
'addons/sourcemod/translations/de/plugin.basecommands.txt',
'addons/sourcemod/translations/de/reservedslots.phrases.txt',
'addons/sourcemod/translations/de/rockthevote.phrases.txt',
'addons/sourcemod/translations/de/slapslay.phrases.txt',
'addons/sourcemod/translations/de/sounds.phrases.txt',
'addons/sourcemod/translations/de/sqladmins.phrases.txt',
'addons/sourcemod/translations/el/adminhelp.phrases.txt',
'addons/sourcemod/translations/el/adminmenu.phrases.txt',
'addons/sourcemod/translations/el/antiflood.phrases.txt',
'addons/sourcemod/translations/el/basebans.phrases.txt',
'addons/sourcemod/translations/el/basecomm.phrases.txt',
'addons/sourcemod/translations/el/basetriggers.phrases.txt',
'addons/sourcemod/translations/el/basevotes.phrases.txt',
'addons/sourcemod/translations/el/clientprefs.phrases.txt',
'addons/sourcemod/translations/el/common.phrases.txt',
'addons/sourcemod/translations/el/core.phrases.txt',
'addons/sourcemod/translations/el/funcommands.phrases.txt',
'addons/sourcemod/translations/el/funvotes.phrases.txt',
'addons/sourcemod/translations/el/mapchooser.phrases.txt',
'addons/sourcemod/translations/el/nextmap.phrases.txt',
'addons/sourcemod/translations/el/nominations.phrases.txt',
'addons/sourcemod/translations/el/playercommands.phrases.txt',
'addons/sourcemod/translations/el/plugin.basecommands.txt',
'addons/sourcemod/translations/el/reservedslots.phrases.txt',
'addons/sourcemod/translations/el/rockthevote.phrases.txt',
'addons/sourcemod/translations/el/sounds.phrases.txt',
'addons/sourcemod/translations/el/sqladmins.phrases.txt',
'addons/sourcemod/translations/es/adminhelp.phrases.txt',
'addons/sourcemod/translations/es/adminmenu.phrases.txt',
'addons/sourcemod/translations/es/antiflood.phrases.txt',
'addons/sourcemod/translations/es/basebans.phrases.txt',
'addons/sourcemod/translations/es/basecomm.phrases.txt',
'addons/sourcemod/translations/es/basetriggers.phrases.txt',
'addons/sourcemod/translations/es/basevotes.phrases.txt',
'addons/sourcemod/translations/es/clientprefs.phrases.txt',
'addons/sourcemod/translations/es/common.phrases.txt',
'addons/sourcemod/translations/es/core.phrases.txt',
'addons/sourcemod/translations/es/funcommands.phrases.txt',
'addons/sourcemod/translations/es/funvotes.phrases.txt',
'addons/sourcemod/translations/es/mapchooser.phrases.txt',
'addons/sourcemod/translations/es/nextmap.phrases.txt',
'addons/sourcemod/translations/es/nominations.phrases.txt',
'addons/sourcemod/translations/es/playercommands.phrases.txt',
'addons/sourcemod/translations/es/plugin.basecommands.txt',
'addons/sourcemod/translations/es/reservedslots.phrases.txt',
'addons/sourcemod/translations/es/rockthevote.phrases.txt',
'addons/sourcemod/translations/es/slapslay.phrases.txt',
'addons/sourcemod/translations/es/sounds.phrases.txt',
'addons/sourcemod/translations/es/sqladmins.phrases.txt',
'addons/sourcemod/translations/fi/adminhelp.phrases.txt',
'addons/sourcemod/translations/fi/adminmenu.phrases.txt',
'addons/sourcemod/translations/fi/antiflood.phrases.txt',
'addons/sourcemod/translations/fi/basebans.phrases.txt',
'addons/sourcemod/translations/fi/basecomm.phrases.txt',
'addons/sourcemod/translations/fi/basetriggers.phrases.txt',
'addons/sourcemod/translations/fi/basevotes.phrases.txt',
'addons/sourcemod/translations/fi/clientprefs.phrases.txt',
'addons/sourcemod/translations/fi/common.phrases.txt',
'addons/sourcemod/translations/fi/core.phrases.txt',
'addons/sourcemod/translations/fi/funcommands.phrases.txt',
'addons/sourcemod/translations/fi/funvotes.phrases.txt',
'addons/sourcemod/translations/fi/mapchooser.phrases.txt',
'addons/sourcemod/translations/fi/nextmap.phrases.txt',
'addons/sourcemod/translations/fi/nominations.phrases.txt',
'addons/sourcemod/translations/fi/playercommands.phrases.txt',
'addons/sourcemod/translations/fi/plugin.basecommands.txt',
'addons/sourcemod/translations/fi/reservedslots.phrases.txt',
'addons/sourcemod/translations/fi/rockthevote.phrases.txt',
'addons/sourcemod/translations/fi/sounds.phrases.txt',
'addons/sourcemod/translations/fi/sqladmins.phrases.txt',
'addons/sourcemod/translations/fr/adminhelp.phrases.txt',
'addons/sourcemod/translations/fr/adminmenu.phrases.txt',
'addons/sourcemod/translations/fr/antiflood.phrases.txt',
'addons/sourcemod/translations/fr/basebans.phrases.txt',
'addons/sourcemod/translations/fr/basecomm.phrases.txt',
'addons/sourcemod/translations/fr/basetriggers.phrases.txt',
'addons/sourcemod/translations/fr/basevotes.phrases.txt',
'addons/sourcemod/translations/fr/clientprefs.phrases.txt',
'addons/sourcemod/translations/fr/common.phrases.txt',
'addons/sourcemod/translations/fr/core.phrases.txt',
'addons/sourcemod/translations/fr/funcommands.phrases.txt',
'addons/sourcemod/translations/fr/funvotes.phrases.txt',
'addons/sourcemod/translations/fr/mapchooser.phrases.txt',
'addons/sourcemod/translations/fr/nextmap.phrases.txt',
'addons/sourcemod/translations/fr/nominations.phrases.txt',
'addons/sourcemod/translations/fr/playercommands.phrases.txt',
'addons/sourcemod/translations/fr/plugin.basecommands.txt',
'addons/sourcemod/translations/fr/reservedslots.phrases.txt',
'addons/sourcemod/translations/fr/rockthevote.phrases.txt',
'addons/sourcemod/translations/fr/slapslay.phrases.txt',
'addons/sourcemod/translations/fr/sounds.phrases.txt',
'addons/sourcemod/translations/fr/sqladmins.phrases.txt',
'addons/sourcemod/translations/funcommands.phrases.txt',
'addons/sourcemod/translations/funvotes.phrases.txt',
'addons/sourcemod/translations/he/adminhelp.phrases.txt',
'addons/sourcemod/translations/he/adminmenu.phrases.txt',
'addons/sourcemod/translations/he/antiflood.phrases.txt',
'addons/sourcemod/translations/he/basebans.phrases.txt',
'addons/sourcemod/translations/he/basecomm.phrases.txt',
'addons/sourcemod/translations/he/basetriggers.phrases.txt',
'addons/sourcemod/translations/he/basevotes.phrases.txt',
'addons/sourcemod/translations/he/clientprefs.phrases.txt',
'addons/sourcemod/translations/he/common.phrases.txt',
'addons/sourcemod/translations/he/core.phrases.txt',
'addons/sourcemod/translations/he/funcommands.phrases.txt',
'addons/sourcemod/translations/he/funvotes.phrases.txt',
'addons/sourcemod/translations/he/mapchooser.phrases.txt',
'addons/sourcemod/translations/he/nextmap.phrases.txt',
'addons/sourcemod/translations/he/nominations.phrases.txt',
'addons/sourcemod/translations/he/playercommands.phrases.txt',
'addons/sourcemod/translations/he/plugin.basecommands.txt',
'addons/sourcemod/translations/he/reservedslots.phrases.txt',
'addons/sourcemod/translations/he/rockthevote.phrases.txt',
'addons/sourcemod/translations/he/sounds.phrases.txt',
'addons/sourcemod/translations/he/sqladmins.phrases.txt',
'addons/sourcemod/translations/hu/adminhelp.phrases.txt',
'addons/sourcemod/translations/hu/adminmenu.phrases.txt',
'addons/sourcemod/translations/hu/antiflood.phrases.txt',
'addons/sourcemod/translations/hu/basebans.phrases.txt',
'addons/sourcemod/translations/hu/basecomm.phrases.txt',
'addons/sourcemod/translations/hu/basetriggers.phrases.txt',
'addons/sourcemod/translations/hu/basevotes.phrases.txt',
'addons/sourcemod/translations/hu/clientprefs.phrases.txt',
'addons/sourcemod/translations/hu/common.phrases.txt',
'addons/sourcemod/translations/hu/core.phrases.txt',
'addons/sourcemod/translations/hu/funcommands.phrases.txt',
'addons/sourcemod/translations/hu/funvotes.phrases.txt',
'addons/sourcemod/translations/hu/mapchooser.phrases.txt',
'addons/sourcemod/translations/hu/nextmap.phrases.txt',
'addons/sourcemod/translations/hu/nominations.phrases.txt',
'addons/sourcemod/translations/hu/playercommands.phrases.txt',
'addons/sourcemod/translations/hu/plugin.basecommands.txt',
'addons/sourcemod/translations/hu/reservedslots.phrases.txt',
'addons/sourcemod/translations/hu/rockthevote.phrases.txt',
'addons/sourcemod/translations/hu/slapslay.phrases.txt',
'addons/sourcemod/translations/hu/sounds.phrases.txt',
'addons/sourcemod/translations/hu/sqladmins.phrases.txt',
'addons/sourcemod/translations/it/adminhelp.phrases.txt',
'addons/sourcemod/translations/it/adminmenu.phrases.txt',
'addons/sourcemod/translations/it/antiflood.phrases.txt',
'addons/sourcemod/translations/it/basebans.phrases.txt',
'addons/sourcemod/translations/it/basecomm.phrases.txt',
'addons/sourcemod/translations/it/basetriggers.phrases.txt',
'addons/sourcemod/translations/it/basevotes.phrases.txt',
'addons/sourcemod/translations/it/clientprefs.phrases.txt',
'addons/sourcemod/translations/it/common.phrases.txt',
'addons/sourcemod/translations/it/core.phrases.txt',
'addons/sourcemod/translations/it/funcommands.phrases.txt',
'addons/sourcemod/translations/it/funvotes.phrases.txt',
'addons/sourcemod/translations/it/mapchooser.phrases.txt',
'addons/sourcemod/translations/it/nextmap.phrases.txt',
'addons/sourcemod/translations/it/nominations.phrases.txt',
'addons/sourcemod/translations/it/playercommands.phrases.txt',
'addons/sourcemod/translations/it/plugin.basecommands.txt',
'addons/sourcemod/translations/it/reservedslots.phrases.txt',
'addons/sourcemod/translations/it/rockthevote.phrases.txt',
'addons/sourcemod/translations/it/sounds.phrases.txt',
'addons/sourcemod/translations/it/sqladmins.phrases.txt',
'addons/sourcemod/translations/jp/adminhelp.phrases.txt',
'addons/sourcemod/translations/jp/adminmenu.phrases.txt',
'addons/sourcemod/translations/jp/antiflood.phrases.txt',
'addons/sourcemod/translations/jp/basebans.phrases.txt',
'addons/sourcemod/translations/jp/basecomm.phrases.txt',
'addons/sourcemod/translations/jp/basetriggers.phrases.txt',
'addons/sourcemod/translations/jp/basevotes.phrases.txt',
'addons/sourcemod/translations/jp/clientprefs.phrases.txt',
'addons/sourcemod/translations/jp/common.phrases.txt',
'addons/sourcemod/translations/jp/core.phrases.txt',
'addons/sourcemod/translations/jp/funcommands.phrases.txt',
'addons/sourcemod/translations/jp/funvotes.phrases.txt',
'addons/sourcemod/translations/jp/mapchooser.phrases.txt',
'addons/sourcemod/translations/jp/nextmap.phrases.txt',
'addons/sourcemod/translations/jp/nominations.phrases.txt',
'addons/sourcemod/translations/jp/playercommands.phrases.txt',
'addons/sourcemod/translations/jp/plugin.basecommands.txt',
'addons/sourcemod/translations/jp/reservedslots.phrases.txt',
'addons/sourcemod/translations/jp/rockthevote.phrases.txt',
'addons/sourcemod/translations/jp/slapslay.phrases.txt',
'addons/sourcemod/translations/jp/sounds.phrases.txt',
'addons/sourcemod/translations/jp/sqladmins.phrases.txt',
'addons/sourcemod/translations/ko/adminhelp.phrases.txt',
'addons/sourcemod/translations/ko/adminmenu.phrases.txt',
'addons/sourcemod/translations/ko/antiflood.phrases.txt',
'addons/sourcemod/translations/ko/basebans.phrases.txt',
'addons/sourcemod/translations/ko/basecomm.phrases.txt',
'addons/sourcemod/translations/ko/basetriggers.phrases.txt',
'addons/sourcemod/translations/ko/basevotes.phrases.txt',
'addons/sourcemod/translations/ko/clientprefs.phrases.txt',
'addons/sourcemod/translations/ko/common.phrases.txt',
'addons/sourcemod/translations/ko/core.phrases.txt',
'addons/sourcemod/translations/ko/funcommands.phrases.txt',
'addons/sourcemod/translations/ko/funvotes.phrases.txt',
'addons/sourcemod/translations/ko/mapchooser.phrases.txt',
'addons/sourcemod/translations/ko/nextmap.phrases.txt',
'addons/sourcemod/translations/ko/nominations.phrases.txt',
'addons/sourcemod/translations/ko/playercommands.phrases.txt',
'addons/sourcemod/translations/ko/plugin.basecommands.txt',
'addons/sourcemod/translations/ko/reservedslots.phrases.txt',
'addons/sourcemod/translations/ko/rockthevote.phrases.txt',
'addons/sourcemod/translations/ko/sounds.phrases.txt',
'addons/sourcemod/translations/ko/sqladmins.phrases.txt',
'addons/sourcemod/translations/lt/adminhelp.phrases.txt',
'addons/sourcemod/translations/lt/adminmenu.phrases.txt',
'addons/sourcemod/translations/lt/antiflood.phrases.txt',
'addons/sourcemod/translations/lt/basebans.phrases.txt',
'addons/sourcemod/translations/lt/basecomm.phrases.txt',
'addons/sourcemod/translations/lt/basetriggers.phrases.txt',
'addons/sourcemod/translations/lt/basevotes.phrases.txt',
'addons/sourcemod/translations/lt/clientprefs.phrases.txt',
'addons/sourcemod/translations/lt/common.phrases.txt',
'addons/sourcemod/translations/lt/core.phrases.txt',
'addons/sourcemod/translations/lt/funcommands.phrases.txt',
'addons/sourcemod/translations/lt/funvotes.phrases.txt',
'addons/sourcemod/translations/lt/mapchooser.phrases.txt',
'addons/sourcemod/translations/lt/nextmap.phrases.txt',
'addons/sourcemod/translations/lt/nominations.phrases.txt',
'addons/sourcemod/translations/lt/playercommands.phrases.txt',
'addons/sourcemod/translations/lt/plugin.basecommands.txt',
'addons/sourcemod/translations/lt/reservedslots.phrases.txt',
'addons/sourcemod/translations/lt/rockthevote.phrases.txt',
'addons/sourcemod/translations/lt/sounds.phrases.txt',
'addons/sourcemod/translations/lt/sqladmins.phrases.txt',
'addons/sourcemod/translations/lv/adminhelp.phrases.txt',
'addons/sourcemod/translations/lv/adminmenu.phrases.txt',
'addons/sourcemod/translations/lv/antiflood.phrases.txt',
'addons/sourcemod/translations/lv/basebans.phrases.txt',
'addons/sourcemod/translations/lv/basecomm.phrases.txt',
'addons/sourcemod/translations/lv/basetriggers.phrases.txt',
'addons/sourcemod/translations/lv/basevotes.phrases.txt',
'addons/sourcemod/translations/lv/clientprefs.phrases.txt',
'addons/sourcemod/translations/lv/common.phrases.txt',
'addons/sourcemod/translations/lv/core.phrases.txt',
'addons/sourcemod/translations/lv/funcommands.phrases.txt',
'addons/sourcemod/translations/lv/funvotes.phrases.txt',
'addons/sourcemod/translations/lv/mapchooser.phrases.txt',
'addons/sourcemod/translations/lv/nextmap.phrases.txt',
'addons/sourcemod/translations/lv/nominations.phrases.txt',
'addons/sourcemod/translations/lv/playercommands.phrases.txt',
'addons/sourcemod/translations/lv/plugin.basecommands.txt',
'addons/sourcemod/translations/lv/reservedslots.phrases.txt',
'addons/sourcemod/translations/lv/rockthevote.phrases.txt',
'addons/sourcemod/translations/lv/slapslay.phrases.txt',
'addons/sourcemod/translations/lv/sounds.phrases.txt',
'addons/sourcemod/translations/lv/sqladmins.phrases.txt',
'addons/sourcemod/translations/mapchooser.phrases.txt',
'addons/sourcemod/translations/nextmap.phrases.txt',
'addons/sourcemod/translations/nl/adminhelp.phrases.txt',
'addons/sourcemod/translations/nl/adminmenu.phrases.txt',
'addons/sourcemod/translations/nl/antiflood.phrases.txt',
'addons/sourcemod/translations/nl/basebans.phrases.txt',
'addons/sourcemod/translations/nl/basecomm.phrases.txt',
'addons/sourcemod/translations/nl/basetriggers.phrases.txt',
'addons/sourcemod/translations/nl/basevotes.phrases.txt',
'addons/sourcemod/translations/nl/clientprefs.phrases.txt',
'addons/sourcemod/translations/nl/common.phrases.txt',
'addons/sourcemod/translations/nl/core.phrases.txt',
'addons/sourcemod/translations/nl/funcommands.phrases.txt',
'addons/sourcemod/translations/nl/funvotes.phrases.txt',
'addons/sourcemod/translations/nl/mapchooser.phrases.txt',
'addons/sourcemod/translations/nl/nextmap.phrases.txt',
'addons/sourcemod/translations/nl/nominations.phrases.txt',
'addons/sourcemod/translations/nl/playercommands.phrases.txt',
'addons/sourcemod/translations/nl/plugin.basecommands.txt',
'addons/sourcemod/translations/nl/reservedslots.phrases.txt',
'addons/sourcemod/translations/nl/rockthevote.phrases.txt',
'addons/sourcemod/translations/nl/sounds.phrases.txt',
'addons/sourcemod/translations/nl/sqladmins.phrases.txt',
'addons/sourcemod/translations/nominations.phrases.txt',
'addons/sourcemod/translations/no/adminhelp.phrases.txt',
'addons/sourcemod/translations/no/adminmenu.phrases.txt',
'addons/sourcemod/translations/no/antiflood.phrases.txt',
'addons/sourcemod/translations/no/basebans.phrases.txt',
'addons/sourcemod/translations/no/basecomm.phrases.txt',
'addons/sourcemod/translations/no/basetriggers.phrases.txt',
'addons/sourcemod/translations/no/basevotes.phrases.txt',
'addons/sourcemod/translations/no/clientprefs.phrases.txt',
'addons/sourcemod/translations/no/common.phrases.txt',
'addons/sourcemod/translations/no/core.phrases.txt',
'addons/sourcemod/translations/no/funcommands.phrases.txt',
'addons/sourcemod/translations/no/funvotes.phrases.txt',
'addons/sourcemod/translations/no/mapchooser.phrases.txt',
'addons/sourcemod/translations/no/nextmap.phrases.txt',
'addons/sourcemod/translations/no/nominations.phrases.txt',
'addons/sourcemod/translations/no/playercommands.phrases.txt',
'addons/sourcemod/translations/no/plugin.basecommands.txt',
'addons/sourcemod/translations/no/reservedslots.phrases.txt',
'addons/sourcemod/translations/no/rockthevote.phrases.txt',
'addons/sourcemod/translations/no/slapslay.phrases.txt',
'addons/sourcemod/translations/no/sounds.phrases.txt',
'addons/sourcemod/translations/no/sqladmins.phrases.txt',
'addons/sourcemod/translations/playercommands.phrases.txt',
'addons/sourcemod/translations/plugin.basecommands.txt',
'addons/sourcemod/translations/pl/adminhelp.phrases.txt',
'addons/sourcemod/translations/pl/adminmenu.phrases.txt',
'addons/sourcemod/translations/pl/antiflood.phrases.txt',
'addons/sourcemod/translations/pl/basebans.phrases.txt',
'addons/sourcemod/translations/pl/basecomm.phrases.txt',
'addons/sourcemod/translations/pl/basetriggers.phrases.txt',
'addons/sourcemod/translations/pl/basevotes.phrases.txt',
'addons/sourcemod/translations/pl/clientprefs.phrases.txt',
'addons/sourcemod/translations/pl/common.phrases.txt',
'addons/sourcemod/translations/pl/core.phrases.txt',
'addons/sourcemod/translations/pl/funcommands.phrases.txt',
'addons/sourcemod/translations/pl/funvotes.phrases.txt',
'addons/sourcemod/translations/pl/mapchooser.phrases.txt',
'addons/sourcemod/translations/pl/nextmap.phrases.txt',
'addons/sourcemod/translations/pl/nominations.phrases.txt',
'addons/sourcemod/translations/pl/playercommands.phrases.txt',
'addons/sourcemod/translations/pl/plugin.basecommands.txt',
'addons/sourcemod/translations/pl/reservedslots.phrases.txt',
'addons/sourcemod/translations/pl/rockthevote.phrases.txt',
'addons/sourcemod/translations/pl/slapslay.phrases.txt',
'addons/sourcemod/translations/pl/sounds.phrases.txt',
'addons/sourcemod/translations/pl/sqladmins.phrases.txt',
'addons/sourcemod/translations/pt/adminhelp.phrases.txt',
'addons/sourcemod/translations/pt/adminmenu.phrases.txt',
'addons/sourcemod/translations/pt/antiflood.phrases.txt',
'addons/sourcemod/translations/pt/basebans.phrases.txt',
'addons/sourcemod/translations/pt/basecomm.phrases.txt',
'addons/sourcemod/translations/pt/basetriggers.phrases.txt',
'addons/sourcemod/translations/pt/basevotes.phrases.txt',
'addons/sourcemod/translations/pt/clientprefs.phrases.txt',
'addons/sourcemod/translations/pt/common.phrases.txt',
'addons/sourcemod/translations/pt/core.phrases.txt',
'addons/sourcemod/translations/pt/funcommands.phrases.txt',
'addons/sourcemod/translations/pt/funvotes.phrases.txt',
'addons/sourcemod/translations/pt/mapchooser.phrases.txt',
'addons/sourcemod/translations/pt/nextmap.phrases.txt',
'addons/sourcemod/translations/pt/nominations.phrases.txt',
'addons/sourcemod/translations/pt/playercommands.phrases.txt',
'addons/sourcemod/translations/pt/plugin.basecommands.txt',
'addons/sourcemod/translations/pt/reservedslots.phrases.txt',
'addons/sourcemod/translations/pt/rockthevote.phrases.txt',
'addons/sourcemod/translations/pt/slapslay.phrases.txt',
'addons/sourcemod/translations/pt/sounds.phrases.txt',
'addons/sourcemod/translations/pt/sqladmins.phrases.txt',
'addons/sourcemod/translations/pt_p/adminhelp.phrases.txt',
'addons/sourcemod/translations/pt_p/adminmenu.phrases.txt',
'addons/sourcemod/translations/pt_p/antiflood.phrases.txt',
'addons/sourcemod/translations/pt_p/basebans.phrases.txt',
'addons/sourcemod/translations/pt_p/basecomm.phrases.txt',
'addons/sourcemod/translations/pt_p/basetriggers.phrases.txt',
'addons/sourcemod/translations/pt_p/basevotes.phrases.txt',
'addons/sourcemod/translations/pt_p/clientprefs.phrases.txt',
'addons/sourcemod/translations/pt_p/common.phrases.txt',
'addons/sourcemod/translations/pt_p/core.phrases.txt',
'addons/sourcemod/translations/pt_p/funcommands.phrases.txt',
'addons/sourcemod/translations/pt_p/funvotes.phrases.txt',
'addons/sourcemod/translations/pt_p/mapchooser.phrases.txt',
'addons/sourcemod/translations/pt_p/nextmap.phrases.txt',
'addons/sourcemod/translations/pt_p/nominations.phrases.txt',
'addons/sourcemod/translations/pt_p/playercommands.phrases.txt',
'addons/sourcemod/translations/pt_p/plugin.basecommands.txt',
'addons/sourcemod/translations/pt_p/reservedslots.phrases.txt',
'addons/sourcemod/translations/pt_p/rockthevote.phrases.txt',
'addons/sourcemod/translations/pt_p/sounds.phrases.txt',
'addons/sourcemod/translations/pt_p/sqladmins.phrases.txt',
'addons/sourcemod/translations/reservedslots.phrases.txt',
'addons/sourcemod/translations/rockthevote.phrases.txt',
'addons/sourcemod/translations/ro/adminhelp.phrases.txt',
'addons/sourcemod/translations/ro/adminmenu.phrases.txt',
'addons/sourcemod/translations/ro/antiflood.phrases.txt',
'addons/sourcemod/translations/ro/basebans.phrases.txt',
'addons/sourcemod/translations/ro/basecomm.phrases.txt',
'addons/sourcemod/translations/ro/basetriggers.phrases.txt',
'addons/sourcemod/translations/ro/basevotes.phrases.txt',
'addons/sourcemod/translations/ro/clientprefs.phrases.txt',
'addons/sourcemod/translations/ro/common.phrases.txt',
'addons/sourcemod/translations/ro/core.phrases.txt',
'addons/sourcemod/translations/ro/funcommands.phrases.txt',
'addons/sourcemod/translations/ro/funvotes.phrases.txt',
'addons/sourcemod/translations/ro/mapchooser.phrases.txt',
'addons/sourcemod/translations/ro/nextmap.phrases.txt',
'addons/sourcemod/translations/ro/nominations.phrases.txt',
'addons/sourcemod/translations/ro/playercommands.phrases.txt',
'addons/sourcemod/translations/ro/plugin.basecommands.txt',
'addons/sourcemod/translations/ro/reservedslots.phrases.txt',
'addons/sourcemod/translations/ro/rockthevote.phrases.txt',
'addons/sourcemod/translations/ro/slapslay.phrases.txt',
'addons/sourcemod/translations/ro/sounds.phrases.txt',
'addons/sourcemod/translations/ro/sqladmins.phrases.txt',
'addons/sourcemod/translations/ru/adminhelp.phrases.txt',
'addons/sourcemod/translations/ru/adminmenu.phrases.txt',
'addons/sourcemod/translations/ru/antiflood.phrases.txt',
'addons/sourcemod/translations/ru/basebans.phrases.txt',
'addons/sourcemod/translations/ru/basecomm.phrases.txt',
'addons/sourcemod/translations/ru/basetriggers.phrases.txt',
'addons/sourcemod/translations/ru/basevotes.phrases.txt',
'addons/sourcemod/translations/ru/clientprefs.phrases.txt',
'addons/sourcemod/translations/ru/common.phrases.txt',
'addons/sourcemod/translations/ru/core.phrases.txt',
'addons/sourcemod/translations/ru/funcommands.phrases.txt',
'addons/sourcemod/translations/ru/funvotes.phrases.txt',
'addons/sourcemod/translations/ru/mapchooser.phrases.txt',
'addons/sourcemod/translations/ru/nextmap.phrases.txt',
'addons/sourcemod/translations/ru/nominations.phrases.txt',
'addons/sourcemod/translations/ru/playercommands.phrases.txt',
'addons/sourcemod/translations/ru/plugin.basecommands.txt',
'addons/sourcemod/translations/ru/reservedslots.phrases.txt',
'addons/sourcemod/translations/ru/rockthevote.phrases.txt',
'addons/sourcemod/translations/ru/slapslay.phrases.txt',
'addons/sourcemod/translations/ru/sounds.phrases.txt',
'addons/sourcemod/translations/ru/sqladmins.phrases.txt',
'addons/sourcemod/translations/sk/adminhelp.phrases.txt',
'addons/sourcemod/translations/sk/adminmenu.phrases.txt',
'addons/sourcemod/translations/sk/antiflood.phrases.txt',
'addons/sourcemod/translations/sk/basebans.phrases.txt',
'addons/sourcemod/translations/sk/basecomm.phrases.txt',
'addons/sourcemod/translations/sk/basetriggers.phrases.txt',
'addons/sourcemod/translations/sk/basevotes.phrases.txt',
'addons/sourcemod/translations/sk/clientprefs.phrases.txt',
'addons/sourcemod/translations/sk/common.phrases.txt',
'addons/sourcemod/translations/sk/core.phrases.txt',
'addons/sourcemod/translations/sk/funcommands.phrases.txt',
'addons/sourcemod/translations/sk/funvotes.phrases.txt',
'addons/sourcemod/translations/sk/mapchooser.phrases.txt',
'addons/sourcemod/translations/sk/nextmap.phrases.txt',
'addons/sourcemod/translations/sk/nominations.phrases.txt',
'addons/sourcemod/translations/sk/playercommands.phrases.txt',
'addons/sourcemod/translations/sk/plugin.basecommands.txt',
'addons/sourcemod/translations/sk/reservedslots.phrases.txt',
'addons/sourcemod/translations/sk/rockthevote.phrases.txt',
'addons/sourcemod/translations/sk/sounds.phrases.txt',
'addons/sourcemod/translations/sk/sqladmins.phrases.txt',
'addons/sourcemod/translations/sounds.phrases.txt',
'addons/sourcemod/translations/sqladmins.phrases.txt',
'addons/sourcemod/translations/sv/adminhelp.phrases.txt',
'addons/sourcemod/translations/sv/adminmenu.phrases.txt',
'addons/sourcemod/translations/sv/antiflood.phrases.txt',
'addons/sourcemod/translations/sv/basebans.phrases.txt',
'addons/sourcemod/translations/sv/basecomm.phrases.txt',
'addons/sourcemod/translations/sv/basetriggers.phrases.txt',
'addons/sourcemod/translations/sv/basevotes.phrases.txt',
'addons/sourcemod/translations/sv/clientprefs.phrases.txt',
'addons/sourcemod/translations/sv/common.phrases.txt',
'addons/sourcemod/translations/sv/core.phrases.txt',
'addons/sourcemod/translations/sv/funcommands.phrases.txt',
'addons/sourcemod/translations/sv/funvotes.phrases.txt',
'addons/sourcemod/translations/sv/mapchooser.phrases.txt',
'addons/sourcemod/translations/sv/nextmap.phrases.txt',
'addons/sourcemod/translations/sv/nominations.phrases.txt',
'addons/sourcemod/translations/sv/playercommands.phrases.txt',
'addons/sourcemod/translations/sv/plugin.basecommands.txt',
'addons/sourcemod/translations/sv/reservedslots.phrases.txt',
'addons/sourcemod/translations/sv/rockthevote.phrases.txt',
'addons/sourcemod/translations/sv/slapslay.phrases.txt',
'addons/sourcemod/translations/sv/sounds.phrases.txt',
'addons/sourcemod/translations/sv/sqladmins.phrases.txt',
'addons/sourcemod/translations/th/adminhelp.phrases.txt',
'addons/sourcemod/translations/th/adminmenu.phrases.txt',
'addons/sourcemod/translations/th/antiflood.phrases.txt',
'addons/sourcemod/translations/th/basebans.phrases.txt',
'addons/sourcemod/translations/th/basecomm.phrases.txt',
'addons/sourcemod/translations/th/basetriggers.phrases.txt',
'addons/sourcemod/translations/th/basevotes.phrases.txt',
'addons/sourcemod/translations/th/clientprefs.phrases.txt',
'addons/sourcemod/translations/th/common.phrases.txt',
'addons/sourcemod/translations/th/core.phrases.txt',
'addons/sourcemod/translations/th/funcommands.phrases.txt',
'addons/sourcemod/translations/th/funvotes.phrases.txt',
'addons/sourcemod/translations/th/mapchooser.phrases.txt',
'addons/sourcemod/translations/th/nextmap.phrases.txt',
'addons/sourcemod/translations/th/nominations.phrases.txt',
'addons/sourcemod/translations/th/playercommands.phrases.txt',
'addons/sourcemod/translations/th/plugin.basecommands.txt',
'addons/sourcemod/translations/th/reservedslots.phrases.txt',
'addons/sourcemod/translations/th/rockthevote.phrases.txt',
'addons/sourcemod/translations/th/sounds.phrases.txt',
'addons/sourcemod/translations/th/sqladmins.phrases.txt',
'addons/sourcemod/translations/tr/adminhelp.phrases.txt',
'addons/sourcemod/translations/tr/adminmenu.phrases.txt',
'addons/sourcemod/translations/tr/antiflood.phrases.txt',
'addons/sourcemod/translations/tr/basebans.phrases.txt',
'addons/sourcemod/translations/tr/basecomm.phrases.txt',
'addons/sourcemod/translations/tr/basetriggers.phrases.txt',
'addons/sourcemod/translations/tr/basevotes.phrases.txt',
'addons/sourcemod/translations/tr/clientprefs.phrases.txt',
'addons/sourcemod/translations/tr/common.phrases.txt',
'addons/sourcemod/translations/tr/core.phrases.txt',
'addons/sourcemod/translations/tr/funcommands.phrases.txt',
'addons/sourcemod/translations/tr/funvotes.phrases.txt',
'addons/sourcemod/translations/tr/mapchooser.phrases.txt',
'addons/sourcemod/translations/tr/nextmap.phrases.txt',
'addons/sourcemod/translations/tr/nominations.phrases.txt',
'addons/sourcemod/translations/tr/playercommands.phrases.txt',
'addons/sourcemod/translations/tr/plugin.basecommands.txt',
'addons/sourcemod/translations/tr/reservedslots.phrases.txt',
'addons/sourcemod/translations/tr/rockthevote.phrases.txt',
'addons/sourcemod/translations/tr/slapslay.phrases.txt',
'addons/sourcemod/translations/tr/sounds.phrases.txt',
'addons/sourcemod/translations/tr/sqladmins.phrases.txt',
'addons/sourcemod/translations/ua/adminhelp.phrases.txt',
'addons/sourcemod/translations/ua/adminmenu.phrases.txt',
'addons/sourcemod/translations/ua/antiflood.phrases.txt',
'addons/sourcemod/translations/ua/basebans.phrases.txt',
'addons/sourcemod/translations/ua/basecomm.phrases.txt',
'addons/sourcemod/translations/ua/basetriggers.phrases.txt',
'addons/sourcemod/translations/ua/basevotes.phrases.txt',
'addons/sourcemod/translations/ua/clientprefs.phrases.txt',
'addons/sourcemod/translations/ua/common.phrases.txt',
'addons/sourcemod/translations/ua/core.phrases.txt',
'addons/sourcemod/translations/ua/funcommands.phrases.txt',
'addons/sourcemod/translations/ua/funvotes.phrases.txt',
'addons/sourcemod/translations/ua/mapchooser.phrases.txt',
'addons/sourcemod/translations/ua/nextmap.phrases.txt',
'addons/sourcemod/translations/ua/nominations.phrases.txt',
'addons/sourcemod/translations/ua/playercommands.phrases.txt',
'addons/sourcemod/translations/ua/plugin.basecommands.txt',
'addons/sourcemod/translations/ua/reservedslots.phrases.txt',
'addons/sourcemod/translations/ua/rockthevote.phrases.txt',
'addons/sourcemod/translations/ua/sounds.phrases.txt',
'addons/sourcemod/translations/ua/sqladmins.phrases.txt',
'addons/sourcemod/translations/vi/adminhelp.phrases.txt',
'addons/sourcemod/translations/vi/adminmenu.phrases.txt',
'addons/sourcemod/translations/vi/antiflood.phrases.txt',
'addons/sourcemod/translations/vi/basebans.phrases.txt',
'addons/sourcemod/translations/vi/basecomm.phrases.txt',
'addons/sourcemod/translations/vi/basetriggers.phrases.txt',
'addons/sourcemod/translations/vi/basevotes.phrases.txt',
'addons/sourcemod/translations/vi/clientprefs.phrases.txt',
'addons/sourcemod/translations/vi/common.phrases.txt',
'addons/sourcemod/translations/vi/core.phrases.txt',
'addons/sourcemod/translations/vi/funcommands.phrases.txt',
'addons/sourcemod/translations/vi/funvotes.phrases.txt',
'addons/sourcemod/translations/vi/mapchooser.phrases.txt',
'addons/sourcemod/translations/vi/nextmap.phrases.txt',
'addons/sourcemod/translations/vi/nominations.phrases.txt',
'addons/sourcemod/translations/vi/playercommands.phrases.txt',
'addons/sourcemod/translations/vi/plugin.basecommands.txt',
'addons/sourcemod/translations/vi/reservedslots.phrases.txt',
'addons/sourcemod/translations/vi/rockthevote.phrases.txt',
'addons/sourcemod/translations/vi/sounds.phrases.txt',
'addons/sourcemod/translations/vi/sqladmins.phrases.txt',
'addons/sourcemod/translations/zho/adminhelp.phrases.txt',
'addons/sourcemod/translations/zho/adminmenu.phrases.txt',
'addons/sourcemod/translations/zho/antiflood.phrases.txt',
'addons/sourcemod/translations/zho/basebans.phrases.txt',
'addons/sourcemod/translations/zho/basecomm.phrases.txt',
'addons/sourcemod/translations/zho/basetriggers.phrases.txt',
'addons/sourcemod/translations/zho/basevotes.phrases.txt',
'addons/sourcemod/translations/zho/clientprefs.phrases.txt',
'addons/sourcemod/translations/zho/common.phrases.txt',
'addons/sourcemod/translations/zho/core.phrases.txt',
'addons/sourcemod/translations/zho/funcommands.phrases.txt',
'addons/sourcemod/translations/zho/funvotes.phrases.txt',
'addons/sourcemod/translations/zho/mapchooser.phrases.txt',
'addons/sourcemod/translations/zho/nextmap.phrases.txt',
'addons/sourcemod/translations/zho/nominations.phrases.txt',
'addons/sourcemod/translations/zho/playercommands.phrases.txt',
'addons/sourcemod/translations/zho/plugin.basecommands.txt',
'addons/sourcemod/translations/zho/reservedslots.phrases.txt',
'addons/sourcemod/translations/zho/rockthevote.phrases.txt',
'addons/sourcemod/translations/zho/sounds.phrases.txt',
'addons/sourcemod/translations/zho/sqladmins.phrases.txt',
'cfg/sourcemod/sm_warmode_off.cfg',
'cfg/sourcemod/sm_warmode_on.cfg',
'cfg/sourcemod/sourcemod.cfg',
]